/******/ (() => {
	// webpackBootstrap
	/******/ "use strict";
	/******/ // The require scope
	/******/ var __webpack_require__ = {};
	/******/
	/************************************************************************/
	/******/ /* webpack/runtime/global */
	/******/ (() => {
		/******/ __webpack_require__.g = (function () {
			/******/ if (typeof globalThis === "object") return globalThis;
			/******/ try {
				/******/ return this || new Function("return this")();
				/******/
			} catch (e) {
				/******/ if (typeof window === "object") return window;
				/******/
			}
			/******/
		})();
		/******/
	})();
	/******/
	/************************************************************************/
	var __webpack_exports__ = {}; // CONCATENATED MODULE: ./node_modules/@pixelunion/rimg-shopify/dist/index.es.js

	/*!
	 * @pixelunion/rimg-shopify v2.7.1
	 * (c) 2023 Pixel Union
	 */
	/*!
	 * @pixelunion/rimg v2.2.2
	 * (c) 2022 Pixel Union
	 */

	/**
	 * The default template render function. Turns a template string into an image
	 * URL.
	 *
	 * @param {String} template
	 * @param {Size} size
	 * @returns {String}
	 */
	function defaultTemplateRender(template, size) {
		return template.replace(
			"{size}",
			"".concat(size.width, "x").concat(size.height)
		);
	}
	/**
	 * @type Settings
	 */

	var defaults = {
		scale: 1,
		template: false,
		templateRender: defaultTemplateRender,
		max: {
			width: Infinity,
			height: Infinity,
		},
		round: 32,
		placeholder: false,
		crop: null,
	};
	/**
	 * Get a data attribute value from an element, with a default fallback and
	 * sanitization step.
	 *
	 * @param {Element} el
	 *
	 * @param {String} name
	 *        The data attribute name.
	 *
	 * @param {Object} options
	 *        An object holding fallback values if the data attribute does not
	 *        exist. If this object doesn't have the property, we further fallback
	 *        to our defaults.
	 *
	 * @param {Function} [sanitize]
	 *        A function to sanitize the data attribute value with.
	 *
	 * @returns {String|*}
	 */

	function getData(el, name, options, sanitize) {
		var attr = "data-rimg-".concat(name);
		if (!el.hasAttribute(attr)) return options[name] || defaults[name];
		var value = el.getAttribute(attr);
		return sanitize ? sanitize(value) : value;
	}
	/**
	 * Sanitize data attributes that represent a size (in the form of `10x10`).
	 *
	 * @param {String} value
	 * @returns {Object} An object with `width` and `height` properties.
	 */

	function parseSize(value) {
		value = value.split("x");
		return {
			width: parseInt(value[0], 10),
			height: parseInt(value[1], 10),
		};
	}
	/**
	 * Sanitize crop values to ensure they are valid, or null
	 *
	 * @param {String} value
	 * @returns {Object} Shopify crop parameter ('top', 'center', 'bottom', 'left', 'right') or null, if an unsupported value is found
	 */

	function processCropValue(value) {
		switch (value) {
			case "top":
			case "center":
			case "bottom":
			case "left":
			case "right":
				return value;

			default:
				return null;
		}
	}
	/**
	 * Loads information about an element.
	 *
	 * Options can be set on the element itself using data attributes, or through
	 * the `options` parameter. Data attributes take priority.
	 *
	 * @param {HTMLElement} el
	 * @param {Settings} options
	 * @returns {Item}
	 */

	function parseItem(el) {
		var options =
			arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
		var isImage = el.hasAttribute("data-rimg-template");
		/**
		 * @typedef {Settings} Item
		 */

		return {
			el: el,
			// Type of element
			isImage: isImage,
			isBackgroundImage: isImage && el.tagName !== "IMG",
			// Image scale
			scale: parseInt(getData(el, "scale", options)),
			// Device density
			density: window.devicePixelRatio || 1,
			// Image template URL
			template: getData(el, "template", options),
			templateRender: options.templateRender || defaults.templateRender,
			// Maximum image dimensions
			max: getData(el, "max", options, parseSize),
			// Round image dimensions to the nearest multiple
			round: getData(el, "round", options),
			// Placeholder image dimensions
			placeholder: getData(el, "placeholder", options, parseSize),
			// Crop value; null if image is uncropped, otherwise equal to the Shopify crop parameter ('center', 'top', etc.)
			crop: getData(el, "crop", options, processCropValue),
		};
	}
	/**
	 * Round to the nearest multiple.
	 *
	 * This is so we don't tax the image server too much.
	 *
	 * @param {Number} size The size, in pixels.
	 * @param {Number} [multiple] The multiple to round to the nearest.
	 * @param {Number} [maxLimit] Maximum allowed value - value to return if rounded multiple is above this limit
	 * @returns {Number}
	 */

	function roundSize(size) {
		var multiple =
			arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 32;
		var maxLimit =
			arguments.length > 2 && arguments[2] !== undefined
				? arguments[2]
				: Infinity;
		return size === 0
			? multiple
			: Math.min(Math.ceil(size / multiple) * multiple, maxLimit);
	}
	/**
	 * Get the size of an element.
	 *
	 * If it is too small, it's parent element is checked, and so on. This helps
	 * avoid the situation where an element doesn't have a size yet or is positioned
	 * out of the layout.
	 *
	 * @param {HTMLElement} el
	 * @return {Object} size
	 * @return {Number} size.width The width, in pixels.
	 * @return {Number} size.height The height, in pixels.
	 */

	function getElementSize(el) {
		var size = {
			width: 0,
			height: 0,
		};

		while (el) {
			size.width = el.offsetWidth;
			size.height = el.offsetHeight;
			if (size.width > 20 && size.height > 20) break;
			el = el.parentNode;
		}

		return size;
	}
	/**
	 * Return the maximum supported density of the image, given the container.
	 *
	 * @param {Item} item
	 * @param {Size} size
	 */

	function supportedDensity(item, size) {
		return Math.min(
			Math.min(Math.max(item.max.width / size.width, 1), item.density),
			Math.min(Math.max(item.max.height / size.height, 1), item.density)
		).toFixed(2);
	}
	/**
	 * Trigger a custom event.
	 *
	 * Note: this approach is deprecated, but still required to support older
	 * browsers such as IE 10.
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Creating_and_triggering_events
	 *
	 * @param {HTMLElement} el
	 *        The element to trigger the event on.
	 *
	 * @param {String} name
	 *        The event name.
	 *
	 * @returns {Boolean}
	 *          True if the event was canceled.
	 */

	function trigger(el, name) {
		var event = document.createEvent("Event");
		event.initEvent(name, true, true);
		return !el.dispatchEvent(event);
	}
	/**
	 * Set the image URL on the element. Supports background images and `srcset`.
	 *
	 * @param {Item} item
	 * @param {Size} size
	 * @param {Boolean} isPlaceholder
	 */

	function setImage(item, size, isPlaceholder, onLoad) {
		var render = item.templateRender;
		var density = isPlaceholder ? 1 : supportedDensity(item, size);
		var round = isPlaceholder ? 1 : item.round; // Calculate the final display size, taking into account the image's
		// maximum dimensions.

		var targetWidth = size.width * density;
		var targetHeight = size.height * density;
		var displaySize;

		if (item.crop) {
			displaySize = {
				width: roundSize(targetWidth, round, item.max.width),
				height: roundSize(targetHeight, round, item.max.height),
			};
		} else {
			// Shopify serves images clamped by the requested dimensions (fitted to the smallest dimension).
			// To get the desired and expected pixel density we need to request cover dimensions (fitted to largest dimension).
			// This isn't a problem with cropped images which are served at the exact dimension requested.
			var containerAspectRatio = size.width / size.height;
			var imageAspectRatio = item.max.width / item.max.height;

			if (containerAspectRatio > imageAspectRatio) {
				// fit width
				displaySize = {
					width: roundSize(targetWidth, round, item.max.width),
					height: roundSize(
						targetWidth / imageAspectRatio,
						round,
						item.max.height
					),
				};
			} else {
				// fit height
				displaySize = {
					width: roundSize(
						targetHeight * imageAspectRatio,
						round,
						item.max.width
					),
					height: roundSize(targetHeight, round, item.max.height),
				};
			}
		}

		var url = render(item.template, displaySize); // On load callback

		var image = new Image();
		image.onload = onLoad;
		image.src = url; // Set image

		if (item.isBackgroundImage) {
			item.el.style.backgroundImage = "url('".concat(url, "')");
		} else {
			item.el.setAttribute("srcset", "".concat(url, " ").concat(density, "x"));
		}
	}
	/**
	 * Load the image, set loaded status, and trigger the load event.
	 *
	 * @fires rimg:load
	 * @fires rimg:error
	 * @param {Item} item
	 * @param {Size} size
	 */

	function loadFullImage(item, size) {
		var el = item.el;
		setImage(item, size, false, function (event) {
			if (event.type === "load") {
				el.setAttribute("data-rimg", "loaded");
			} else {
				el.setAttribute("data-rimg", "error");
				trigger(el, "rimg:error");
			}

			trigger(el, "rimg:load");
		});
	}
	/**
	 * Load in a responsive image.
	 *
	 * Sets the image's `srcset` attribute to the final image URLs, calculated based
	 * on the actual size the image is being shown at.
	 *
	 * @fires rimg:loading
	 *        The image URLs have been set and we are waiting for them to load.
	 *
	 * @fires rimg:loaded
	 *        The final image has loaded.
	 *
	 * @fires rimg:error
	 *        The final image failed loading.
	 *
	 * @param {Item} item
	 */

	function loadImage(item) {
		var el = item.el; // Already loaded?

		var status = el.getAttribute("data-rimg");
		if (status === "loading" || status === "loaded") return; // Is the SVG loaded?
		// In Firefox, el.complete always returns true [citation needed, may not be the case anymore, Jan/2022]
		// so we also check el.naturalWidth, which equals 0 until the image loads

		if (!item.isBackgroundImage) {
			if (el.naturalWidth === 0 || !el.complete) {
				// Wait for the load event, then call load image
				el.addEventListener("load", function cb() {
					el.removeEventListener("load", cb);
					loadImage(item);
				});
				return;
			}
		} // Trigger loading event, and stop if cancelled

		if (trigger(el, "rimg:loading")) return; // Mark as loading

		el.setAttribute("data-rimg", "loading"); // Get element size. This is used as the ideal display size.

		var size = getElementSize(item.el);
		size.width *= item.scale;
		size.height *= item.scale;

		if (item.placeholder) {
			// Load a placeholder image first, followed by the full image. Force the
			// element to keep its dimensions while it loads. If the image is smaller
			// than the element size, use the image's size. Density is taken into account
			// for HiDPI devices to avoid blurry images.
			if (!item.isBackgroundImage) {
				el.setAttribute(
					"width",
					Math.min(Math.floor(item.max.width / item.density), size.width)
				);
				el.setAttribute(
					"height",
					Math.min(Math.floor(item.max.height / item.density), size.height)
				);
			}

			setImage(item, item.placeholder, true, function () {
				return loadFullImage(item, size);
			});
		} else {
			loadFullImage(item, size);
		}
	}
	/**
	 * Prepare an element to be displayed on the screen.
	 *
	 * Images have special logic applied to them to swap out the different sources.
	 *
	 * @fires rimg:enter
	 *        The element is entering the viewport.
	 *
	 * @param {HTMLElement} el
	 * @param {Settings} options
	 */

	function load(el, options) {
		if (!el) return;
		trigger(el, "rimg:enter");
		var item = parseItem(el, options);

		if (item.isImage) {
			if (!item.isBackgroundImage) {
				el.setAttribute("data-rimg-template-svg", el.getAttribute("srcset"));
			}

			loadImage(item);
		}
	}
	/**
	 * Reset an element's state so that its image can be recalculated.
	 *
	 * @fires rimg:update
	 *        The element is being updated.
	 *
	 * @param {HTMLElement} el
	 * @param {Settings} options
	 */

	function update(el, options) {
		if (!el) return;
		trigger(el, "rimg:update");
		var item = parseItem(el, options);

		if (item.isImage) {
			if (!item.isBackgroundImage) {
				el.setAttribute("data-rimg", "lazy");
				el.setAttribute("srcset", el.getAttribute("data-rimg-template-svg"));
			}

			loadImage(item);
		}
	}
	/**
	 * Returns true if the element is within the viewport.
	 * @param {HTMLElement} el
	 * @returns {Boolean}
	 */

	function inViewport(el) {
		if (!el.offsetWidth || !el.offsetHeight || !el.getClientRects().length) {
			return false;
		}

		var root = document.documentElement;
		var width = Math.min(root.clientWidth, window.innerWidth);
		var height = Math.min(root.clientHeight, window.innerHeight);
		var rect = el.getBoundingClientRect();
		return (
			rect.bottom >= 0 &&
			rect.right >= 0 &&
			rect.top <= height &&
			rect.left <= width
		);
	}
	/**
	 * @typedef {Object} Size
	 * @property {Number} width
	 * @property {Number} height
	 */

	/**
	 * A function to turn a template string into a URL.
	 *
	 * @callback TemplateRenderer
	 * @param {String} template
	 * @param {Size} size
	 * @returns {String}
	 */

	/**
	 * @typedef {Object} Settings
	 *
	 * @property {String} [template]
	 *           A template string used to generate URLs for an image. This allows us to
	 *           dynamically load images with sizes to match the container's size.
	 *
	 * @property {TemplateRenderer} [templateRender]
	 *           A function to turn a template string into a URL.
	 *
	 * @property {Size} [max]
	 *           The maximum available size for the image. This ensures we don't
	 *           try to load an image larger than is possible.
	 *
	 * @property {Number} [scale]
	 *           A number to scale the final image dimensions by.
	 *           Only applies to lazy-loaded images. Defaults to 1.
	 *
	 * @property {Number} [round]
	 *           Round image dimensions to the nearest multiple. This is intended to
	 *           tax the image server less by lowering the number of possible image
	 *           sizes requested.
	 *
	 * @property {Size} [placeholder]
	 *           The size of the lo-fi image to load before the full image.
	 *
	 * @property {String} [crop]
	 *           Crop value; null if image is uncropped, otherwise equal
	 *           to the Shopify crop parameter ('center', 'top', etc.).
	 */

	/**
	 * Initialize the responsive image handler.
	 *
	 * @param {String|HTMLElement|NodeList} selector
	 *        The CSS selector, element, or elements to track for lazy-loading.
	 *
	 * @param {Settings} options
	 *
	 * @returns {PublicApi}
	 */

	function rimg() {
		var selector =
			arguments.length > 0 && arguments[0] !== undefined
				? arguments[0]
				: '[data-rimg="lazy"]';
		var options =
			arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}; // Intersections

		var io = new IntersectionObserver(
			function (entries) {
				entries.forEach(function (entry) {
					if (entry.isIntersecting || entry.intersectionRatio > 0) {
						io.unobserve(entry.target);
						load(entry.target, options);
					}
				});
			},
			{
				// Watch the viewport, with 20% vertical margins
				rootMargin: "20% 0px",
			}
		);
		/**
		 * @typedef {Object} PublicApi
		 */

		var api = {
			/**
			 * Track a new selector, element, or nodelist for lazy-loading.
			 * @type Function
			 * @param {String|HTMLElement|NodeList} selector
			 */
			track: function track() {
				var selector =
					arguments.length > 0 && arguments[0] !== undefined
						? arguments[0]
						: '[data-rimg="lazy"]';
				var els = querySelector(selector);

				for (var i = 0; i < els.length; i++) {
					// If an element is already in the viewport, load it right away. This
					// fixes a race-condition with dynamically added elements.
					if (inViewport(els[i])) {
						load(els[i], options);
					} else {
						io.observe(els[i]);
					}
				}
			},

			/**
			 * Update element(s) that have already been loaded to force their images
			 * to be recalculated.
			 * @type Function
			 * @param {String|HTMLElement|NodeList} selector
			 */
			update: function update$1() {
				var selector =
					arguments.length > 0 && arguments[0] !== undefined
						? arguments[0]
						: '[data-rimg="loaded"]';
				var els = querySelector(selector);

				for (var i = 0; i < els.length; i++) {
					update(els[i], options);
				}
			},

			/**
			 * Stop tracking element(s) for lazy-loading.
			 * @type Function
			 * @param {String|HTMLElement|NodeList} selector
			 */
			untrack: function untrack() {
				var selector =
					arguments.length > 0 && arguments[0] !== undefined
						? arguments[0]
						: "[data-rimg]";
				var els = querySelector(selector);

				for (var i = 0; i < els.length; i++) {
					io.unobserve(els[i]);
				}
			},

			/**
			 * Manually load images.
			 * @type Function
			 * @param {String|HTMLElement|NodeList} selector
			 */
			load: function load$1() {
				var selector =
					arguments.length > 0 && arguments[0] !== undefined
						? arguments[0]
						: "[data-rimg]";
				var els = querySelector(selector);

				for (var i = 0; i < els.length; i++) {
					load(els[i], options);
				}
			},

			/**
			 * Unload all event handlers and observers.
			 * @type Function
			 */
			unload: function unload() {
				io.disconnect();
			},
		}; // Add initial elements

		api.track(selector);
		return api;
	}
	/**
	 * Finds a group of elements on the page.
	 *
	 * @param {String|HTMLElement|NodeList} selector
	 * @returns {Object} An array-like object.
	 */

	function querySelector(selector) {
		if (typeof selector === "string") {
			return document.querySelectorAll(selector);
		}

		if (selector instanceof HTMLElement) {
			return [selector];
		}

		if (selector instanceof NodeList) {
			return selector;
		}

		return [];
	}

	/**
	 * Polyfill for Element.matches().
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/matches
	 */
	if (!Element.prototype.matches) {
		Element.prototype.matches =
			Element.prototype.matchesSelector ||
			Element.prototype.mozMatchesSelector ||
			Element.prototype.msMatchesSelector ||
			Element.prototype.oMatchesSelector ||
			Element.prototype.webkitMatchesSelector ||
			function (s) {
				var matches = (this.document || this.ownerDocument).querySelectorAll(s),
					i = matches.length;

				while (--i >= 0 && matches.item(i) !== this) {}

				return i > -1;
			};
	}

	var state = {
		init: init,
		watch: watch,
		unwatch: unwatch,
		load: load$1,
	};

	function init() {
		var selector =
			arguments.length > 0 && arguments[0] !== undefined
				? arguments[0]
				: '[data-rimg="lazy"]';
		var options =
			arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
		state.selector = selector;
		state.instance = rimg(selector, options);
		state.loadedWidth = Math.max(
			document.documentElement.clientWidth,
			window.innerWidth || 0
		); // Listen for Shopify theme editor events

		document.addEventListener("shopify:section:load", function (event) {
			return watch(event.target);
		});
		window.addEventListener("resize", function () {
			return _update();
		});
		document.addEventListener("shopify:section:unload", function (event) {
			return unwatch(event.target);
		}); // Listen for custom events to allow themes to hook into rimg

		document.addEventListener("theme:rimg:watch", function (event) {
			return watch(event.target);
		});
		document.addEventListener("theme:rimg:unwatch", function (event) {
			return unwatch(event.target);
		}); // Support custom events triggered through jQuery
		// See: https://github.com/jquery/jquery/issues/3347

		if (window.jQuery) {
			jQuery(document).on({
				"theme:rimg:watch": function themeRimgWatch(event) {
					return watch(event.target);
				},
				"theme:rimg:unwatch": function themeRimgUnwatch(event) {
					return unwatch(event.target);
				},
			});
		}
	}
	/**
	 * Track an element, and its children.
	 *
	 * @param {HTMLElement} el
	 */

	function watch(el) {
		// Track element
		if (typeof el.matches === "function" && el.matches(state.selector)) {
			state.instance.track(el);
		} // Track element's children

		state.instance.track(el.querySelectorAll(state.selector));
	}
	/**
	 * Untrack an element, and its children
	 *
	 * @param {HTMLElement} el
	 * @private
	 */

	function unwatch(el) {
		// Untrack element's children
		state.instance.untrack(el.querySelectorAll(state.selector)); // Untrack element

		if (typeof el.matches === "function" && el.matches(state.selector)) {
			state.instance.untrack(el);
		}
	}
	/**
	 * Manually load an image
	 *
	 * @param {HTMLElement} el
	 */

	function load$1(el) {
		// Load element
		if (typeof el.matches === "function" && el.matches(state.selector)) {
			state.instance.load(el);
		} // Load element's children

		state.instance.load(el.querySelectorAll(state.selector));
	}
	/**
	 * Update an element, and its children.
	 *
	 * @param {HTMLElement} el
	 */

	function _update() {
		var currentWidth = Math.max(
			document.documentElement.clientWidth,
			window.innerWidth || 0
		); // Return if we're not 2x smaller, or larger than the existing loading size

		if (
			currentWidth / state.loadedWidth > 0.5 &&
			currentWidth / state.loadedWidth < 2
		) {
			return;
		}

		state.loadedWidth = currentWidth;
		state.instance.update();
	}

	/* harmony default export */ const index_es = state; // CONCATENATED MODULE: ./node_modules/@pixelunion/pxs-complementary-products/dist/index.es.js

	/*!
	 * @pixelunion/pxs-complementary-products v3.5.3
	 * (c) 2022 Pixel Union
	 */

	function _typeof(obj) {
		"@babel/helpers - typeof";

		return (
			(_typeof =
				"function" == typeof Symbol && "symbol" == typeof Symbol.iterator
					? function (obj) {
							return typeof obj;
					  }
					: function (obj) {
							return obj &&
								"function" == typeof Symbol &&
								obj.constructor === Symbol &&
								obj !== Symbol.prototype
								? "symbol"
								: typeof obj;
					  }),
			_typeof(obj)
		);
	}

	function _classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}

	function _defineProperties(target, props) {
		for (var i = 0; i < props.length; i++) {
			var descriptor = props[i];
			descriptor.enumerable = descriptor.enumerable || false;
			descriptor.configurable = true;
			if ("value" in descriptor) descriptor.writable = true;
			Object.defineProperty(target, descriptor.key, descriptor);
		}
	}

	function _createClass(Constructor, protoProps, staticProps) {
		if (protoProps) _defineProperties(Constructor.prototype, protoProps);
		if (staticProps) _defineProperties(Constructor, staticProps);
		Object.defineProperty(Constructor, "prototype", {
			writable: false,
		});
		return Constructor;
	}

	var commonjsGlobal =
		typeof globalThis !== "undefined"
			? globalThis
			: typeof window !== "undefined"
			? window
			: typeof __webpack_require__.g !== "undefined"
			? __webpack_require__.g
			: typeof self !== "undefined"
			? self
			: {};

	function unwrapExports(x) {
		return x &&
			x.__esModule &&
			Object.prototype.hasOwnProperty.call(x, "default")
			? x["default"]
			: x;
	}

	function createCommonjsModule(fn, module) {
		return (
			(module = { exports: {} }), fn(module, module.exports), module.exports
		);
	}

	var EventHandler_1 = createCommonjsModule(function (module, exports) {
		exports.__esModule = true;
		var EventHandler = /** @class */ (function () {
			function EventHandler() {
				this.events = [];
			}
			EventHandler.prototype.register = function (el, event, listener) {
				if (!el || !event || !listener) return null;
				this.events.push({ el: el, event: event, listener: listener });
				el.addEventListener(event, listener);
				return { el: el, event: event, listener: listener };
			};
			EventHandler.prototype.unregister = function (_a) {
				var el = _a.el,
					event = _a.event,
					listener = _a.listener;
				if (!el || !event || !listener) return null;
				this.events = this.events.filter(function (e) {
					return el !== e.el || event !== e.event || listener !== e.listener;
				});
				el.removeEventListener(event, listener);
				return { el: el, event: event, listener: listener };
			};
			EventHandler.prototype.unregisterAll = function () {
				this.events.forEach(function (_a) {
					var el = _a.el,
						event = _a.event,
						listener = _a.listener;
					return el.removeEventListener(event, listener);
				});
				this.events = [];
			};
			return EventHandler;
		})();
		exports["default"] = EventHandler;
	});

	var EventHandler = unwrapExports(EventHandler_1);

	/*!
	 * @pixelunion/shopify-asyncview v2.0.5
	 * (c) 2020 Pixel Union
	 */

	function _classCallCheck$1(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}

	function _defineProperties$1(target, props) {
		for (var i = 0; i < props.length; i++) {
			var descriptor = props[i];
			descriptor.enumerable = descriptor.enumerable || false;
			descriptor.configurable = true;
			if ("value" in descriptor) descriptor.writable = true;
			Object.defineProperty(target, descriptor.key, descriptor);
		}
	}

	function _createClass$1(Constructor, protoProps, staticProps) {
		if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
		if (staticProps) _defineProperties$1(Constructor, staticProps);
		return Constructor;
	}

	function _defineProperty(obj, key, value) {
		if (key in obj) {
			Object.defineProperty(obj, key, {
				value: value,
				enumerable: true,
				configurable: true,
				writable: true,
			});
		} else {
			obj[key] = value;
		}

		return obj;
	}

	function ownKeys(object, enumerableOnly) {
		var keys = Object.keys(object);

		if (Object.getOwnPropertySymbols) {
			var symbols = Object.getOwnPropertySymbols(object);
			if (enumerableOnly)
				symbols = symbols.filter(function (sym) {
					return Object.getOwnPropertyDescriptor(object, sym).enumerable;
				});
			keys.push.apply(keys, symbols);
		}

		return keys;
	}

	function _objectSpread2(target) {
		for (var i = 1; i < arguments.length; i++) {
			var source = arguments[i] != null ? arguments[i] : {};

			if (i % 2) {
				ownKeys(Object(source), true).forEach(function (key) {
					_defineProperty(target, key, source[key]);
				});
			} else if (Object.getOwnPropertyDescriptors) {
				Object.defineProperties(
					target,
					Object.getOwnPropertyDescriptors(source)
				);
			} else {
				ownKeys(Object(source)).forEach(function (key) {
					Object.defineProperty(
						target,
						key,
						Object.getOwnPropertyDescriptor(source, key)
					);
				});
			}
		}

		return target;
	}

	function _slicedToArray(arr, i) {
		return (
			_arrayWithHoles(arr) ||
			_iterableToArrayLimit(arr, i) ||
			_unsupportedIterableToArray(arr, i) ||
			_nonIterableRest()
		);
	}

	function _arrayWithHoles(arr) {
		if (Array.isArray(arr)) return arr;
	}

	function _iterableToArrayLimit(arr, i) {
		if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr)))
			return;
		var _arr = [];
		var _n = true;
		var _d = false;
		var _e = undefined;

		try {
			for (
				var _i = arr[Symbol.iterator](), _s;
				!(_n = (_s = _i.next()).done);
				_n = true
			) {
				_arr.push(_s.value);

				if (i && _arr.length === i) break;
			}
		} catch (err) {
			_d = true;
			_e = err;
		} finally {
			try {
				if (!_n && _i["return"] != null) _i["return"]();
			} finally {
				if (_d) throw _e;
			}
		}

		return _arr;
	}

	function _unsupportedIterableToArray(o, minLen) {
		if (!o) return;
		if (typeof o === "string") return _arrayLikeToArray(o, minLen);
		var n = Object.prototype.toString.call(o).slice(8, -1);
		if (n === "Object" && o.constructor) n = o.constructor.name;
		if (n === "Map" || n === "Set") return Array.from(n);
		if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
			return _arrayLikeToArray(o, minLen);
	}

	function _arrayLikeToArray(arr, len) {
		if (len == null || len > arr.length) len = arr.length;

		for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

		return arr2;
	}

	function _nonIterableRest() {
		throw new TypeError(
			"Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
		);
	}

	var deferred = {};

	var AsyncView = /*#__PURE__*/ (function () {
		function AsyncView() {
			_classCallCheck$1(this, AsyncView);
		}

		_createClass$1(AsyncView, null, [
			{
				key: "load",

				/**
				 * Load the template given by the provided URL into the provided
				 * view
				 *
				 * @param {string} url - The url to load
				 * @param {object} query - An object containing additional query parameters of the URL
				 * @param {string} query.view - A required query parameter indicating which view to load
				 * @param {object} [options] - Config options
				 * @param {string} [options.hash] - A hash of the current page content
				 */
				value: function load(url) {
					var query =
						arguments.length > 1 && arguments[1] !== undefined
							? arguments[1]
							: {};
					var options =
						arguments.length > 2 && arguments[2] !== undefined
							? arguments[2]
							: {};

					if (!("view" in query)) {
						return Promise.reject(
							new Error("'view' not found in 'query' parameter")
						);
					}

					var querylessUrl = url.replace(/\?[^#]+/, "");
					var queryParamsString = new RegExp(/.+\?([^#]+)/).exec(url);
					var queryParams = query;

					if (queryParamsString && queryParamsString.length >= 2) {
						queryParamsString[1].split("&").forEach(function (param) {
							var _param$split = param.split("="),
								_param$split2 = _slicedToArray(_param$split, 2),
								key = _param$split2[0],
								value = _param$split2[1];

							queryParams[key] = value;
						});
					} // NOTE: We're adding an additional timestamp to the query.
					// This is to prevent certain browsers from returning cached
					// versions of the url we are requesting.
					// See this PR for more info: https://github.com/pixelunion/shopify-asyncview/pull/4

					var cachebustingParams = _objectSpread2({}, queryParams, {
						_: new Date().getTime(),
					});

					var hashUrl = querylessUrl.replace(
						/([^#]+)(.*)/,
						function (match, address, hash) {
							return ""
								.concat(address, "?")
								.concat(
									Object.keys(queryParams)
										.sort()
										.map(function (key) {
											return ""
												.concat(key, "=")
												.concat(encodeURIComponent(queryParams[key]));
										})
										.join("&")
								)
								.concat(hash);
						}
					);
					var requestUrl = querylessUrl.replace(
						/([^#]+)(.*)/,
						function (match, address, hash) {
							return ""
								.concat(address, "?")
								.concat(
									Object.keys(cachebustingParams)
										.sort()
										.map(function (key) {
											return ""
												.concat(key, "=")
												.concat(encodeURIComponent(cachebustingParams[key]));
										})
										.join("&")
								)
								.concat(hash);
						}
					);
					var promise = new Promise(function (resolve, reject) {
						var data;

						if (hashUrl in deferred) {
							resolve(deferred[hashUrl]);
							return;
						}

						deferred[hashUrl] = promise;

						if (options.hash) {
							data = sessionStorage.getItem(hashUrl);

							if (data) {
								var deserialized = JSON.parse(data);

								if (options.hash === deserialized.options.hash) {
									delete deferred[hashUrl];
									resolve(deserialized);
									return;
								}
							}
						}

						var xhr = new XMLHttpRequest();
						xhr.open("GET", requestUrl, true);

						xhr.onload = function () {
							var el = xhr.response;
							var newOptions = {};
							var optionsEl = el.querySelector("[data-options]");

							if (optionsEl && optionsEl.innerHTML) {
								newOptions = JSON.parse(
									el.querySelector("[data-options]").innerHTML
								);
							}

							var htmlEls = el.querySelectorAll("[data-html]");
							var newHtml = {};

							if (
								htmlEls.length === 1 &&
								htmlEls[0].getAttribute("data-html") === ""
							) {
								newHtml = htmlEls[0].innerHTML;
							} else {
								for (var i = 0; i < htmlEls.length; i++) {
									newHtml[htmlEls[i].getAttribute("data-html")] =
										htmlEls[i].innerHTML;
								}
							}

							var dataEls = el.querySelectorAll("[data-data]");
							var newData = {};

							if (
								dataEls.length === 1 &&
								dataEls[0].getAttribute("data-data") === ""
							) {
								newData = JSON.parse(dataEls[0].innerHTML);
							} else {
								for (var _i = 0; _i < dataEls.length; _i++) {
									newData[dataEls[_i].getAttribute("data-data")] = JSON.parse(
										dataEls[_i].innerHTML
									);
								}
							}

							if (options.hash) {
								try {
									sessionStorage.setItem(
										hashUrl,
										JSON.stringify({
											options: newOptions,
											data: newData,
											html: newHtml,
										})
									);
								} catch (error) {
									console.error(error);
								}
							}

							delete deferred[hashUrl];
							resolve({
								data: newData,
								html: newHtml,
							});
						};

						xhr.onerror = function () {
							delete deferred[hashUrl];
							reject();
						};

						xhr.responseType = "document";
						xhr.send();
					});
					return promise;
				},
			},
		]);

		return AsyncView;
	})();

	var evEmitter = createCommonjsModule(function (module) {
		/**
		 * EvEmitter v1.1.0
		 * Lil' event emitter
		 * MIT License
		 */

		/* jshint unused: true, undef: true, strict: true */

		(function (global, factory) {
			// universal module definition
			/* jshint strict: false */ /* globals define, module, window */ if (
				module.exports
			) {
				// CommonJS - Browserify, Webpack
				module.exports = factory();
			} else {
				// Browser globals
				global.EvEmitter = factory();
			}
		})(typeof window != "undefined" ? window : commonjsGlobal, function () {
			function EvEmitter() {}

			var proto = EvEmitter.prototype;

			proto.on = function (eventName, listener) {
				if (!eventName || !listener) {
					return;
				}
				// set events hash
				var events = (this._events = this._events || {});
				// set listeners array
				var listeners = (events[eventName] = events[eventName] || []);
				// only add once
				if (listeners.indexOf(listener) == -1) {
					listeners.push(listener);
				}

				return this;
			};

			proto.once = function (eventName, listener) {
				if (!eventName || !listener) {
					return;
				}
				// add event
				this.on(eventName, listener);
				// set once flag
				// set onceEvents hash
				var onceEvents = (this._onceEvents = this._onceEvents || {});
				// set onceListeners object
				var onceListeners = (onceEvents[eventName] =
					onceEvents[eventName] || {});
				// set flag
				onceListeners[listener] = true;

				return this;
			};

			proto.off = function (eventName, listener) {
				var listeners = this._events && this._events[eventName];
				if (!listeners || !listeners.length) {
					return;
				}
				var index = listeners.indexOf(listener);
				if (index != -1) {
					listeners.splice(index, 1);
				}

				return this;
			};

			proto.emitEvent = function (eventName, args) {
				var listeners = this._events && this._events[eventName];
				if (!listeners || !listeners.length) {
					return;
				}
				// copy over to avoid interference if .off() in listener
				listeners = listeners.slice(0);
				args = args || [];
				// once stuff
				var onceListeners = this._onceEvents && this._onceEvents[eventName];

				for (var i = 0; i < listeners.length; i++) {
					var listener = listeners[i];
					var isOnce = onceListeners && onceListeners[listener];
					if (isOnce) {
						// remove listener
						// remove before trigger to prevent recursion
						this.off(eventName, listener);
						// unset once flag
						delete onceListeners[listener];
					}
					// trigger listener
					listener.apply(this, args);
				}

				return this;
			};

			proto.allOff = function () {
				delete this._events;
				delete this._onceEvents;
			};

			return EvEmitter;
		});
	});

	var getSize = createCommonjsModule(function (module) {
		/*!
		 * getSize v2.0.3
		 * measure size of elements
		 * MIT license
		 */

		/* jshint browser: true, strict: true, undef: true, unused: true */
		/* globals console: false */

		(function (window, factory) {
			/* jshint strict: false */ /* globals define, module */ if (
				module.exports
			) {
				// CommonJS
				module.exports = factory();
			} else {
				// browser global
				window.getSize = factory();
			}
		})(window, function factory() {
			// -------------------------- helpers -------------------------- //

			// get a number from a string, not a percentage
			function getStyleSize(value) {
				var num = parseFloat(value);
				// not a percent like '100%', and a number
				var isValid = value.indexOf("%") == -1 && !isNaN(num);
				return isValid && num;
			}

			function noop() {}

			var logError =
				typeof console == "undefined"
					? noop
					: function (message) {
							console.error(message);
					  };

			// -------------------------- measurements -------------------------- //

			var measurements = [
				"paddingLeft",
				"paddingRight",
				"paddingTop",
				"paddingBottom",
				"marginLeft",
				"marginRight",
				"marginTop",
				"marginBottom",
				"borderLeftWidth",
				"borderRightWidth",
				"borderTopWidth",
				"borderBottomWidth",
			];

			var measurementsLength = measurements.length;

			function getZeroSize() {
				var size = {
					width: 0,
					height: 0,
					innerWidth: 0,
					innerHeight: 0,
					outerWidth: 0,
					outerHeight: 0,
				};
				for (var i = 0; i < measurementsLength; i++) {
					var measurement = measurements[i];
					size[measurement] = 0;
				}
				return size;
			}

			// -------------------------- getStyle -------------------------- //

			/**
			 * getStyle, get style of element, check for Firefox bug
			 * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
			 */
			function getStyle(elem) {
				var style = getComputedStyle(elem);
				if (!style) {
					logError(
						"Style returned " +
							style +
							". Are you running this code in a hidden iframe on Firefox? " +
							"See https://bit.ly/getsizebug1"
					);
				}
				return style;
			}

			// -------------------------- setup -------------------------- //

			var isSetup = false;

			var isBoxSizeOuter;

			/**
			 * setup
			 * check isBoxSizerOuter
			 * do on first getSize() rather than on page load for Firefox bug
			 */
			function setup() {
				// setup once
				if (isSetup) {
					return;
				}
				isSetup = true;

				// -------------------------- box sizing -------------------------- //

				/**
				 * Chrome & Safari measure the outer-width on style.width on border-box elems
				 * IE11 & Firefox<29 measures the inner-width
				 */
				var div = document.createElement("div");
				div.style.width = "200px";
				div.style.padding = "1px 2px 3px 4px";
				div.style.borderStyle = "solid";
				div.style.borderWidth = "1px 2px 3px 4px";
				div.style.boxSizing = "border-box";

				var body = document.body || document.documentElement;
				body.appendChild(div);
				var style = getStyle(div);
				// round value for browser zoom. desandro/masonry#928
				isBoxSizeOuter = Math.round(getStyleSize(style.width)) == 200;
				getSize.isBoxSizeOuter = isBoxSizeOuter;

				body.removeChild(div);
			}

			// -------------------------- getSize -------------------------- //

			function getSize(elem) {
				setup();

				// use querySeletor if elem is string
				if (typeof elem == "string") {
					elem = document.querySelector(elem);
				}

				// do not proceed on non-objects
				if (!elem || typeof elem != "object" || !elem.nodeType) {
					return;
				}

				var style = getStyle(elem);

				// if hidden, everything is 0
				if (style.display == "none") {
					return getZeroSize();
				}

				var size = {};
				size.width = elem.offsetWidth;
				size.height = elem.offsetHeight;

				var isBorderBox = (size.isBorderBox = style.boxSizing == "border-box");

				// get all measurements
				for (var i = 0; i < measurementsLength; i++) {
					var measurement = measurements[i];
					var value = style[measurement];
					var num = parseFloat(value);
					// any 'auto', 'medium' value will be 0
					size[measurement] = !isNaN(num) ? num : 0;
				}

				var paddingWidth = size.paddingLeft + size.paddingRight;
				var paddingHeight = size.paddingTop + size.paddingBottom;
				var marginWidth = size.marginLeft + size.marginRight;
				var marginHeight = size.marginTop + size.marginBottom;
				var borderWidth = size.borderLeftWidth + size.borderRightWidth;
				var borderHeight = size.borderTopWidth + size.borderBottomWidth;

				var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;

				// overwrite width and height if we can get it from style
				var styleWidth = getStyleSize(style.width);
				if (styleWidth !== false) {
					size.width =
						styleWidth +
						// add padding and border unless it's already including it
						(isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth);
				}

				var styleHeight = getStyleSize(style.height);
				if (styleHeight !== false) {
					size.height =
						styleHeight +
						// add padding and border unless it's already including it
						(isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight);
				}

				size.innerWidth = size.width - (paddingWidth + borderWidth);
				size.innerHeight = size.height - (paddingHeight + borderHeight);

				size.outerWidth = size.width + marginWidth;
				size.outerHeight = size.height + marginHeight;

				return size;
			}

			return getSize;
		});
	});

	var matchesSelector = createCommonjsModule(function (module) {
		/**
		 * matchesSelector v2.0.2
		 * matchesSelector( element, '.selector' )
		 * MIT license
		 */

		/*jshint browser: true, strict: true, undef: true, unused: true */

		(function (window, factory) {
			// universal module definition
			if (module.exports) {
				// CommonJS
				module.exports = factory();
			} else {
				// browser global
				window.matchesSelector = factory();
			}
		})(window, function factory() {
			var matchesMethod = (function () {
				var ElemProto = window.Element.prototype;
				// check for the standard method name first
				if (ElemProto.matches) {
					return "matches";
				}
				// check un-prefixed
				if (ElemProto.matchesSelector) {
					return "matchesSelector";
				}
				// check vendor prefixes
				var prefixes = ["webkit", "moz", "ms", "o"];

				for (var i = 0; i < prefixes.length; i++) {
					var prefix = prefixes[i];
					var method = prefix + "MatchesSelector";
					if (ElemProto[method]) {
						return method;
					}
				}
			})();

			return function matchesSelector(elem, selector) {
				return elem[matchesMethod](selector);
			};
		});
	});

	var utils = createCommonjsModule(function (module) {
		/**
		 * Fizzy UI utils v2.0.7
		 * MIT license
		 */

		/*jshint browser: true, undef: true, unused: true, strict: true */

		(function (window, factory) {
			// universal module definition
			/*jshint strict: false */ /*globals define, module, require */ if (
				module.exports
			) {
				// CommonJS
				module.exports = factory(window, matchesSelector);
			} else {
				// browser global
				window.fizzyUIUtils = factory(window, window.matchesSelector);
			}
		})(window, function factory(window, matchesSelector) {
			var utils = {};

			// ----- extend ----- //

			// extends objects
			utils.extend = function (a, b) {
				for (var prop in b) {
					a[prop] = b[prop];
				}
				return a;
			};

			// ----- modulo ----- //

			utils.modulo = function (num, div) {
				return ((num % div) + div) % div;
			};

			// ----- makeArray ----- //

			var arraySlice = Array.prototype.slice;

			// turn element or nodeList into an array
			utils.makeArray = function (obj) {
				if (Array.isArray(obj)) {
					// use object if already an array
					return obj;
				}
				// return empty array if undefined or null. #6
				if (obj === null || obj === undefined) {
					return [];
				}

				var isArrayLike =
					typeof obj == "object" && typeof obj.length == "number";
				if (isArrayLike) {
					// convert nodeList to array
					return arraySlice.call(obj);
				}

				// array of single index
				return [obj];
			};

			// ----- removeFrom ----- //

			utils.removeFrom = function (ary, obj) {
				var index = ary.indexOf(obj);
				if (index != -1) {
					ary.splice(index, 1);
				}
			};

			// ----- getParent ----- //

			utils.getParent = function (elem, selector) {
				while (elem.parentNode && elem != document.body) {
					elem = elem.parentNode;
					if (matchesSelector(elem, selector)) {
						return elem;
					}
				}
			};

			// ----- getQueryElement ----- //

			// use element as selector string
			utils.getQueryElement = function (elem) {
				if (typeof elem == "string") {
					return document.querySelector(elem);
				}
				return elem;
			};

			// ----- handleEvent ----- //

			// enable .ontype to trigger from .addEventListener( elem, 'type' )
			utils.handleEvent = function (event) {
				var method = "on" + event.type;
				if (this[method]) {
					this[method](event);
				}
			};

			// ----- filterFindElements ----- //

			utils.filterFindElements = function (elems, selector) {
				// make array of elems
				elems = utils.makeArray(elems);
				var ffElems = [];

				elems.forEach(function (elem) {
					// check that elem is an actual element
					if (!(elem instanceof HTMLElement)) {
						return;
					}
					// add elem if no selector
					if (!selector) {
						ffElems.push(elem);
						return;
					}
					// filter & find items if we have a selector
					// filter
					if (matchesSelector(elem, selector)) {
						ffElems.push(elem);
					}
					// find children
					var childElems = elem.querySelectorAll(selector);
					// concat childElems to filterFound array
					for (var i = 0; i < childElems.length; i++) {
						ffElems.push(childElems[i]);
					}
				});

				return ffElems;
			};

			// ----- debounceMethod ----- //

			utils.debounceMethod = function (_class, methodName, threshold) {
				threshold = threshold || 100;
				// original method
				var method = _class.prototype[methodName];
				var timeoutName = methodName + "Timeout";

				_class.prototype[methodName] = function () {
					var timeout = this[timeoutName];
					clearTimeout(timeout);

					var args = arguments;
					var _this = this;
					this[timeoutName] = setTimeout(function () {
						method.apply(_this, args);
						delete _this[timeoutName];
					}, threshold);
				};
			};

			// ----- docReady ----- //

			utils.docReady = function (callback) {
				var readyState = document.readyState;
				if (readyState == "complete" || readyState == "interactive") {
					// do async to allow for other scripts to run. metafizzy/flickity#441
					setTimeout(callback);
				} else {
					document.addEventListener("DOMContentLoaded", callback);
				}
			};

			// ----- htmlInit ----- //

			// http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
			utils.toDashed = function (str) {
				return str
					.replace(/(.)([A-Z])/g, function (match, $1, $2) {
						return $1 + "-" + $2;
					})
					.toLowerCase();
			};

			var console = window.console;
			/**
			 * allow user to initialize classes via [data-namespace] or .js-namespace class
			 * htmlInit( Widget, 'widgetName' )
			 * options are parsed from data-namespace-options
			 */
			utils.htmlInit = function (WidgetClass, namespace) {
				utils.docReady(function () {
					var dashedNamespace = utils.toDashed(namespace);
					var dataAttr = "data-" + dashedNamespace;
					var dataAttrElems = document.querySelectorAll("[" + dataAttr + "]");
					var jsDashElems = document.querySelectorAll(".js-" + dashedNamespace);
					var elems = utils
						.makeArray(dataAttrElems)
						.concat(utils.makeArray(jsDashElems));
					var dataOptionsAttr = dataAttr + "-options";
					var jQuery = window.jQuery;

					elems.forEach(function (elem) {
						var attr =
							elem.getAttribute(dataAttr) || elem.getAttribute(dataOptionsAttr);
						var options;
						try {
							options = attr && JSON.parse(attr);
						} catch (error) {
							// log error, do not initialize
							if (console) {
								console.error(
									"Error parsing " +
										dataAttr +
										" on " +
										elem.className +
										": " +
										error
								);
							}
							return;
						}
						// initialize
						var instance = new WidgetClass(elem, options);
						// make available via $().data('namespace')
						if (jQuery) {
							jQuery.data(elem, namespace, instance);
						}
					});
				});
			};

			// -----  ----- //

			return utils;
		});
	});

	var cell = createCommonjsModule(function (module) {
		// Flickity.Cell
		(function (window, factory) {
			// universal module definition
			if (module.exports) {
				// CommonJS
				module.exports = factory(window, getSize);
			} else {
				// browser global
				window.Flickity = window.Flickity || {};
				window.Flickity.Cell = factory(window, window.getSize);
			}
		})(window, function factory(window, getSize) {
			function Cell(elem, parent) {
				this.element = elem;
				this.parent = parent;

				this.create();
			}

			var proto = Cell.prototype;

			proto.create = function () {
				this.element.style.position = "absolute";
				this.element.setAttribute("aria-hidden", "true");
				this.x = 0;
				this.shift = 0;
				this.element.style[this.parent.originSide] = 0;
			};

			proto.destroy = function () {
				// reset style
				this.unselect();
				this.element.style.position = "";
				var side = this.parent.originSide;
				this.element.style[side] = "";
				this.element.style.transform = "";
				this.element.removeAttribute("aria-hidden");
			};

			proto.getSize = function () {
				this.size = getSize(this.element);
			};

			proto.setPosition = function (x) {
				this.x = x;
				this.updateTarget();
				this.renderPosition(x);
			};

			// setDefaultTarget v1 method, backwards compatibility, remove in v3
			proto.updateTarget = proto.setDefaultTarget = function () {
				var marginProperty =
					this.parent.originSide == "left" ? "marginLeft" : "marginRight";
				this.target =
					this.x +
					this.size[marginProperty] +
					this.size.width * this.parent.cellAlign;
			};

			proto.renderPosition = function (x) {
				// render position of cell with in slider
				var sideOffset = this.parent.originSide === "left" ? 1 : -1;

				var adjustedX = this.parent.options.percentPosition
					? x * sideOffset * (this.parent.size.innerWidth / this.size.width)
					: x * sideOffset;

				this.element.style.transform =
					"translateX(" + this.parent.getPositionValue(adjustedX) + ")";
			};

			proto.select = function () {
				this.element.classList.add("is-selected");
				this.element.removeAttribute("aria-hidden");
			};

			proto.unselect = function () {
				this.element.classList.remove("is-selected");
				this.element.setAttribute("aria-hidden", "true");
			};

			/**
			 * @param {Integer} shift - 0, 1, or -1
			 */
			proto.wrapShift = function (shift) {
				this.shift = shift;
				this.renderPosition(this.x + this.parent.slideableWidth * shift);
			};

			proto.remove = function () {
				this.element.parentNode.removeChild(this.element);
			};

			return Cell;
		});
	});

	var slide = createCommonjsModule(function (module) {
		// slide
		(function (window, factory) {
			// universal module definition
			if (module.exports) {
				// CommonJS
				module.exports = factory();
			} else {
				// browser global
				window.Flickity = window.Flickity || {};
				window.Flickity.Slide = factory();
			}
		})(window, function factory() {
			function Slide(parent) {
				this.parent = parent;
				this.isOriginLeft = parent.originSide == "left";
				this.cells = [];
				this.outerWidth = 0;
				this.height = 0;
			}

			var proto = Slide.prototype;

			proto.addCell = function (cell) {
				this.cells.push(cell);
				this.outerWidth += cell.size.outerWidth;
				this.height = Math.max(cell.size.outerHeight, this.height);
				// first cell stuff
				if (this.cells.length == 1) {
					this.x = cell.x; // x comes from first cell
					var beginMargin = this.isOriginLeft ? "marginLeft" : "marginRight";
					this.firstMargin = cell.size[beginMargin];
				}
			};

			proto.updateTarget = function () {
				var endMargin = this.isOriginLeft ? "marginRight" : "marginLeft";
				var lastCell = this.getLastCell();
				var lastMargin = lastCell ? lastCell.size[endMargin] : 0;
				var slideWidth = this.outerWidth - (this.firstMargin + lastMargin);
				this.target =
					this.x + this.firstMargin + slideWidth * this.parent.cellAlign;
			};

			proto.getLastCell = function () {
				return this.cells[this.cells.length - 1];
			};

			proto.select = function () {
				this.cells.forEach(function (cell) {
					cell.select();
				});
			};

			proto.unselect = function () {
				this.cells.forEach(function (cell) {
					cell.unselect();
				});
			};

			proto.getCellElements = function () {
				return this.cells.map(function (cell) {
					return cell.element;
				});
			};

			return Slide;
		});
	});

	var animate = createCommonjsModule(function (module) {
		// animate
		(function (window, factory) {
			// universal module definition
			if (module.exports) {
				// CommonJS
				module.exports = factory(window, utils);
			} else {
				// browser global
				window.Flickity = window.Flickity || {};
				window.Flickity.animatePrototype = factory(window, window.fizzyUIUtils);
			}
		})(window, function factory(window, utils) {
			// -------------------------- animate -------------------------- //

			var proto = {};

			proto.startAnimation = function () {
				if (this.isAnimating) {
					return;
				}

				this.isAnimating = true;
				this.restingFrames = 0;
				this.animate();
			};

			proto.animate = function () {
				this.applyDragForce();
				this.applySelectedAttraction();

				var previousX = this.x;

				this.integratePhysics();
				this.positionSlider();
				this.settle(previousX);
				// animate next frame
				if (this.isAnimating) {
					var _this = this;
					requestAnimationFrame(function animateFrame() {
						_this.animate();
					});
				}
			};

			proto.positionSlider = function () {
				var x = this.x;
				// wrap position around
				if (this.options.wrapAround && this.cells.length > 1) {
					x = utils.modulo(x, this.slideableWidth);
					x -= this.slideableWidth;
					this.shiftWrapCells(x);
				}

				this.setTranslateX(x, this.isAnimating);
				this.dispatchScrollEvent();
			};

			proto.setTranslateX = function (x, is3d) {
				x += this.cursorPosition;
				// reverse if right-to-left and using transform
				x = this.options.rightToLeft ? -x : x;
				var translateX = this.getPositionValue(x);
				// use 3D transforms for hardware acceleration on iOS
				// but use 2D when settled, for better font-rendering
				this.slider.style.transform = is3d
					? "translate3d(" + translateX + ",0,0)"
					: "translateX(" + translateX + ")";
			};

			proto.dispatchScrollEvent = function () {
				var firstSlide = this.slides[0];
				if (!firstSlide) {
					return;
				}
				var positionX = -this.x - firstSlide.target;
				var progress = positionX / this.slidesWidth;
				this.dispatchEvent("scroll", null, [progress, positionX]);
			};

			proto.positionSliderAtSelected = function () {
				if (!this.cells.length) {
					return;
				}
				this.x = -this.selectedSlide.target;
				this.velocity = 0; // stop wobble
				this.positionSlider();
			};

			proto.getPositionValue = function (position) {
				if (this.options.percentPosition) {
					// percent position, round to 2 digits, like 12.34%
					return (
						Math.round((position / this.size.innerWidth) * 10000) * 0.01 + "%"
					);
				} else {
					// pixel positioning
					return Math.round(position) + "px";
				}
			};

			proto.settle = function (previousX) {
				// keep track of frames where x hasn't moved
				var isResting =
					!this.isPointerDown &&
					Math.round(this.x * 100) == Math.round(previousX * 100);
				if (isResting) {
					this.restingFrames++;
				}
				// stop animating if resting for 3 or more frames
				if (this.restingFrames > 2) {
					this.isAnimating = false;
					delete this.isFreeScrolling;
					// render position with translateX when settled
					this.positionSlider();
					this.dispatchEvent("settle", null, [this.selectedIndex]);
				}
			};

			proto.shiftWrapCells = function (x) {
				// shift before cells
				var beforeGap = this.cursorPosition + x;
				this._shiftCells(this.beforeShiftCells, beforeGap, -1);
				// shift after cells
				var afterGap =
					this.size.innerWidth -
					(x + this.slideableWidth + this.cursorPosition);
				this._shiftCells(this.afterShiftCells, afterGap, 1);
			};

			proto._shiftCells = function (cells, gap, shift) {
				for (var i = 0; i < cells.length; i++) {
					var cell = cells[i];
					var cellShift = gap > 0 ? shift : 0;
					cell.wrapShift(cellShift);
					gap -= cell.size.outerWidth;
				}
			};

			proto._unshiftCells = function (cells) {
				if (!cells || !cells.length) {
					return;
				}
				for (var i = 0; i < cells.length; i++) {
					cells[i].wrapShift(0);
				}
			};

			// -------------------------- physics -------------------------- //

			proto.integratePhysics = function () {
				this.x += this.velocity;
				this.velocity *= this.getFrictionFactor();
			};

			proto.applyForce = function (force) {
				this.velocity += force;
			};

			proto.getFrictionFactor = function () {
				return (
					1 -
					this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"]
				);
			};

			proto.getRestingPosition = function () {
				// my thanks to Steven Wittens, who simplified this math greatly
				return this.x + this.velocity / (1 - this.getFrictionFactor());
			};

			proto.applyDragForce = function () {
				if (!this.isDraggable || !this.isPointerDown) {
					return;
				}
				// change the position to drag position by applying force
				var dragVelocity = this.dragX - this.x;
				var dragForce = dragVelocity - this.velocity;
				this.applyForce(dragForce);
			};

			proto.applySelectedAttraction = function () {
				// do not attract if pointer down or no slides
				var dragDown = this.isDraggable && this.isPointerDown;
				if (dragDown || this.isFreeScrolling || !this.slides.length) {
					return;
				}
				var distance = this.selectedSlide.target * -1 - this.x;
				var force = distance * this.options.selectedAttraction;
				this.applyForce(force);
			};

			return proto;
		});
	});

	var flickity = createCommonjsModule(function (module) {
		// Flickity main
		/* eslint-disable max-params */
		(function (window, factory) {
			// universal module definition
			if (module.exports) {
				// CommonJS
				module.exports = factory(
					window,
					evEmitter,
					getSize,
					utils,
					cell,
					slide,
					animate
				);
			} else {
				// browser global
				var _Flickity = window.Flickity;

				window.Flickity = factory(
					window,
					window.EvEmitter,
					window.getSize,
					window.fizzyUIUtils,
					_Flickity.Cell,
					_Flickity.Slide,
					_Flickity.animatePrototype
				);
			}
		})(
			window,
			function factory(
				window,
				EvEmitter,
				getSize,
				utils,
				Cell,
				Slide,
				animatePrototype
			) {
				// vars
				var jQuery = window.jQuery;
				var getComputedStyle = window.getComputedStyle;
				var console = window.console;

				function moveElements(elems, toElem) {
					elems = utils.makeArray(elems);
					while (elems.length) {
						toElem.appendChild(elems.shift());
					}
				}

				// -------------------------- Flickity -------------------------- //

				// globally unique identifiers
				var GUID = 0;
				// internal store of all Flickity intances
				var instances = {};

				function Flickity(element, options) {
					var queryElement = utils.getQueryElement(element);
					if (!queryElement) {
						if (console) {
							console.error(
								"Bad element for Flickity: " + (queryElement || element)
							);
						}
						return;
					}
					this.element = queryElement;
					// do not initialize twice on same element
					if (this.element.flickityGUID) {
						var instance = instances[this.element.flickityGUID];
						if (instance) instance.option(options);
						return instance;
					}

					// add jQuery
					if (jQuery) {
						this.$element = jQuery(this.element);
					}
					// options
					this.options = utils.extend({}, this.constructor.defaults);
					this.option(options);

					// kick things off
					this._create();
				}

				Flickity.defaults = {
					accessibility: true,
					// adaptiveHeight: false,
					cellAlign: "center",
					// cellSelector: undefined,
					// contain: false,
					freeScrollFriction: 0.075, // friction when free-scrolling
					friction: 0.28, // friction when selecting
					namespaceJQueryEvents: true,
					// initialIndex: 0,
					percentPosition: true,
					resize: true,
					selectedAttraction: 0.025,
					setGallerySize: true,
					// watchCSS: false,
					// wrapAround: false
				};

				// hash of methods triggered on _create()
				Flickity.createMethods = [];

				var proto = Flickity.prototype;
				// inherit EventEmitter
				utils.extend(proto, EvEmitter.prototype);

				proto._create = function () {
					// add id for Flickity.data
					var id = (this.guid = ++GUID);
					this.element.flickityGUID = id; // expando
					instances[id] = this; // associate via id
					// initial properties
					this.selectedIndex = 0;
					// how many frames slider has been in same position
					this.restingFrames = 0;
					// initial physics properties
					this.x = 0;
					this.velocity = 0;
					this.originSide = this.options.rightToLeft ? "right" : "left";
					// create viewport & slider
					this.viewport = document.createElement("div");
					this.viewport.className = "flickity-viewport";
					this._createSlider();

					if (this.options.resize || this.options.watchCSS) {
						window.addEventListener("resize", this);
					}

					// add listeners from on option
					for (var eventName in this.options.on) {
						var listener = this.options.on[eventName];
						this.on(eventName, listener);
					}

					Flickity.createMethods.forEach(function (method) {
						this[method]();
					}, this);

					if (this.options.watchCSS) {
						this.watchCSS();
					} else {
						this.activate();
					}
				};

				/**
				 * set options
				 * @param {Object} opts - options to extend
				 */
				proto.option = function (opts) {
					utils.extend(this.options, opts);
				};

				proto.activate = function () {
					if (this.isActive) {
						return;
					}
					this.isActive = true;
					this.element.classList.add("flickity-enabled");
					if (this.options.rightToLeft) {
						this.element.classList.add("flickity-rtl");
					}

					this.getSize();
					// move initial cell elements so they can be loaded as cells
					var cellElems = this._filterFindCellElements(this.element.children);
					moveElements(cellElems, this.slider);
					this.viewport.appendChild(this.slider);
					this.element.appendChild(this.viewport);
					// get cells from children
					this.reloadCells();

					if (this.options.accessibility) {
						// allow element to focusable
						this.element.tabIndex = 0;
						// listen for key presses
						this.element.addEventListener("keydown", this);
					}

					this.emitEvent("activate");
					this.selectInitialIndex();
					// flag for initial activation, for using initialIndex
					this.isInitActivated = true;
					// ready event. #493
					this.dispatchEvent("ready");
				};

				// slider positions the cells
				proto._createSlider = function () {
					// slider element does all the positioning
					var slider = document.createElement("div");
					slider.className = "flickity-slider";
					slider.style[this.originSide] = 0;
					this.slider = slider;
				};

				proto._filterFindCellElements = function (elems) {
					return utils.filterFindElements(elems, this.options.cellSelector);
				};

				// goes through all children
				proto.reloadCells = function () {
					// collection of item elements
					this.cells = this._makeCells(this.slider.children);
					this.positionCells();
					this._getWrapShiftCells();
					this.setGallerySize();
				};

				/**
				 * turn elements into Flickity.Cells
				 * @param {[Array, NodeList, HTMLElement]} elems - elements to make into cells
				 * @returns {Array} items - collection of new Flickity Cells
				 */
				proto._makeCells = function (elems) {
					var cellElems = this._filterFindCellElements(elems);

					// create new Flickity for collection
					var cells = cellElems.map(function (cellElem) {
						return new Cell(cellElem, this);
					}, this);

					return cells;
				};

				proto.getLastCell = function () {
					return this.cells[this.cells.length - 1];
				};

				proto.getLastSlide = function () {
					return this.slides[this.slides.length - 1];
				};

				// positions all cells
				proto.positionCells = function () {
					// size all cells
					this._sizeCells(this.cells);
					// position all cells
					this._positionCells(0);
				};

				/**
				 * position certain cells
				 * @param {Integer} index - which cell to start with
				 */
				proto._positionCells = function (index) {
					index = index || 0;
					// also measure maxCellHeight
					// start 0 if positioning all cells
					this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
					var cellX = 0;
					// get cellX
					if (index > 0) {
						var startCell = this.cells[index - 1];
						cellX = startCell.x + startCell.size.outerWidth;
					}
					var len = this.cells.length;
					for (var i = index; i < len; i++) {
						var cell = this.cells[i];
						cell.setPosition(cellX);
						cellX += cell.size.outerWidth;
						this.maxCellHeight = Math.max(
							cell.size.outerHeight,
							this.maxCellHeight
						);
					}
					// keep track of cellX for wrap-around
					this.slideableWidth = cellX;
					// slides
					this.updateSlides();
					// contain slides target
					this._containSlides();
					// update slidesWidth
					this.slidesWidth = len
						? this.getLastSlide().target - this.slides[0].target
						: 0;
				};

				/**
				 * cell.getSize() on multiple cells
				 * @param {Array} cells - cells to size
				 */
				proto._sizeCells = function (cells) {
					cells.forEach(function (cell) {
						cell.getSize();
					});
				};

				// --------------------------  -------------------------- //

				proto.updateSlides = function () {
					this.slides = [];
					if (!this.cells.length) {
						return;
					}

					var slide = new Slide(this);
					this.slides.push(slide);
					var isOriginLeft = this.originSide == "left";
					var nextMargin = isOriginLeft ? "marginRight" : "marginLeft";

					var canCellFit = this._getCanCellFit();

					this.cells.forEach(function (cell, i) {
						// just add cell if first cell in slide
						if (!slide.cells.length) {
							slide.addCell(cell);
							return;
						}

						var slideWidth =
							slide.outerWidth -
							slide.firstMargin +
							(cell.size.outerWidth - cell.size[nextMargin]);

						if (canCellFit.call(this, i, slideWidth)) {
							slide.addCell(cell);
						} else {
							// doesn't fit, new slide
							slide.updateTarget();

							slide = new Slide(this);
							this.slides.push(slide);
							slide.addCell(cell);
						}
					}, this);
					// last slide
					slide.updateTarget();
					// update .selectedSlide
					this.updateSelectedSlide();
				};

				proto._getCanCellFit = function () {
					var groupCells = this.options.groupCells;
					if (!groupCells) {
						return function () {
							return false;
						};
					} else if (typeof groupCells == "number") {
						// group by number. 3 -> [0,1,2], [3,4,5], ...
						var number = parseInt(groupCells, 10);
						return function (i) {
							return i % number !== 0;
						};
					}
					// default, group by width of slide
					// parse '75%
					var percentMatch =
						typeof groupCells == "string" && groupCells.match(/^(\d+)%$/);
					var percent = percentMatch ? parseInt(percentMatch[1], 10) / 100 : 1;
					return function (i, slideWidth) {
						/* eslint-disable-next-line no-invalid-this */
						return slideWidth <= (this.size.innerWidth + 1) * percent;
					};
				};

				// alias _init for jQuery plugin .flickity()
				proto._init = proto.reposition = function () {
					this.positionCells();
					this.positionSliderAtSelected();
				};

				proto.getSize = function () {
					this.size = getSize(this.element);
					this.setCellAlign();
					this.cursorPosition = this.size.innerWidth * this.cellAlign;
				};

				var cellAlignShorthands = {
					// cell align, then based on origin side
					center: {
						left: 0.5,
						right: 0.5,
					},
					left: {
						left: 0,
						right: 1,
					},
					right: {
						right: 0,
						left: 1,
					},
				};

				proto.setCellAlign = function () {
					var shorthand = cellAlignShorthands[this.options.cellAlign];
					this.cellAlign = shorthand
						? shorthand[this.originSide]
						: this.options.cellAlign;
				};

				proto.setGallerySize = function () {
					if (this.options.setGallerySize) {
						var height =
							this.options.adaptiveHeight && this.selectedSlide
								? this.selectedSlide.height
								: this.maxCellHeight;
						this.viewport.style.height = height + "px";
					}
				};

				proto._getWrapShiftCells = function () {
					// only for wrap-around
					if (!this.options.wrapAround) {
						return;
					}
					// unshift previous cells
					this._unshiftCells(this.beforeShiftCells);
					this._unshiftCells(this.afterShiftCells);
					// get before cells
					// initial gap
					var gapX = this.cursorPosition;
					var cellIndex = this.cells.length - 1;
					this.beforeShiftCells = this._getGapCells(gapX, cellIndex, -1);
					// get after cells
					// ending gap between last cell and end of gallery viewport
					gapX = this.size.innerWidth - this.cursorPosition;
					// start cloning at first cell, working forwards
					this.afterShiftCells = this._getGapCells(gapX, 0, 1);
				};

				proto._getGapCells = function (gapX, cellIndex, increment) {
					// keep adding cells until the cover the initial gap
					var cells = [];
					while (gapX > 0) {
						var cell = this.cells[cellIndex];
						if (!cell) {
							break;
						}
						cells.push(cell);
						cellIndex += increment;
						gapX -= cell.size.outerWidth;
					}
					return cells;
				};

				// ----- contain ----- //

				// contain cell targets so no excess sliding
				proto._containSlides = function () {
					if (
						!this.options.contain ||
						this.options.wrapAround ||
						!this.cells.length
					) {
						return;
					}
					var isRightToLeft = this.options.rightToLeft;
					var beginMargin = isRightToLeft ? "marginRight" : "marginLeft";
					var endMargin = isRightToLeft ? "marginLeft" : "marginRight";
					var contentWidth =
						this.slideableWidth - this.getLastCell().size[endMargin];
					// content is less than gallery size
					var isContentSmaller = contentWidth < this.size.innerWidth;
					// bounds
					var beginBound =
						this.cursorPosition + this.cells[0].size[beginMargin];
					var endBound =
						contentWidth - this.size.innerWidth * (1 - this.cellAlign);
					// contain each cell target
					this.slides.forEach(function (slide) {
						if (isContentSmaller) {
							// all cells fit inside gallery
							slide.target = contentWidth * this.cellAlign;
						} else {
							// contain to bounds
							slide.target = Math.max(slide.target, beginBound);
							slide.target = Math.min(slide.target, endBound);
						}
					}, this);
				};

				// -----  ----- //

				/**
				 * emits events via eventEmitter and jQuery events
				 * @param {String} type - name of event
				 * @param {Event} event - original event
				 * @param {Array} args - extra arguments
				 */
				proto.dispatchEvent = function (type, event, args) {
					var emitArgs = event ? [event].concat(args) : args;
					this.emitEvent(type, emitArgs);

					if (jQuery && this.$element) {
						// default trigger with type if no event
						type += this.options.namespaceJQueryEvents ? ".flickity" : "";
						var $event = type;
						if (event) {
							// create jQuery event
							var jQEvent = new jQuery.Event(event);
							jQEvent.type = type;
							$event = jQEvent;
						}
						this.$element.trigger($event, args);
					}
				};

				// -------------------------- select -------------------------- //

				/**
				 * @param {Integer} index - index of the slide
				 * @param {Boolean} isWrap - will wrap-around to last/first if at the end
				 * @param {Boolean} isInstant - will immediately set position at selected cell
				 */
				proto.select = function (index, isWrap, isInstant) {
					if (!this.isActive) {
						return;
					}
					index = parseInt(index, 10);
					this._wrapSelect(index);

					if (this.options.wrapAround || isWrap) {
						index = utils.modulo(index, this.slides.length);
					}
					// bail if invalid index
					if (!this.slides[index]) {
						return;
					}
					var prevIndex = this.selectedIndex;
					this.selectedIndex = index;
					this.updateSelectedSlide();
					if (isInstant) {
						this.positionSliderAtSelected();
					} else {
						this.startAnimation();
					}
					if (this.options.adaptiveHeight) {
						this.setGallerySize();
					}
					// events
					this.dispatchEvent("select", null, [index]);
					// change event if new index
					if (index != prevIndex) {
						this.dispatchEvent("change", null, [index]);
					}
					// old v1 event name, remove in v3
					this.dispatchEvent("cellSelect");
				};

				// wraps position for wrapAround, to move to closest slide. #113
				proto._wrapSelect = function (index) {
					var len = this.slides.length;
					var isWrapping = this.options.wrapAround && len > 1;
					if (!isWrapping) {
						return index;
					}
					var wrapIndex = utils.modulo(index, len);
					// go to shortest
					var delta = Math.abs(wrapIndex - this.selectedIndex);
					var backWrapDelta = Math.abs(wrapIndex + len - this.selectedIndex);
					var forewardWrapDelta = Math.abs(
						wrapIndex - len - this.selectedIndex
					);
					if (!this.isDragSelect && backWrapDelta < delta) {
						index += len;
					} else if (!this.isDragSelect && forewardWrapDelta < delta) {
						index -= len;
					}
					// wrap position so slider is within normal area
					if (index < 0) {
						this.x -= this.slideableWidth;
					} else if (index >= len) {
						this.x += this.slideableWidth;
					}
				};

				proto.previous = function (isWrap, isInstant) {
					this.select(this.selectedIndex - 1, isWrap, isInstant);
				};

				proto.next = function (isWrap, isInstant) {
					this.select(this.selectedIndex + 1, isWrap, isInstant);
				};

				proto.updateSelectedSlide = function () {
					var slide = this.slides[this.selectedIndex];
					// selectedIndex could be outside of slides, if triggered before resize()
					if (!slide) {
						return;
					}
					// unselect previous selected slide
					this.unselectSelectedSlide();
					// update new selected slide
					this.selectedSlide = slide;
					slide.select();
					this.selectedCells = slide.cells;
					this.selectedElements = slide.getCellElements();
					// HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
					// Remove in v3?
					this.selectedCell = slide.cells[0];
					this.selectedElement = this.selectedElements[0];
				};

				proto.unselectSelectedSlide = function () {
					if (this.selectedSlide) {
						this.selectedSlide.unselect();
					}
				};

				proto.selectInitialIndex = function () {
					var initialIndex = this.options.initialIndex;
					// already activated, select previous selectedIndex
					if (this.isInitActivated) {
						this.select(this.selectedIndex, false, true);
						return;
					}
					// select with selector string
					if (initialIndex && typeof initialIndex == "string") {
						var cell = this.queryCell(initialIndex);
						if (cell) {
							this.selectCell(initialIndex, false, true);
							return;
						}
					}

					var index = 0;
					// select with number
					if (initialIndex && this.slides[initialIndex]) {
						index = initialIndex;
					}
					// select instantly
					this.select(index, false, true);
				};

				/**
				 * select slide from number or cell element
				 * @param {[Element, Number]} value - zero-based index or element to select
				 * @param {Boolean} isWrap - enables wrapping around for extra index
				 * @param {Boolean} isInstant - disables slide animation
				 */
				proto.selectCell = function (value, isWrap, isInstant) {
					// get cell
					var cell = this.queryCell(value);
					if (!cell) {
						return;
					}

					var index = this.getCellSlideIndex(cell);
					this.select(index, isWrap, isInstant);
				};

				proto.getCellSlideIndex = function (cell) {
					// get index of slides that has cell
					for (var i = 0; i < this.slides.length; i++) {
						var slide = this.slides[i];
						var index = slide.cells.indexOf(cell);
						if (index != -1) {
							return i;
						}
					}
				};

				// -------------------------- get cells -------------------------- //

				/**
				 * get Flickity.Cell, given an Element
				 * @param {Element} elem - matching cell element
				 * @returns {Flickity.Cell} cell - matching cell
				 */
				proto.getCell = function (elem) {
					// loop through cells to get the one that matches
					for (var i = 0; i < this.cells.length; i++) {
						var cell = this.cells[i];
						if (cell.element == elem) {
							return cell;
						}
					}
				};

				/**
				 * get collection of Flickity.Cells, given Elements
				 * @param {[Element, Array, NodeList]} elems - multiple elements
				 * @returns {Array} cells - Flickity.Cells
				 */
				proto.getCells = function (elems) {
					elems = utils.makeArray(elems);
					var cells = [];
					elems.forEach(function (elem) {
						var cell = this.getCell(elem);
						if (cell) {
							cells.push(cell);
						}
					}, this);
					return cells;
				};

				/**
				 * get cell elements
				 * @returns {Array} cellElems
				 */
				proto.getCellElements = function () {
					return this.cells.map(function (cell) {
						return cell.element;
					});
				};

				/**
				 * get parent cell from an element
				 * @param {Element} elem - child element
				 * @returns {Flickit.Cell} cell - parent cell
				 */
				proto.getParentCell = function (elem) {
					// first check if elem is cell
					var cell = this.getCell(elem);
					if (cell) {
						return cell;
					}
					// try to get parent cell elem
					elem = utils.getParent(elem, ".flickity-slider > *");
					return this.getCell(elem);
				};

				/**
				 * get cells adjacent to a slide
				 * @param {Integer} adjCount - number of adjacent slides
				 * @param {Integer} index - index of slide to start
				 * @returns {Array} cells - array of Flickity.Cells
				 */
				proto.getAdjacentCellElements = function (adjCount, index) {
					if (!adjCount) {
						return this.selectedSlide.getCellElements();
					}
					index = index === undefined ? this.selectedIndex : index;

					var len = this.slides.length;
					if (1 + adjCount * 2 >= len) {
						return this.getCellElements();
					}

					var cellElems = [];
					for (var i = index - adjCount; i <= index + adjCount; i++) {
						var slideIndex = this.options.wrapAround ? utils.modulo(i, len) : i;
						var slide = this.slides[slideIndex];
						if (slide) {
							cellElems = cellElems.concat(slide.getCellElements());
						}
					}
					return cellElems;
				};

				/**
				 * select slide from number or cell element
				 * @param {[Element, String, Number]} selector - element, selector string, or index
				 * @returns {Flickity.Cell} - matching cell
				 */
				proto.queryCell = function (selector) {
					if (typeof selector == "number") {
						// use number as index
						return this.cells[selector];
					}
					if (typeof selector == "string") {
						// do not select invalid selectors from hash: #123, #/. #791
						if (selector.match(/^[#.]?[\d/]/)) {
							return;
						}
						// use string as selector, get element
						selector = this.element.querySelector(selector);
					}
					// get cell from element
					return this.getCell(selector);
				};

				// -------------------------- events -------------------------- //

				proto.uiChange = function () {
					this.emitEvent("uiChange");
				};

				// keep focus on element when child UI elements are clicked
				proto.childUIPointerDown = function (event) {
					// HACK iOS does not allow touch events to bubble up?!
					if (event.type != "touchstart") {
						event.preventDefault();
					}
					this.focus();
				};

				// ----- resize ----- //

				proto.onresize = function () {
					this.watchCSS();
					this.resize();
				};

				utils.debounceMethod(Flickity, "onresize", 150);

				proto.resize = function () {
					// #1177 disable resize behavior when animating or dragging for iOS 15
					if (!this.isActive || this.isAnimating || this.isDragging) {
						return;
					}
					this.getSize();
					// wrap values
					if (this.options.wrapAround) {
						this.x = utils.modulo(this.x, this.slideableWidth);
					}
					this.positionCells();
					this._getWrapShiftCells();
					this.setGallerySize();
					this.emitEvent("resize");
					// update selected index for group slides, instant
					// TODO: position can be lost between groups of various numbers
					var selectedElement =
						this.selectedElements && this.selectedElements[0];
					this.selectCell(selectedElement, false, true);
				};

				// watches the :after property, activates/deactivates
				proto.watchCSS = function () {
					var watchOption = this.options.watchCSS;
					if (!watchOption) {
						return;
					}

					var afterContent = getComputedStyle(this.element, ":after").content;
					// activate if :after { content: 'flickity' }
					if (afterContent.indexOf("flickity") != -1) {
						this.activate();
					} else {
						this.deactivate();
					}
				};

				// ----- keydown ----- //

				// go previous/next if left/right keys pressed
				proto.onkeydown = function (event) {
					// only work if element is in focus
					var isNotFocused =
						document.activeElement && document.activeElement != this.element;
					if (!this.options.accessibility || isNotFocused) {
						return;
					}

					var handler = Flickity.keyboardHandlers[event.keyCode];
					if (handler) {
						handler.call(this);
					}
				};

				Flickity.keyboardHandlers = {
					// left arrow
					37: function () {
						var leftMethod = this.options.rightToLeft ? "next" : "previous";
						this.uiChange();
						this[leftMethod]();
					},
					// right arrow
					39: function () {
						var rightMethod = this.options.rightToLeft ? "previous" : "next";
						this.uiChange();
						this[rightMethod]();
					},
				};

				// ----- focus ----- //

				proto.focus = function () {
					// TODO remove scrollTo once focus options gets more support
					// https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus ...
					//    #Browser_compatibility
					var prevScrollY = window.pageYOffset;
					this.element.focus({ preventScroll: true });
					// hack to fix scroll jump after focus, #76
					if (window.pageYOffset != prevScrollY) {
						window.scrollTo(window.pageXOffset, prevScrollY);
					}
				};

				// -------------------------- destroy -------------------------- //

				// deactivate all Flickity functionality, but keep stuff available
				proto.deactivate = function () {
					if (!this.isActive) {
						return;
					}
					this.element.classList.remove("flickity-enabled");
					this.element.classList.remove("flickity-rtl");
					this.unselectSelectedSlide();
					// destroy cells
					this.cells.forEach(function (cell) {
						cell.destroy();
					});
					this.element.removeChild(this.viewport);
					// move child elements back into element
					moveElements(this.slider.children, this.element);
					if (this.options.accessibility) {
						this.element.removeAttribute("tabIndex");
						this.element.removeEventListener("keydown", this);
					}
					// set flags
					this.isActive = false;
					this.emitEvent("deactivate");
				};

				proto.destroy = function () {
					this.deactivate();
					window.removeEventListener("resize", this);
					this.allOff();
					this.emitEvent("destroy");
					if (jQuery && this.$element) {
						jQuery.removeData(this.element, "flickity");
					}
					delete this.element.flickityGUID;
					delete instances[this.guid];
				};

				// -------------------------- prototype -------------------------- //

				utils.extend(proto, animatePrototype);

				// -------------------------- extras -------------------------- //

				/**
				 * get Flickity instance from element
				 * @param {[Element, String]} elem - element or selector string
				 * @returns {Flickity} - Flickity instance
				 */
				Flickity.data = function (elem) {
					elem = utils.getQueryElement(elem);
					var id = elem && elem.flickityGUID;
					return id && instances[id];
				};

				utils.htmlInit(Flickity, "flickity");

				if (jQuery && jQuery.bridget) {
					jQuery.bridget("flickity", Flickity);
				}

				// set internal jQuery, for Webpack + jQuery v3, #478
				Flickity.setJQuery = function (jq) {
					jQuery = jq;
				};

				Flickity.Cell = Cell;
				Flickity.Slide = Slide;

				return Flickity;
			}
		);
	});

	var unipointer = createCommonjsModule(function (module) {
		/*!
		 * Unipointer v2.4.0
		 * base class for doing one thing with pointer event
		 * MIT license
		 */

		/*jshint browser: true, undef: true, unused: true, strict: true */

		(function (window, factory) {
			// universal module definition
			/* jshint strict: false */ /*global define, module, require */ if (
				module.exports
			) {
				// CommonJS
				module.exports = factory(window, evEmitter);
			} else {
				// browser global
				window.Unipointer = factory(window, window.EvEmitter);
			}
		})(window, function factory(window, EvEmitter) {
			function noop() {}

			function Unipointer() {}

			// inherit EvEmitter
			var proto = (Unipointer.prototype = Object.create(EvEmitter.prototype));

			proto.bindStartEvent = function (elem) {
				this._bindStartEvent(elem, true);
			};

			proto.unbindStartEvent = function (elem) {
				this._bindStartEvent(elem, false);
			};

			/**
			 * Add or remove start event
			 * @param {Boolean} isAdd - remove if falsey
			 */
			proto._bindStartEvent = function (elem, isAdd) {
				// munge isAdd, default to true
				isAdd = isAdd === undefined ? true : isAdd;
				var bindMethod = isAdd ? "addEventListener" : "removeEventListener";

				// default to mouse events
				var startEvent = "mousedown";
				if ("ontouchstart" in window) {
					// HACK prefer Touch Events as you can preventDefault on touchstart to
					// disable scroll in iOS & mobile Chrome metafizzy/flickity#1177
					startEvent = "touchstart";
				} else if (window.PointerEvent) {
					// Pointer Events
					startEvent = "pointerdown";
				}
				elem[bindMethod](startEvent, this);
			};

			// trigger handler methods for events
			proto.handleEvent = function (event) {
				var method = "on" + event.type;
				if (this[method]) {
					this[method](event);
				}
			};

			// returns the touch that we're keeping track of
			proto.getTouch = function (touches) {
				for (var i = 0; i < touches.length; i++) {
					var touch = touches[i];
					if (touch.identifier == this.pointerIdentifier) {
						return touch;
					}
				}
			};

			// ----- start event ----- //

			proto.onmousedown = function (event) {
				// dismiss clicks from right or middle buttons
				var button = event.button;
				if (button && button !== 0 && button !== 1) {
					return;
				}
				this._pointerDown(event, event);
			};

			proto.ontouchstart = function (event) {
				this._pointerDown(event, event.changedTouches[0]);
			};

			proto.onpointerdown = function (event) {
				this._pointerDown(event, event);
			};

			/**
			 * pointer start
			 * @param {Event} event
			 * @param {Event or Touch} pointer
			 */
			proto._pointerDown = function (event, pointer) {
				// dismiss right click and other pointers
				// button = 0 is okay, 1-4 not
				if (event.button || this.isPointerDown) {
					return;
				}

				this.isPointerDown = true;
				// save pointer identifier to match up touch events
				this.pointerIdentifier =
					pointer.pointerId !== undefined
						? // pointerId for pointer events, touch.indentifier for touch events
						  pointer.pointerId
						: pointer.identifier;

				this.pointerDown(event, pointer);
			};

			proto.pointerDown = function (event, pointer) {
				this._bindPostStartEvents(event);
				this.emitEvent("pointerDown", [event, pointer]);
			};

			// hash of events to be bound after start event
			var postStartEvents = {
				mousedown: ["mousemove", "mouseup"],
				touchstart: ["touchmove", "touchend", "touchcancel"],
				pointerdown: ["pointermove", "pointerup", "pointercancel"],
			};

			proto._bindPostStartEvents = function (event) {
				if (!event) {
					return;
				}
				// get proper events to match start event
				var events = postStartEvents[event.type];
				// bind events to node
				events.forEach(function (eventName) {
					window.addEventListener(eventName, this);
				}, this);
				// save these arguments
				this._boundPointerEvents = events;
			};

			proto._unbindPostStartEvents = function () {
				// check for _boundEvents, in case dragEnd triggered twice (old IE8 bug)
				if (!this._boundPointerEvents) {
					return;
				}
				this._boundPointerEvents.forEach(function (eventName) {
					window.removeEventListener(eventName, this);
				}, this);

				delete this._boundPointerEvents;
			};

			// ----- move event ----- //

			proto.onmousemove = function (event) {
				this._pointerMove(event, event);
			};

			proto.onpointermove = function (event) {
				if (event.pointerId == this.pointerIdentifier) {
					this._pointerMove(event, event);
				}
			};

			proto.ontouchmove = function (event) {
				var touch = this.getTouch(event.changedTouches);
				if (touch) {
					this._pointerMove(event, touch);
				}
			};

			/**
			 * pointer move
			 * @param {Event} event
			 * @param {Event or Touch} pointer
			 * @private
			 */
			proto._pointerMove = function (event, pointer) {
				this.pointerMove(event, pointer);
			};

			// public
			proto.pointerMove = function (event, pointer) {
				this.emitEvent("pointerMove", [event, pointer]);
			};

			// ----- end event ----- //

			proto.onmouseup = function (event) {
				this._pointerUp(event, event);
			};

			proto.onpointerup = function (event) {
				if (event.pointerId == this.pointerIdentifier) {
					this._pointerUp(event, event);
				}
			};

			proto.ontouchend = function (event) {
				var touch = this.getTouch(event.changedTouches);
				if (touch) {
					this._pointerUp(event, touch);
				}
			};

			/**
			 * pointer up
			 * @param {Event} event
			 * @param {Event or Touch} pointer
			 * @private
			 */
			proto._pointerUp = function (event, pointer) {
				this._pointerDone();
				this.pointerUp(event, pointer);
			};

			// public
			proto.pointerUp = function (event, pointer) {
				this.emitEvent("pointerUp", [event, pointer]);
			};

			// ----- pointer done ----- //

			// triggered on pointer up & pointer cancel
			proto._pointerDone = function () {
				this._pointerReset();
				this._unbindPostStartEvents();
				this.pointerDone();
			};

			proto._pointerReset = function () {
				// reset properties
				this.isPointerDown = false;
				delete this.pointerIdentifier;
			};

			proto.pointerDone = noop;

			// ----- pointer cancel ----- //

			proto.onpointercancel = function (event) {
				if (event.pointerId == this.pointerIdentifier) {
					this._pointerCancel(event, event);
				}
			};

			proto.ontouchcancel = function (event) {
				var touch = this.getTouch(event.changedTouches);
				if (touch) {
					this._pointerCancel(event, touch);
				}
			};

			/**
			 * pointer cancel
			 * @param {Event} event
			 * @param {Event or Touch} pointer
			 * @private
			 */
			proto._pointerCancel = function (event, pointer) {
				this._pointerDone();
				this.pointerCancel(event, pointer);
			};

			// public
			proto.pointerCancel = function (event, pointer) {
				this.emitEvent("pointerCancel", [event, pointer]);
			};

			// -----  ----- //

			// utility function for getting x/y coords from event
			Unipointer.getPointerPoint = function (pointer) {
				return {
					x: pointer.pageX,
					y: pointer.pageY,
				};
			};

			// -----  ----- //

			return Unipointer;
		});
	});

	var unidragger = createCommonjsModule(function (module) {
		/*!
		 * Unidragger v2.4.0
		 * Draggable base class
		 * MIT license
		 */

		/*jshint browser: true, unused: true, undef: true, strict: true */

		(function (window, factory) {
			// universal module definition
			/*jshint strict: false */ /*globals define, module, require */ if (
				module.exports
			) {
				// CommonJS
				module.exports = factory(window, unipointer);
			} else {
				// browser global
				window.Unidragger = factory(window, window.Unipointer);
			}
		})(window, function factory(window, Unipointer) {
			// -------------------------- Unidragger -------------------------- //

			function Unidragger() {}

			// inherit Unipointer & EvEmitter
			var proto = (Unidragger.prototype = Object.create(Unipointer.prototype));

			// ----- bind start ----- //

			proto.bindHandles = function () {
				this._bindHandles(true);
			};

			proto.unbindHandles = function () {
				this._bindHandles(false);
			};

			/**
			 * Add or remove start event
			 * @param {Boolean} isAdd
			 */
			proto._bindHandles = function (isAdd) {
				// munge isAdd, default to true
				isAdd = isAdd === undefined ? true : isAdd;
				// bind each handle
				var bindMethod = isAdd ? "addEventListener" : "removeEventListener";
				var touchAction = isAdd ? this._touchActionValue : "";
				for (var i = 0; i < this.handles.length; i++) {
					var handle = this.handles[i];
					this._bindStartEvent(handle, isAdd);
					handle[bindMethod]("click", this);
					// touch-action: none to override browser touch gestures. metafizzy/flickity#540
					if (window.PointerEvent) {
						handle.style.touchAction = touchAction;
					}
				}
			};

			// prototype so it can be overwriteable by Flickity
			proto._touchActionValue = "none";

			// ----- start event ----- //

			/**
			 * pointer start
			 * @param {Event} event
			 * @param {Event or Touch} pointer
			 */
			proto.pointerDown = function (event, pointer) {
				var isOkay = this.okayPointerDown(event);
				if (!isOkay) {
					return;
				}
				// track start event position
				// Safari 9 overrides pageX and pageY. These values needs to be copied. flickity#842
				this.pointerDownPointer = {
					pageX: pointer.pageX,
					pageY: pointer.pageY,
				};

				event.preventDefault();
				this.pointerDownBlur();
				// bind move and end events
				this._bindPostStartEvents(event);
				this.emitEvent("pointerDown", [event, pointer]);
			};

			// nodes that have text fields
			var cursorNodes = {
				TEXTAREA: true,
				INPUT: true,
				SELECT: true,
				OPTION: true,
			};

			// input types that do not have text fields
			var clickTypes = {
				radio: true,
				checkbox: true,
				button: true,
				submit: true,
				image: true,
				file: true,
			};

			// dismiss inputs with text fields. flickity#403, flickity#404
			proto.okayPointerDown = function (event) {
				var isCursorNode = cursorNodes[event.target.nodeName];
				var isClickType = clickTypes[event.target.type];
				var isOkay = !isCursorNode || isClickType;
				if (!isOkay) {
					this._pointerReset();
				}
				return isOkay;
			};

			// kludge to blur previously focused input
			proto.pointerDownBlur = function () {
				var focused = document.activeElement;
				// do not blur body for IE10, metafizzy/flickity#117
				var canBlur = focused && focused.blur && focused != document.body;
				if (canBlur) {
					focused.blur();
				}
			};

			// ----- move event ----- //

			/**
			 * drag move
			 * @param {Event} event
			 * @param {Event or Touch} pointer
			 */
			proto.pointerMove = function (event, pointer) {
				var moveVector = this._dragPointerMove(event, pointer);
				this.emitEvent("pointerMove", [event, pointer, moveVector]);
				this._dragMove(event, pointer, moveVector);
			};

			// base pointer move logic
			proto._dragPointerMove = function (event, pointer) {
				var moveVector = {
					x: pointer.pageX - this.pointerDownPointer.pageX,
					y: pointer.pageY - this.pointerDownPointer.pageY,
				};
				// start drag if pointer has moved far enough to start drag
				if (!this.isDragging && this.hasDragStarted(moveVector)) {
					this._dragStart(event, pointer);
				}
				return moveVector;
			};

			// condition if pointer has moved far enough to start drag
			proto.hasDragStarted = function (moveVector) {
				return Math.abs(moveVector.x) > 3 || Math.abs(moveVector.y) > 3;
			};

			// ----- end event ----- //

			/**
			 * pointer up
			 * @param {Event} event
			 * @param {Event or Touch} pointer
			 */
			proto.pointerUp = function (event, pointer) {
				this.emitEvent("pointerUp", [event, pointer]);
				this._dragPointerUp(event, pointer);
			};

			proto._dragPointerUp = function (event, pointer) {
				if (this.isDragging) {
					this._dragEnd(event, pointer);
				} else {
					// pointer didn't move enough for drag to start
					this._staticClick(event, pointer);
				}
			};

			// -------------------------- drag -------------------------- //

			// dragStart
			proto._dragStart = function (event, pointer) {
				this.isDragging = true;
				// prevent clicks
				this.isPreventingClicks = true;
				this.dragStart(event, pointer);
			};

			proto.dragStart = function (event, pointer) {
				this.emitEvent("dragStart", [event, pointer]);
			};

			// dragMove
			proto._dragMove = function (event, pointer, moveVector) {
				// do not drag if not dragging yet
				if (!this.isDragging) {
					return;
				}

				this.dragMove(event, pointer, moveVector);
			};

			proto.dragMove = function (event, pointer, moveVector) {
				event.preventDefault();
				this.emitEvent("dragMove", [event, pointer, moveVector]);
			};

			// dragEnd
			proto._dragEnd = function (event, pointer) {
				// set flags
				this.isDragging = false;
				// re-enable clicking async
				setTimeout(
					function () {
						delete this.isPreventingClicks;
					}.bind(this)
				);

				this.dragEnd(event, pointer);
			};

			proto.dragEnd = function (event, pointer) {
				this.emitEvent("dragEnd", [event, pointer]);
			};

			// ----- onclick ----- //

			// handle all clicks and prevent clicks when dragging
			proto.onclick = function (event) {
				if (this.isPreventingClicks) {
					event.preventDefault();
				}
			};

			// ----- staticClick ----- //

			// triggered after pointer down & up with no/tiny movement
			proto._staticClick = function (event, pointer) {
				// ignore emulated mouse up clicks
				if (this.isIgnoringMouseUp && event.type == "mouseup") {
					return;
				}

				this.staticClick(event, pointer);

				// set flag for emulated clicks 300ms after touchend
				if (event.type != "mouseup") {
					this.isIgnoringMouseUp = true;
					// reset flag after 300ms
					setTimeout(
						function () {
							delete this.isIgnoringMouseUp;
						}.bind(this),
						400
					);
				}
			};

			proto.staticClick = function (event, pointer) {
				this.emitEvent("staticClick", [event, pointer]);
			};

			// ----- utils ----- //

			Unidragger.getPointerPoint = Unipointer.getPointerPoint;

			// -----  ----- //

			return Unidragger;
		});
	});

	var drag = createCommonjsModule(function (module) {
		// drag
		(function (window, factory) {
			// universal module definition
			if (module.exports) {
				// CommonJS
				module.exports = factory(window, flickity, unidragger, utils);
			} else {
				// browser global
				window.Flickity = factory(
					window,
					window.Flickity,
					window.Unidragger,
					window.fizzyUIUtils
				);
			}
		})(window, function factory(window, Flickity, Unidragger, utils) {
			// ----- defaults ----- //

			utils.extend(Flickity.defaults, {
				draggable: ">1",
				dragThreshold: 3,
			});

			// ----- create ----- //

			Flickity.createMethods.push("_createDrag");

			// -------------------------- drag prototype -------------------------- //

			var proto = Flickity.prototype;
			utils.extend(proto, Unidragger.prototype);
			proto._touchActionValue = "pan-y";

			// --------------------------  -------------------------- //

			proto._createDrag = function () {
				this.on("activate", this.onActivateDrag);
				this.on("uiChange", this._uiChangeDrag);
				this.on("deactivate", this.onDeactivateDrag);
				this.on("cellChange", this.updateDraggable);
				// TODO updateDraggable on resize? if groupCells & slides change
			};

			proto.onActivateDrag = function () {
				this.handles = [this.viewport];
				this.bindHandles();
				this.updateDraggable();
			};

			proto.onDeactivateDrag = function () {
				this.unbindHandles();
				this.element.classList.remove("is-draggable");
			};

			proto.updateDraggable = function () {
				// disable dragging if less than 2 slides. #278
				if (this.options.draggable == ">1") {
					this.isDraggable = this.slides.length > 1;
				} else {
					this.isDraggable = this.options.draggable;
				}
				if (this.isDraggable) {
					this.element.classList.add("is-draggable");
				} else {
					this.element.classList.remove("is-draggable");
				}
			};

			// backwards compatibility
			proto.bindDrag = function () {
				this.options.draggable = true;
				this.updateDraggable();
			};

			proto.unbindDrag = function () {
				this.options.draggable = false;
				this.updateDraggable();
			};

			proto._uiChangeDrag = function () {
				delete this.isFreeScrolling;
			};

			// -------------------------- pointer events -------------------------- //

			proto.pointerDown = function (event, pointer) {
				if (!this.isDraggable) {
					this._pointerDownDefault(event, pointer);
					return;
				}
				var isOkay = this.okayPointerDown(event);
				if (!isOkay) {
					return;
				}

				this._pointerDownPreventDefault(event);
				this.pointerDownFocus(event);
				// blur
				if (document.activeElement != this.element) {
					// do not blur if already focused
					this.pointerDownBlur();
				}

				// stop if it was moving
				this.dragX = this.x;
				this.viewport.classList.add("is-pointer-down");
				// track scrolling
				this.pointerDownScroll = getScrollPosition();
				window.addEventListener("scroll", this);

				this._pointerDownDefault(event, pointer);
			};

			// default pointerDown logic, used for staticClick
			proto._pointerDownDefault = function (event, pointer) {
				// track start event position
				// Safari 9 overrides pageX and pageY. These values needs to be copied. #779
				this.pointerDownPointer = {
					pageX: pointer.pageX,
					pageY: pointer.pageY,
				};
				// bind move and end events
				this._bindPostStartEvents(event);
				this.dispatchEvent("pointerDown", event, [pointer]);
			};

			var focusNodes = {
				INPUT: true,
				TEXTAREA: true,
				SELECT: true,
			};

			proto.pointerDownFocus = function (event) {
				var isFocusNode = focusNodes[event.target.nodeName];
				if (!isFocusNode) {
					this.focus();
				}
			};

			proto._pointerDownPreventDefault = function (event) {
				var isTouchStart = event.type == "touchstart";
				var isTouchPointer = event.pointerType == "touch";
				var isFocusNode = focusNodes[event.target.nodeName];
				if (!isTouchStart && !isTouchPointer && !isFocusNode) {
					event.preventDefault();
				}
			};

			// ----- move ----- //

			proto.hasDragStarted = function (moveVector) {
				return Math.abs(moveVector.x) > this.options.dragThreshold;
			};

			// ----- up ----- //

			proto.pointerUp = function (event, pointer) {
				delete this.isTouchScrolling;
				this.viewport.classList.remove("is-pointer-down");
				this.dispatchEvent("pointerUp", event, [pointer]);
				this._dragPointerUp(event, pointer);
			};

			proto.pointerDone = function () {
				window.removeEventListener("scroll", this);
				delete this.pointerDownScroll;
			};

			// -------------------------- dragging -------------------------- //

			proto.dragStart = function (event, pointer) {
				if (!this.isDraggable) {
					return;
				}
				this.dragStartPosition = this.x;
				this.startAnimation();
				window.removeEventListener("scroll", this);
				this.dispatchEvent("dragStart", event, [pointer]);
			};

			proto.pointerMove = function (event, pointer) {
				var moveVector = this._dragPointerMove(event, pointer);
				this.dispatchEvent("pointerMove", event, [pointer, moveVector]);
				this._dragMove(event, pointer, moveVector);
			};

			proto.dragMove = function (event, pointer, moveVector) {
				if (!this.isDraggable) {
					return;
				}
				event.preventDefault();

				this.previousDragX = this.dragX;
				// reverse if right-to-left
				var direction = this.options.rightToLeft ? -1 : 1;
				if (this.options.wrapAround) {
					// wrap around move. #589
					moveVector.x %= this.slideableWidth;
				}
				var dragX = this.dragStartPosition + moveVector.x * direction;

				if (!this.options.wrapAround && this.slides.length) {
					// slow drag
					var originBound = Math.max(
						-this.slides[0].target,
						this.dragStartPosition
					);
					dragX = dragX > originBound ? (dragX + originBound) * 0.5 : dragX;
					var endBound = Math.min(
						-this.getLastSlide().target,
						this.dragStartPosition
					);
					dragX = dragX < endBound ? (dragX + endBound) * 0.5 : dragX;
				}

				this.dragX = dragX;

				this.dragMoveTime = new Date();
				this.dispatchEvent("dragMove", event, [pointer, moveVector]);
			};

			proto.dragEnd = function (event, pointer) {
				if (!this.isDraggable) {
					return;
				}
				if (this.options.freeScroll) {
					this.isFreeScrolling = true;
				}
				// set selectedIndex based on where flick will end up
				var index = this.dragEndRestingSelect();

				if (this.options.freeScroll && !this.options.wrapAround) {
					// if free-scroll & not wrap around
					// do not free-scroll if going outside of bounding slides
					// so bounding slides can attract slider, and keep it in bounds
					var restingX = this.getRestingPosition();
					this.isFreeScrolling =
						-restingX > this.slides[0].target &&
						-restingX < this.getLastSlide().target;
				} else if (!this.options.freeScroll && index == this.selectedIndex) {
					// boost selection if selected index has not changed
					index += this.dragEndBoostSelect();
				}
				delete this.previousDragX;
				// apply selection
				// TODO refactor this, selecting here feels weird
				// HACK, set flag so dragging stays in correct direction
				this.isDragSelect = this.options.wrapAround;
				this.select(index);
				delete this.isDragSelect;
				this.dispatchEvent("dragEnd", event, [pointer]);
			};

			proto.dragEndRestingSelect = function () {
				var restingX = this.getRestingPosition();
				// how far away from selected slide
				var distance = Math.abs(
					this.getSlideDistance(-restingX, this.selectedIndex)
				);
				// get closet resting going up and going down
				var positiveResting = this._getClosestResting(restingX, distance, 1);
				var negativeResting = this._getClosestResting(restingX, distance, -1);
				// use closer resting for wrap-around
				var index =
					positiveResting.distance < negativeResting.distance
						? positiveResting.index
						: negativeResting.index;
				return index;
			};

			/**
			 * given resting X and distance to selected cell
			 * get the distance and index of the closest cell
			 * @param {Number} restingX - estimated post-flick resting position
			 * @param {Number} distance - distance to selected cell
			 * @param {Integer} increment - +1 or -1, going up or down
			 * @returns {Object} - { distance: {Number}, index: {Integer} }
			 */
			proto._getClosestResting = function (restingX, distance, increment) {
				var index = this.selectedIndex;
				var minDistance = Infinity;
				var condition =
					this.options.contain && !this.options.wrapAround
						? // if contain, keep going if distance is equal to minDistance
						  function (dist, minDist) {
								return dist <= minDist;
						  }
						: function (dist, minDist) {
								return dist < minDist;
						  };
				while (condition(distance, minDistance)) {
					// measure distance to next cell
					index += increment;
					minDistance = distance;
					distance = this.getSlideDistance(-restingX, index);
					if (distance === null) {
						break;
					}
					distance = Math.abs(distance);
				}
				return {
					distance: minDistance,
					// selected was previous index
					index: index - increment,
				};
			};

			/**
			 * measure distance between x and a slide target
			 * @param {Number} x - horizontal position
			 * @param {Integer} index - slide index
			 * @returns {Number} - slide distance
			 */
			proto.getSlideDistance = function (x, index) {
				var len = this.slides.length;
				// wrap around if at least 2 slides
				var isWrapAround = this.options.wrapAround && len > 1;
				var slideIndex = isWrapAround ? utils.modulo(index, len) : index;
				var slide = this.slides[slideIndex];
				if (!slide) {
					return null;
				}
				// add distance for wrap-around slides
				var wrap = isWrapAround
					? this.slideableWidth * Math.floor(index / len)
					: 0;
				return x - (slide.target + wrap);
			};

			proto.dragEndBoostSelect = function () {
				// do not boost if no previousDragX or dragMoveTime
				if (
					this.previousDragX === undefined ||
					!this.dragMoveTime ||
					// or if drag was held for 100 ms
					new Date() - this.dragMoveTime > 100
				) {
					return 0;
				}

				var distance = this.getSlideDistance(-this.dragX, this.selectedIndex);
				var delta = this.previousDragX - this.dragX;
				if (distance > 0 && delta > 0) {
					// boost to next if moving towards the right, and positive velocity
					return 1;
				} else if (distance < 0 && delta < 0) {
					// boost to previous if moving towards the left, and negative velocity
					return -1;
				}
				return 0;
			};

			// ----- staticClick ----- //

			proto.staticClick = function (event, pointer) {
				// get clickedCell, if cell was clicked
				var clickedCell = this.getParentCell(event.target);
				var cellElem = clickedCell && clickedCell.element;
				var cellIndex = clickedCell && this.cells.indexOf(clickedCell);
				this.dispatchEvent("staticClick", event, [
					pointer,
					cellElem,
					cellIndex,
				]);
			};

			// ----- scroll ----- //

			proto.onscroll = function () {
				var scroll = getScrollPosition();
				var scrollMoveX = this.pointerDownScroll.x - scroll.x;
				var scrollMoveY = this.pointerDownScroll.y - scroll.y;
				// cancel click/tap if scroll is too much
				if (Math.abs(scrollMoveX) > 3 || Math.abs(scrollMoveY) > 3) {
					this._pointerDone();
				}
			};

			// ----- utils ----- //

			function getScrollPosition() {
				return {
					x: window.pageXOffset,
					y: window.pageYOffset,
				};
			}

			// -----  ----- //

			return Flickity;
		});
	});

	var prevNextButton = createCommonjsModule(function (module) {
		// prev/next buttons
		(function (window, factory) {
			// universal module definition
			if (module.exports) {
				// CommonJS
				module.exports = factory(window, flickity, unipointer, utils);
			} else {
				// browser global
				factory(
					window,
					window.Flickity,
					window.Unipointer,
					window.fizzyUIUtils
				);
			}
		})(window, function factory(window, Flickity, Unipointer, utils) {
			var svgURI = "http://www.w3.org/2000/svg";

			// -------------------------- PrevNextButton -------------------------- //

			function PrevNextButton(direction, parent) {
				this.direction = direction;
				this.parent = parent;
				this._create();
			}

			PrevNextButton.prototype = Object.create(Unipointer.prototype);

			PrevNextButton.prototype._create = function () {
				// properties
				this.isEnabled = true;
				this.isPrevious = this.direction == -1;
				var leftDirection = this.parent.options.rightToLeft ? 1 : -1;
				this.isLeft = this.direction == leftDirection;

				var element = (this.element = document.createElement("button"));
				element.className = "flickity-button flickity-prev-next-button";
				element.className += this.isPrevious ? " previous" : " next";
				// prevent button from submitting form http://stackoverflow.com/a/10836076/182183
				element.setAttribute("type", "button");
				// init as disabled
				this.disable();

				element.setAttribute(
					"aria-label",
					this.isPrevious ? "Previous" : "Next"
				);

				// create arrow
				var svg = this.createSVG();
				element.appendChild(svg);
				// events
				this.parent.on("select", this.update.bind(this));
				this.on(
					"pointerDown",
					this.parent.childUIPointerDown.bind(this.parent)
				);
			};

			PrevNextButton.prototype.activate = function () {
				this.bindStartEvent(this.element);
				this.element.addEventListener("click", this);
				// add to DOM
				this.parent.element.appendChild(this.element);
			};

			PrevNextButton.prototype.deactivate = function () {
				// remove from DOM
				this.parent.element.removeChild(this.element);
				// click events
				this.unbindStartEvent(this.element);
				this.element.removeEventListener("click", this);
			};

			PrevNextButton.prototype.createSVG = function () {
				var svg = document.createElementNS(svgURI, "svg");
				svg.setAttribute("class", "flickity-button-icon");
				svg.setAttribute("viewBox", "0 0 100 100");
				var path = document.createElementNS(svgURI, "path");
				var pathMovements = getArrowMovements(this.parent.options.arrowShape);
				path.setAttribute("d", pathMovements);
				path.setAttribute("class", "arrow");
				// rotate arrow
				if (!this.isLeft) {
					path.setAttribute("transform", "translate(100, 100) rotate(180) ");
				}
				svg.appendChild(path);
				return svg;
			};

			// get SVG path movmement
			function getArrowMovements(shape) {
				// use shape as movement if string
				if (typeof shape == "string") {
					return shape;
				}
				// create movement string
				return (
					"M " +
					shape.x0 +
					",50" +
					" L " +
					shape.x1 +
					"," +
					(shape.y1 + 50) +
					" L " +
					shape.x2 +
					"," +
					(shape.y2 + 50) +
					" L " +
					shape.x3 +
					",50 " +
					" L " +
					shape.x2 +
					"," +
					(50 - shape.y2) +
					" L " +
					shape.x1 +
					"," +
					(50 - shape.y1) +
					" Z"
				);
			}

			PrevNextButton.prototype.handleEvent = utils.handleEvent;

			PrevNextButton.prototype.onclick = function () {
				if (!this.isEnabled) {
					return;
				}
				this.parent.uiChange();
				var method = this.isPrevious ? "previous" : "next";
				this.parent[method]();
			};

			// -----  ----- //

			PrevNextButton.prototype.enable = function () {
				if (this.isEnabled) {
					return;
				}
				this.element.disabled = false;
				this.isEnabled = true;
			};

			PrevNextButton.prototype.disable = function () {
				if (!this.isEnabled) {
					return;
				}
				this.element.disabled = true;
				this.isEnabled = false;
			};

			PrevNextButton.prototype.update = function () {
				// index of first or last slide, if previous or next
				var slides = this.parent.slides;
				// enable is wrapAround and at least 2 slides
				if (this.parent.options.wrapAround && slides.length > 1) {
					this.enable();
					return;
				}
				var lastIndex = slides.length ? slides.length - 1 : 0;
				var boundIndex = this.isPrevious ? 0 : lastIndex;
				var method =
					this.parent.selectedIndex == boundIndex ? "disable" : "enable";
				this[method]();
			};

			PrevNextButton.prototype.destroy = function () {
				this.deactivate();
				this.allOff();
			};

			// -------------------------- Flickity prototype -------------------------- //

			utils.extend(Flickity.defaults, {
				prevNextButtons: true,
				arrowShape: {
					x0: 10,
					x1: 60,
					y1: 50,
					x2: 70,
					y2: 40,
					x3: 30,
				},
			});

			Flickity.createMethods.push("_createPrevNextButtons");
			var proto = Flickity.prototype;

			proto._createPrevNextButtons = function () {
				if (!this.options.prevNextButtons) {
					return;
				}

				this.prevButton = new PrevNextButton(-1, this);
				this.nextButton = new PrevNextButton(1, this);

				this.on("activate", this.activatePrevNextButtons);
			};

			proto.activatePrevNextButtons = function () {
				this.prevButton.activate();
				this.nextButton.activate();
				this.on("deactivate", this.deactivatePrevNextButtons);
			};

			proto.deactivatePrevNextButtons = function () {
				this.prevButton.deactivate();
				this.nextButton.deactivate();
				this.off("deactivate", this.deactivatePrevNextButtons);
			};

			// --------------------------  -------------------------- //

			Flickity.PrevNextButton = PrevNextButton;

			return Flickity;
		});
	});

	var pageDots = createCommonjsModule(function (module) {
		// page dots
		(function (window, factory) {
			// universal module definition
			if (module.exports) {
				// CommonJS
				module.exports = factory(window, flickity, unipointer, utils);
			} else {
				// browser global
				factory(
					window,
					window.Flickity,
					window.Unipointer,
					window.fizzyUIUtils
				);
			}
		})(window, function factory(window, Flickity, Unipointer, utils) {
			function PageDots(parent) {
				this.parent = parent;
				this._create();
			}

			PageDots.prototype = Object.create(Unipointer.prototype);

			PageDots.prototype._create = function () {
				// create holder element
				this.holder = document.createElement("ol");
				this.holder.className = "flickity-page-dots";
				// create dots, array of elements
				this.dots = [];
				// events
				this.handleClick = this.onClick.bind(this);
				this.on(
					"pointerDown",
					this.parent.childUIPointerDown.bind(this.parent)
				);
			};

			PageDots.prototype.activate = function () {
				this.setDots();
				this.holder.addEventListener("click", this.handleClick);
				this.bindStartEvent(this.holder);
				// add to DOM
				this.parent.element.appendChild(this.holder);
			};

			PageDots.prototype.deactivate = function () {
				this.holder.removeEventListener("click", this.handleClick);
				this.unbindStartEvent(this.holder);
				// remove from DOM
				this.parent.element.removeChild(this.holder);
			};

			PageDots.prototype.setDots = function () {
				// get difference between number of slides and number of dots
				var delta = this.parent.slides.length - this.dots.length;
				if (delta > 0) {
					this.addDots(delta);
				} else if (delta < 0) {
					this.removeDots(-delta);
				}
			};

			PageDots.prototype.addDots = function (count) {
				var fragment = document.createDocumentFragment();
				var newDots = [];
				var length = this.dots.length;
				var max = length + count;

				for (var i = length; i < max; i++) {
					var dot = document.createElement("li");
					dot.className = "dot";
					dot.setAttribute("aria-label", "Page dot " + (i + 1));
					fragment.appendChild(dot);
					newDots.push(dot);
				}

				this.holder.appendChild(fragment);
				this.dots = this.dots.concat(newDots);
			};

			PageDots.prototype.removeDots = function (count) {
				// remove from this.dots collection
				var removeDots = this.dots.splice(this.dots.length - count, count);
				// remove from DOM
				removeDots.forEach(function (dot) {
					this.holder.removeChild(dot);
				}, this);
			};

			PageDots.prototype.updateSelected = function () {
				// remove selected class on previous
				if (this.selectedDot) {
					this.selectedDot.className = "dot";
					this.selectedDot.removeAttribute("aria-current");
				}
				// don't proceed if no dots
				if (!this.dots.length) {
					return;
				}
				this.selectedDot = this.dots[this.parent.selectedIndex];
				this.selectedDot.className = "dot is-selected";
				this.selectedDot.setAttribute("aria-current", "step");
			};

			PageDots.prototype.onTap = // old method name, backwards-compatible
				PageDots.prototype.onClick = function (event) {
					var target = event.target;
					// only care about dot clicks
					if (target.nodeName != "LI") {
						return;
					}

					this.parent.uiChange();
					var index = this.dots.indexOf(target);
					this.parent.select(index);
				};

			PageDots.prototype.destroy = function () {
				this.deactivate();
				this.allOff();
			};

			Flickity.PageDots = PageDots;

			// -------------------------- Flickity -------------------------- //

			utils.extend(Flickity.defaults, {
				pageDots: true,
			});

			Flickity.createMethods.push("_createPageDots");

			var proto = Flickity.prototype;

			proto._createPageDots = function () {
				if (!this.options.pageDots) {
					return;
				}
				this.pageDots = new PageDots(this);
				// events
				this.on("activate", this.activatePageDots);
				this.on("select", this.updateSelectedPageDots);
				this.on("cellChange", this.updatePageDots);
				this.on("resize", this.updatePageDots);
				this.on("deactivate", this.deactivatePageDots);
			};

			proto.activatePageDots = function () {
				this.pageDots.activate();
			};

			proto.updateSelectedPageDots = function () {
				this.pageDots.updateSelected();
			};

			proto.updatePageDots = function () {
				this.pageDots.setDots();
			};

			proto.deactivatePageDots = function () {
				this.pageDots.deactivate();
			};

			// -----  ----- //

			Flickity.PageDots = PageDots;

			return Flickity;
		});
	});

	var player = createCommonjsModule(function (module) {
		// player & autoPlay
		(function (window, factory) {
			// universal module definition
			if (module.exports) {
				// CommonJS
				module.exports = factory(evEmitter, utils, flickity);
			} else {
				// browser global
				factory(window.EvEmitter, window.fizzyUIUtils, window.Flickity);
			}
		})(window, function factory(EvEmitter, utils, Flickity) {
			// -------------------------- Player -------------------------- //

			function Player(parent) {
				this.parent = parent;
				this.state = "stopped";
				// visibility change event handler
				this.onVisibilityChange = this.visibilityChange.bind(this);
				this.onVisibilityPlay = this.visibilityPlay.bind(this);
			}

			Player.prototype = Object.create(EvEmitter.prototype);

			// start play
			Player.prototype.play = function () {
				if (this.state == "playing") {
					return;
				}
				// do not play if page is hidden, start playing when page is visible
				var isPageHidden = document.hidden;
				if (isPageHidden) {
					document.addEventListener("visibilitychange", this.onVisibilityPlay);
					return;
				}

				this.state = "playing";
				// listen to visibility change
				document.addEventListener("visibilitychange", this.onVisibilityChange);
				// start ticking
				this.tick();
			};

			Player.prototype.tick = function () {
				// do not tick if not playing
				if (this.state != "playing") {
					return;
				}

				var time = this.parent.options.autoPlay;
				// default to 3 seconds
				time = typeof time == "number" ? time : 3000;
				var _this = this;
				// HACK: reset ticks if stopped and started within interval
				this.clear();
				this.timeout = setTimeout(function () {
					_this.parent.next(true);
					_this.tick();
				}, time);
			};

			Player.prototype.stop = function () {
				this.state = "stopped";
				this.clear();
				// remove visibility change event
				document.removeEventListener(
					"visibilitychange",
					this.onVisibilityChange
				);
			};

			Player.prototype.clear = function () {
				clearTimeout(this.timeout);
			};

			Player.prototype.pause = function () {
				if (this.state == "playing") {
					this.state = "paused";
					this.clear();
				}
			};

			Player.prototype.unpause = function () {
				// re-start play if paused
				if (this.state == "paused") {
					this.play();
				}
			};

			// pause if page visibility is hidden, unpause if visible
			Player.prototype.visibilityChange = function () {
				var isPageHidden = document.hidden;
				this[isPageHidden ? "pause" : "unpause"]();
			};

			Player.prototype.visibilityPlay = function () {
				this.play();
				document.removeEventListener("visibilitychange", this.onVisibilityPlay);
			};

			// -------------------------- Flickity -------------------------- //

			utils.extend(Flickity.defaults, {
				pauseAutoPlayOnHover: true,
			});

			Flickity.createMethods.push("_createPlayer");
			var proto = Flickity.prototype;

			proto._createPlayer = function () {
				this.player = new Player(this);

				this.on("activate", this.activatePlayer);
				this.on("uiChange", this.stopPlayer);
				this.on("pointerDown", this.stopPlayer);
				this.on("deactivate", this.deactivatePlayer);
			};

			proto.activatePlayer = function () {
				if (!this.options.autoPlay) {
					return;
				}
				this.player.play();
				this.element.addEventListener("mouseenter", this);
			};

			// Player API, don't hate the ... thanks I know where the door is

			proto.playPlayer = function () {
				this.player.play();
			};

			proto.stopPlayer = function () {
				this.player.stop();
			};

			proto.pausePlayer = function () {
				this.player.pause();
			};

			proto.unpausePlayer = function () {
				this.player.unpause();
			};

			proto.deactivatePlayer = function () {
				this.player.stop();
				this.element.removeEventListener("mouseenter", this);
			};

			// ----- mouseenter/leave ----- //

			// pause auto-play on hover
			proto.onmouseenter = function () {
				if (!this.options.pauseAutoPlayOnHover) {
					return;
				}
				this.player.pause();
				this.element.addEventListener("mouseleave", this);
			};

			// resume auto-play on hover off
			proto.onmouseleave = function () {
				this.player.unpause();
				this.element.removeEventListener("mouseleave", this);
			};

			// -----  ----- //

			Flickity.Player = Player;

			return Flickity;
		});
	});

	var addRemoveCell = createCommonjsModule(function (module) {
		// add, remove cell
		(function (window, factory) {
			// universal module definition
			if (module.exports) {
				// CommonJS
				module.exports = factory(window, flickity, utils);
			} else {
				// browser global
				factory(window, window.Flickity, window.fizzyUIUtils);
			}
		})(window, function factory(window, Flickity, utils) {
			// append cells to a document fragment
			function getCellsFragment(cells) {
				var fragment = document.createDocumentFragment();
				cells.forEach(function (cell) {
					fragment.appendChild(cell.element);
				});
				return fragment;
			}

			// -------------------------- add/remove cell prototype -------------------------- //

			var proto = Flickity.prototype;

			/**
			 * Insert, prepend, or append cells
			 * @param {[Element, Array, NodeList]} elems - Elements to insert
			 * @param {Integer} index - Zero-based number to insert
			 */
			proto.insert = function (elems, index) {
				var cells = this._makeCells(elems);
				if (!cells || !cells.length) {
					return;
				}
				var len = this.cells.length;
				// default to append
				index = index === undefined ? len : index;
				// add cells with document fragment
				var fragment = getCellsFragment(cells);
				// append to slider
				var isAppend = index == len;
				if (isAppend) {
					this.slider.appendChild(fragment);
				} else {
					var insertCellElement = this.cells[index].element;
					this.slider.insertBefore(fragment, insertCellElement);
				}
				// add to this.cells
				if (index === 0) {
					// prepend, add to start
					this.cells = cells.concat(this.cells);
				} else if (isAppend) {
					// append, add to end
					this.cells = this.cells.concat(cells);
				} else {
					// insert in this.cells
					var endCells = this.cells.splice(index, len - index);
					this.cells = this.cells.concat(cells).concat(endCells);
				}

				this._sizeCells(cells);
				this.cellChange(index, true);
			};

			proto.append = function (elems) {
				this.insert(elems, this.cells.length);
			};

			proto.prepend = function (elems) {
				this.insert(elems, 0);
			};

			/**
			 * Remove cells
			 * @param {[Element, Array, NodeList]} elems - ELements to remove
			 */
			proto.remove = function (elems) {
				var cells = this.getCells(elems);
				if (!cells || !cells.length) {
					return;
				}

				var minCellIndex = this.cells.length - 1;
				// remove cells from collection & DOM
				cells.forEach(function (cell) {
					cell.remove();
					var index = this.cells.indexOf(cell);
					minCellIndex = Math.min(index, minCellIndex);
					utils.removeFrom(this.cells, cell);
				}, this);

				this.cellChange(minCellIndex, true);
			};

			/**
			 * logic to be run after a cell's size changes
			 * @param {Element} elem - cell's element
			 */
			proto.cellSizeChange = function (elem) {
				var cell = this.getCell(elem);
				if (!cell) {
					return;
				}
				cell.getSize();

				var index = this.cells.indexOf(cell);
				this.cellChange(index);
			};

			/**
			 * logic any time a cell is changed: added, removed, or size changed
			 * @param {Integer} changedCellIndex - index of the changed cell, optional
			 * @param {Boolean} isPositioningSlider - Positions slider after selection
			 */
			proto.cellChange = function (changedCellIndex, isPositioningSlider) {
				var prevSelectedElem = this.selectedElement;
				this._positionCells(changedCellIndex);
				this._getWrapShiftCells();
				this.setGallerySize();
				// update selectedIndex
				// try to maintain position & select previous selected element
				var cell = this.getCell(prevSelectedElem);
				if (cell) {
					this.selectedIndex = this.getCellSlideIndex(cell);
				}
				this.selectedIndex = Math.min(
					this.slides.length - 1,
					this.selectedIndex
				);

				this.emitEvent("cellChange", [changedCellIndex]);
				// position slider
				this.select(this.selectedIndex);
				// do not position slider after lazy load
				if (isPositioningSlider) {
					this.positionSliderAtSelected();
				}
			};

			// -----  ----- //

			return Flickity;
		});
	});

	var lazyload = createCommonjsModule(function (module) {
		// lazyload
		(function (window, factory) {
			// universal module definition
			if (module.exports) {
				// CommonJS
				module.exports = factory(window, flickity, utils);
			} else {
				// browser global
				factory(window, window.Flickity, window.fizzyUIUtils);
			}
		})(window, function factory(window, Flickity, utils) {
			Flickity.createMethods.push("_createLazyload");
			var proto = Flickity.prototype;

			proto._createLazyload = function () {
				this.on("select", this.lazyLoad);
			};

			proto.lazyLoad = function () {
				var lazyLoad = this.options.lazyLoad;
				if (!lazyLoad) {
					return;
				}
				// get adjacent cells, use lazyLoad option for adjacent count
				var adjCount = typeof lazyLoad == "number" ? lazyLoad : 0;
				var cellElems = this.getAdjacentCellElements(adjCount);
				// get lazy images in those cells
				var lazyImages = [];
				cellElems.forEach(function (cellElem) {
					var lazyCellImages = getCellLazyImages(cellElem);
					lazyImages = lazyImages.concat(lazyCellImages);
				});
				// load lazy images
				lazyImages.forEach(function (img) {
					new LazyLoader(img, this);
				}, this);
			};

			function getCellLazyImages(cellElem) {
				// check if cell element is lazy image
				if (cellElem.nodeName == "IMG") {
					var lazyloadAttr = cellElem.getAttribute("data-flickity-lazyload");
					var srcAttr = cellElem.getAttribute("data-flickity-lazyload-src");
					var srcsetAttr = cellElem.getAttribute(
						"data-flickity-lazyload-srcset"
					);
					if (lazyloadAttr || srcAttr || srcsetAttr) {
						return [cellElem];
					}
				}
				// select lazy images in cell
				var lazySelector =
					"img[data-flickity-lazyload], " +
					"img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]";
				var imgs = cellElem.querySelectorAll(lazySelector);
				return utils.makeArray(imgs);
			}

			// -------------------------- LazyLoader -------------------------- //

			/**
			 * class to handle loading images
			 * @param {Image} img - Image element
			 * @param {Flickity} flickity - Flickity instance
			 */
			function LazyLoader(img, flickity) {
				this.img = img;
				this.flickity = flickity;
				this.load();
			}

			LazyLoader.prototype.handleEvent = utils.handleEvent;

			LazyLoader.prototype.load = function () {
				this.img.addEventListener("load", this);
				this.img.addEventListener("error", this);
				// get src & srcset
				var src =
					this.img.getAttribute("data-flickity-lazyload") ||
					this.img.getAttribute("data-flickity-lazyload-src");
				var srcset = this.img.getAttribute("data-flickity-lazyload-srcset");
				// set src & serset
				this.img.src = src;
				if (srcset) {
					this.img.setAttribute("srcset", srcset);
				}
				// remove attr
				this.img.removeAttribute("data-flickity-lazyload");
				this.img.removeAttribute("data-flickity-lazyload-src");
				this.img.removeAttribute("data-flickity-lazyload-srcset");
			};

			LazyLoader.prototype.onload = function (event) {
				this.complete(event, "flickity-lazyloaded");
			};

			LazyLoader.prototype.onerror = function (event) {
				this.complete(event, "flickity-lazyerror");
			};

			LazyLoader.prototype.complete = function (event, className) {
				// unbind events
				this.img.removeEventListener("load", this);
				this.img.removeEventListener("error", this);

				var cell = this.flickity.getParentCell(this.img);
				var cellElem = cell && cell.element;
				this.flickity.cellSizeChange(cellElem);

				this.img.classList.add(className);
				this.flickity.dispatchEvent("lazyLoad", event, cellElem);
			};

			// -----  ----- //

			Flickity.LazyLoader = LazyLoader;

			return Flickity;
		});
	});

	var js = createCommonjsModule(function (module) {
		/*!
		 * Flickity v2.3.0
		 * Touch, responsive, flickable carousels
		 *
		 * Licensed GPLv3 for open source use
		 * or Flickity Commercial License for commercial use
		 *
		 * https://flickity.metafizzy.co
		 * Copyright 2015-2021 Metafizzy
		 */

		(function (window, factory) {
			// universal module definition
			if (module.exports) {
				// CommonJS
				module.exports = factory(
					flickity,
					drag,
					prevNextButton,
					pageDots,
					player,
					addRemoveCell,
					lazyload
				);
			}
		})(window, function factory(Flickity) {
			return Flickity;
		});
	});

	var ComplementaryProducts = /*#__PURE__*/ (function () {
		function ComplementaryProducts(options) {
			_classCallCheck(this, ComplementaryProducts);

			this.sectionEl = options.sectionEl;
			this.sectionId = options.sectionId;
			this.events = new EventHandler();
			this.productId = options.productId;
			this.includeIndicatorDots = options.includeIndicatorDots || false;
			this.recommendationsRoute = options.productRecommendationsRoute;
			this.limit = options.limit;
			var defaultArrowShape = {
				x0: 10,
				x1: 60,
				y1: 50,
				x2: 65,
				y2: 45,
				x3: 20,
			};
			this.arrowShape = options.arrowShape || defaultArrowShape;
			this.recommendationsEl = this.sectionEl.querySelector(
				"[data-complementary-products]"
			);
			this.loadRecommendations();
		}

		_createClass(ComplementaryProducts, [
			{
				key: "loadRecommendations",
				value: function loadRecommendations() {
					var _this = this;

					var url = ""
						.concat(this.recommendationsRoute, "?section_id=")
						.concat(this.sectionId, "&limit=")
						.concat(this.limit, "&product_id=")
						.concat(this.productId, "&intent=complementary");
					AsyncView.load(url, {
						view: "",
					}).then(function (_ref) {
						var html = _ref.html;
						if (_typeof(html) === "object" && Object.keys(html).length === 0)
							return;

						if (html.trim().length === 0) {
							_this.recommendationsEl.classList.add(
								"complementary-products--no-recommendations"
							);

							return;
						}

						_this.recommendationsEl.innerHTML = html;

						if (!index_es.instance) {
							index_es.init();
						}

						index_es.watch(_this.recommendationsEl);

						var slider = _this.recommendationsEl.querySelector("[data-slider]");

						var slides =
							_this.recommendationsEl.querySelectorAll("[data-slide]");

						if (slides.length > 1) {
							_this.slider = new js(slider, {
								cellSelector: "[data-slide]",
								accessibility: false,
								adaptiveHeight: false,
								autoPlay: false,
								cellAlign: "left",
								contain: true,
								imagesLoaded: true,
								pageDots: _this.includeIndicatorDots,
								wrapAround: true,
								arrowShape: _this.arrowShape,
							});

							_this.events.register(slider, "rimg:load", function () {
								_this.slider.resize();
							});
						}
					});
				},
			},
			{
				key: "unload",
				value: function unload() {
					this.slider.destroy();
				},
			},
		]);

		return ComplementaryProducts;
	})();

	/* harmony default export */ const dist_index_es = ComplementaryProducts; // CONCATENATED MODULE: ./node_modules/@pixelunion/shopify-surface-pick-up/dist/index.es.js

	const LOCAL_STORAGE_KEY = "pxu-shopify-surface-pick-up";
	const loadingClass = "surface-pick-up--loading";

	const isNotExpired = (timestamp) => timestamp + 1000 * 60 * 60 >= Date.now();

	const removeTrailingSlash = (s) => s.replace(/(.*)\/$/, "$1"); // Haversine Distance
	// The haversine formula is an equation giving great-circle distances between
	// two points on a sphere from their longitudes and latitudes

	function calculateDistance(
		latitude1,
		longitude1,
		latitude2,
		longitude2,
		unitSystem
	) {
		const dtor = Math.PI / 180;
		const radius = unitSystem === "metric" ? 6378.14 : 3959;
		const rlat1 = latitude1 * dtor;
		const rlong1 = longitude1 * dtor;
		const rlat2 = latitude2 * dtor;
		const rlong2 = longitude2 * dtor;
		const dlon = rlong1 - rlong2;
		const dlat = rlat1 - rlat2;
		const a =
			Math.sin(dlat / 2) ** 2 +
			Math.cos(rlat1) * Math.cos(rlat2) * Math.sin(dlon / 2) ** 2;
		const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
		return radius * c;
	}

	async function getGeoLocation() {
		return new Promise((resolve, reject) => {
			const options = {
				maximumAge: 3600000,
				// 1 hour
				timeout: 5000,
			};

			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition(
					({ coords }) => resolve(coords),
					reject,
					options
				);
			} else {
				reject();
			}
		});
	}

	async function setLocation({ latitude, longitude }) {
		const newData = {
			latitude,
			longitude,
			timestamp: Date.now(),
		};
		localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(newData));
		return fetch("/localization.json", {
			method: "PUT",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				latitude,
				longitude,
			}),
		}).then(() => ({
			latitude,
			longitude,
		}));
	}

	async function getLocation(requestLocation = false) {
		const cachedLocation = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));

		if (cachedLocation && isNotExpired(cachedLocation.timestamp)) {
			return cachedLocation;
		}

		if (requestLocation) {
			return getGeoLocation().then((coords) => {
				setLocation(coords); // We don't need to wait for this

				return coords;
			});
		}

		return null;
	}

	class SurfacePickUp {
		constructor(el, options) {
			this.el = el;
			const themeObj = window.PXUTheme || window.Theme;
			this.options = {
				root_url:
					(themeObj && themeObj.routes && themeObj.routes.root_url) || "",
				...options,
			};
			this.options.root_url = removeTrailingSlash(this.options.root_url);
			this.callbacks = [];
			this.onBtnPress = null;
			this.latestVariantId = null;
		}

		load(variantId) {
			// If no variant is available, empty element and quick-return
			if (!variantId) {
				this.el.innerHTML = "";
				return Promise.resolve(true);
			} // Because Shopify doesn't expose any `pick_up_enabled` data on the shop object, we
			// don't know if the variant might be, or is definitely not available for pick up.
			// Until we know the shop has > 0 pick up locations, we want to avoid prompting the
			// user for location data (it's annoying, and only makes sense to do if we use it).
			//
			// Instead, we have to make an initial request, check and see if any pick up locations
			// were returned, then ask for the users location, then make another request to get the
			// location-aware pick up locations.
			//
			// As far as I can tell the pick up aware locations differ only in sort order - which
			// we could do on the front end - but we're following this approach to ensure future
			// compatibility with any changes Shopify makes (maybe disabling options based on
			// user location, or whatever else).
			//
			// Shopify has indicated they will look into adding pick_up_enabled data to the shop
			// object, which which case this method can be greatly simplifed into 2 simple cases.

			this.latestVariantId = variantId;
			this.el.classList.add(loadingClass);
			return this._getData(variantId).then((data) => this._injectData(data));
		}

		onModalRequest(callback) {
			if (this.callbacks.indexOf(callback) >= 0) return;
			this.callbacks.push(callback);
		}

		offModalRequest(callback) {
			this.callbacks.splice(this.callbacks.indexOf(callback));
		}

		unload() {
			this.callbacks = [];
			this.el.innerHTML = "";
		}

		_getData(variantId) {
			return new Promise((resolve) => {
				const xhr = new XMLHttpRequest();
				const requestUrl = `${this.options.root_url}/variants/${variantId}/?section_id=surface-pick-up`;
				xhr.open("GET", requestUrl, true);

				xhr.onload = () => {
					const el = xhr.response;
					const embed = el.querySelector('[data-html="surface-pick-up-embed"]');
					const itemsContainer = el.querySelector(
						'[data-html="surface-pick-up-items"]'
					);
					const items = itemsContainer.content.querySelectorAll(
						"[data-surface-pick-up-item]"
					);
					resolve({
						embed,
						itemsContainer,
						items,
						variantId,
					});
				};

				xhr.onerror = () => {
					resolve({
						embed: {
							innerHTML: "",
						},
						itemsContainer: {
							innerHTML: "",
						},
						items: [],
						variantId,
					});
				};

				xhr.responseType = "document";
				xhr.send();
			});
		}

		_injectData({ embed, itemsContainer, items, variantId }) {
			if (variantId !== this.latestVariantId || items.length === 0) {
				this.el.innerHTML = "";
				this.el.classList.remove(loadingClass);
				return;
			}

			this.el.innerHTML = embed.innerHTML;
			this.el.classList.remove(loadingClass);
			let calculatedDistances = false;

			const calculateDistances = () => {
				if (calculatedDistances) return Promise.resolve();
				return getLocation(true)
					.then((coords) => {
						items.forEach((item) => {
							const distanceEl = item.querySelector("[data-distance]");
							const distanceUnitEl = item.querySelector("[data-distance-unit]");
							const unitSystem = distanceUnitEl.dataset.distanceUnit;
							const itemLatitude = parseFloat(distanceEl.dataset.latitude);
							const itemLongitude = parseFloat(distanceEl.dataset.longitude);

							if (coords && isFinite(itemLatitude) && isFinite(itemLongitude)) {
								const distance = calculateDistance(
									coords.latitude,
									coords.longitude,
									itemLatitude,
									itemLongitude,
									unitSystem
								);
								distanceEl.innerHTML = distance.toFixed(1);
							} else {
								distanceEl.remove();
								distanceUnitEl.remove();
							}
						});
					})
					.catch((e) => {
						console.log(e);
						items.forEach((item) => {
							const distanceEl = item.querySelector("[data-distance]");
							const distanceUnitEl = item.querySelector("[data-distance-unit]");
							distanceEl.remove();
							distanceUnitEl.remove();
						});
					})
					.finally(() => {
						calculatedDistances = true;
					});
			};

			this.el
				.querySelector("[data-surface-pick-up-embed-modal-btn]")
				.addEventListener("click", () => {
					calculateDistances().then(() =>
						this.callbacks.forEach((callback) =>
							callback(itemsContainer.innerHTML)
						)
					);
				});
		}
	}

	/* harmony default export */ const shopify_surface_pick_up_dist_index_es =
		SurfacePickUp; // CONCATENATED MODULE: ./node_modules/@pixelunion/shopify-price-ui/dist/index.es.js

	function index_es_classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}

	function index_es_defineProperties(target, props) {
		for (var i = 0; i < props.length; i++) {
			var descriptor = props[i];
			descriptor.enumerable = descriptor.enumerable || false;
			descriptor.configurable = true;
			if ("value" in descriptor) descriptor.writable = true;
			Object.defineProperty(target, descriptor.key, descriptor);
		}
	}

	function index_es_createClass(Constructor, protoProps, staticProps) {
		if (protoProps)
			index_es_defineProperties(Constructor.prototype, protoProps);
		if (staticProps) index_es_defineProperties(Constructor, staticProps);
		return Constructor;
	}

	function index_es_defineProperty(obj, key, value) {
		if (key in obj) {
			Object.defineProperty(obj, key, {
				value: value,
				enumerable: true,
				configurable: true,
				writable: true,
			});
		} else {
			obj[key] = value;
		}

		return obj;
	}

	function index_es_ownKeys(object, enumerableOnly) {
		var keys = Object.keys(object);

		if (Object.getOwnPropertySymbols) {
			var symbols = Object.getOwnPropertySymbols(object);
			if (enumerableOnly)
				symbols = symbols.filter(function (sym) {
					return Object.getOwnPropertyDescriptor(object, sym).enumerable;
				});
			keys.push.apply(keys, symbols);
		}

		return keys;
	}

	function index_es_objectSpread2(target) {
		for (var i = 1; i < arguments.length; i++) {
			var source = arguments[i] != null ? arguments[i] : {};

			if (i % 2) {
				index_es_ownKeys(Object(source), true).forEach(function (key) {
					index_es_defineProperty(target, key, source[key]);
				});
			} else if (Object.getOwnPropertyDescriptors) {
				Object.defineProperties(
					target,
					Object.getOwnPropertyDescriptors(source)
				);
			} else {
				index_es_ownKeys(Object(source)).forEach(function (key) {
					Object.defineProperty(
						target,
						key,
						Object.getOwnPropertyDescriptor(source, key)
					);
				});
			}
		}

		return target;
	}

	var priceUITemplate = document.getElementById("price-ui").content;
	var priceTemplate = document.getElementById("price-ui__price").content;
	var priceRangeTemplate = document.getElementById(
		"price-ui__price-range"
	).content;
	var unitPriceTemplate = document.getElementById(
		"price-ui__unit-pricing"
	).content;

	function createPriceRangeFragment(priceMin, priceMax, formatter) {
		var priceRangeFragment = priceRangeTemplate.cloneNode(true);
		priceRangeFragment.querySelector(
			"[data-price-min] [data-price]"
		).innerHTML = formatter(priceMin);
		priceRangeFragment.querySelector(
			"[data-price-max] [data-price]"
		).innerHTML = formatter(priceMax);
		return priceRangeFragment;
	}

	function createPriceFragment(price, formatter) {
		var priceFragment = priceTemplate.cloneNode(true);
		priceFragment.querySelector("[data-price]").innerHTML = formatter(price);
		return priceFragment;
	}

	function createUnitPricing(variant, formatter) {
		var unitPriceContainer = unitPriceTemplate.cloneNode(true);
		var unitQuantityEl = unitPriceContainer.querySelector(
			"[data-unit-quantity]"
		);
		var unitPriceEl = unitPriceContainer.querySelector(
			"[data-unit-price] [data-price]"
		);
		var unitMeasurementEl = unitPriceContainer.querySelector(
			"[data-unit-measurement]"
		);
		unitQuantityEl.innerHTML = ""
			.concat(variant.unit_price_measurement.quantity_value)
			.concat(variant.unit_price_measurement.quantity_unit);
		unitPriceEl.innerHTML = formatter(variant.unit_price);

		if (variant.unit_price_measurement.reference_value === 1) {
			unitMeasurementEl.innerHTML =
				variant.unit_price_measurement.reference_unit;
		} else {
			unitMeasurementEl.innerHTML = ""
				.concat(variant.unit_price_measurement.reference_value)
				.concat(variant.unit_price_measurement.reference_unit);
		}

		return unitPriceContainer;
	}

	var PriceUI = /*#__PURE__*/ (function () {
		function PriceUI(el) {
			index_es_classCallCheck(this, PriceUI);

			this._el = el;
		}

		index_es_createClass(PriceUI, [
			{
				key: "load",
				value: function load(product, options) {
					var _variant$formatter$ha = index_es_objectSpread2(
							{
								variant: false,
								formatter: function formatter(price) {
									return price;
								},
								handler: function handler(priceUIFragment) {
									return priceUIFragment;
								},
							},
							options
						),
						variant = _variant$formatter$ha.variant,
						formatter = _variant$formatter$ha.formatter,
						handler = _variant$formatter$ha.handler;

					this._el.classList.add("price-ui--loading");

					var priceUIFragment = handler(
						!variant
							? this._loadProduct(product, formatter)
							: this._loadVariant(variant, formatter),
						product,
						options
					);
					this._el.innerHTML = "";

					this._el.appendChild(priceUIFragment);

					this._el.classList.remove("price-ui--loading");
				},
			},
			{
				key: "_loadVariant",
				value: function _loadVariant(variant, formatter) {
					var priceUIFragment = priceUITemplate.cloneNode(true);
					var compareAtPriceEl = priceUIFragment.querySelector(
						"[data-compare-at-price]"
					);
					var priceEl = priceUIFragment.querySelector("[data-price]");
					var unitPricingEl = priceUIFragment.querySelector(
						"[data-unit-pricing]"
					);
					var isOnSale =
						variant.compare_at_price &&
						variant.compare_at_price !== variant.price;

					if (isOnSale) {
						priceEl.classList.add("price--sale");

						var _priceFragment = createPriceFragment(
							variant.compare_at_price,
							formatter
						);

						compareAtPriceEl.appendChild(_priceFragment);
					}

					var priceFragment = createPriceFragment(variant.price, formatter);
					priceEl.appendChild(priceFragment);

					if ("unit_price" in variant) {
						var unitPricingFragment = createUnitPricing(variant, formatter);
						unitPricingEl.appendChild(unitPricingFragment);
					}

					return priceUIFragment;
				},
			},
			{
				key: "_loadProduct",
				value: function _loadProduct(product, formatter) {
					var priceMin = null;
					var priceMax = null;
					var compareAtPriceMin = null;
					var compareAtPriceMax = null;
					var priceVaries = false;
					var compareAtPriceVaries = false;
					var isOnSale = false;
					product.variants.forEach(function (variant) {
						// Use variant price as compare_at_price if compare_at_price is unavailable
						var tmpCompareAtPrice = variant.compare_at_price
							? variant.compare_at_price
							: variant.price; // Determine price min

						if (priceMin === null || variant.price < priceMin) {
							priceMin = variant.price;
						} // Determine price max

						if (priceMax === null || variant.price > priceMax) {
							priceMax = variant.price;
						} // Determine compare_at_price min

						if (
							compareAtPriceMin === null ||
							tmpCompareAtPrice < compareAtPriceMin
						) {
							compareAtPriceMin = tmpCompareAtPrice;
						} // Determine compare_at_price max

						if (
							compareAtPriceMax === null ||
							tmpCompareAtPrice > compareAtPriceMax
						) {
							compareAtPriceMax = tmpCompareAtPrice;
						}

						if (tmpCompareAtPrice !== variant.price) {
							isOnSale = true;
						}
					});
					priceVaries = priceMin !== priceMax;
					compareAtPriceVaries = compareAtPriceMin !== compareAtPriceMax;
					var priceUIFragment = priceUITemplate.cloneNode(true);
					var compareAtPriceEl = priceUIFragment.querySelector(
						"[data-compare-at-price]"
					);
					var priceEl = priceUIFragment.querySelector("[data-price]");

					if (isOnSale) {
						priceEl.classList.add("price--sale");

						if (compareAtPriceVaries) {
							var priceRangeFragment = createPriceRangeFragment(
								compareAtPriceMin,
								compareAtPriceMax,
								formatter
							);
							compareAtPriceEl.appendChild(priceRangeFragment);
						} else {
							var priceFragment = createPriceFragment(
								compareAtPriceMin,
								formatter
							);
							compareAtPriceEl.appendChild(priceFragment);
						}
					}

					if (priceVaries) {
						var _priceRangeFragment = createPriceRangeFragment(
							priceMin,
							priceMax,
							formatter
						);

						priceEl.appendChild(_priceRangeFragment);
					} else {
						var _priceFragment2 = createPriceFragment(priceMin, formatter);

						priceEl.appendChild(_priceFragment2);
					}

					return priceUIFragment;
				},
			},
		]);

		return PriceUI;
	})();

	var priceUIBadgeTemplate = document.getElementById("price-ui-badge").content;
	var badgePercentSavingsTemplate = document.getElementById(
		"price-ui-badge__percent-savings"
	).content;
	var badgePercentSavingsRangeTemplate = document.getElementById(
		"price-ui-badge__percent-savings-range"
	).content;
	var badgeSavingsTemplate = document.getElementById(
		"price-ui-badge__price-savings"
	).content;
	var badgeSavingsRangeTemplate = document.getElementById(
		"price-ui-badge__price-savings-range"
	).content;
	var badgeOnSaleTemplate = document.getElementById(
		"price-ui-badge__on-sale"
	).content;
	var badgeSoldOutTemplate = document.getElementById(
		"price-ui-badge__sold-out"
	).content;
	var badgeInStockTemplate = document.getElementById(
		"price-ui-badge__in-stock"
	).content;

	function createBadgeRangeFragment(savings, percent, style, formatter) {
		var badgeRangeFragment = null;

		switch (style) {
			case "percent":
				badgeRangeFragment = badgePercentSavingsRangeTemplate.cloneNode(true);
				badgeRangeFragment.querySelector("[data-price-percent]").innerHTML =
					percent;
				break;

			case "money":
				badgeRangeFragment = badgeSavingsRangeTemplate.cloneNode(true);
				badgeRangeFragment.querySelector("[data-price]").innerHTML =
					formatter(savings);
				break;

			default:
				badgeRangeFragment = badgeOnSaleTemplate.cloneNode(true);
				break;
		}

		return badgeRangeFragment;
	}

	function createBadgeSingleFragment(savings, percent, style, formatter) {
		var badgeSingleFragment = null;

		switch (style) {
			case "percent":
				badgeSingleFragment = badgePercentSavingsTemplate.cloneNode(true);
				badgeSingleFragment.querySelector("[data-price-percent]").innerHTML =
					percent;
				break;

			case "money":
				badgeSingleFragment = badgeSavingsTemplate.cloneNode(true);
				badgeSingleFragment.querySelector("[data-price]").innerHTML =
					formatter(savings);
				break;

			default:
				badgeSingleFragment = badgeOnSaleTemplate.cloneNode(true);
				break;
		}

		return badgeSingleFragment;
	}

	var PriceUIBadge = /*#__PURE__*/ (function () {
		function PriceUIBadge(el) {
			index_es_classCallCheck(this, PriceUIBadge);

			this._el = el;
		}

		index_es_createClass(PriceUIBadge, [
			{
				key: "load",
				value: function load(product, options) {
					var _variant$style$format = index_es_objectSpread2(
							{
								variant: false,
								style: "percent",
								formatter: function formatter(price) {
									return price;
								},
								handler: function handler(priceUIFragment) {
									return priceUIFragment;
								},
							},
							options
						),
						variant = _variant$style$format.variant,
						style = _variant$style$format.style,
						formatter = _variant$style$format.formatter,
						handler = _variant$style$format.handler;

					this._el.classList.add("price-ui-badge--loading");

					var priceUIBadgeFragment = handler(
						!variant
							? this._loadProduct(product, style, formatter)
							: this._loadVariant(variant, style, formatter),
						product,
						options
					);
					this._el.innerHTML = "";

					this._el.appendChild(priceUIBadgeFragment);

					this._el.classList.remove("price-ui-badge--loading");
				},
			},
			{
				key: "_loadVariant",
				value: function _loadVariant(variant, style, formatter) {
					var priceUIBadgeFragment = priceUIBadgeTemplate.cloneNode(true);
					var badgeEl = priceUIBadgeFragment.querySelector("[data-badge]");
					var isOnSale =
						variant.compare_at_price &&
						variant.compare_at_price !== variant.price;

					if (!isOnSale) {
						var badgeInStockFragment = badgeInStockTemplate.cloneNode(true);
						badgeEl.appendChild(badgeInStockFragment);
						return priceUIBadgeFragment; // Fast return if it's not on sale
					}

					if (!variant.available) {
						var badgeSoldOutFragment = badgeSoldOutTemplate.cloneNode(true);
						badgeEl.appendChild(badgeSoldOutFragment);
					} else {
						var savings = variant.compare_at_price - variant.price; // Round percent to two decimal places

						var percent = Math.round(
							(savings / variant.compare_at_price) * 100
						);
						var badgeSingleFragment = createBadgeSingleFragment(
							savings,
							percent,
							style,
							formatter
						);
						badgeEl.appendChild(badgeSingleFragment);
					}

					return priceUIBadgeFragment;
				},
			},
			{
				key: "_loadProduct",
				value: function _loadProduct(product, style, formatter) {
					var isOnSale = false;
					var savingsVaries = false;
					var largestSavings = -1;
					var largestPercentSavings = 0;
					product.variants.forEach(function (variant) {
						var tmpCompareAtPrice = variant.compare_at_price;

						if (!variant.compare_at_price) {
							tmpCompareAtPrice = variant.price;
						}

						var tmpSavings = tmpCompareAtPrice - variant.price;

						if (largestSavings !== 0 && tmpSavings !== largestSavings) {
							savingsVaries = true;
						}

						if (tmpSavings > 0) {
							isOnSale = true;

							if (tmpSavings > largestSavings) {
								largestSavings = tmpSavings;
								largestPercentSavings = tmpSavings / tmpCompareAtPrice;
							}
						}
					}); // Converts from a number out of 1, to a number out of 100 rounded to two decimals

					largestPercentSavings = Math.round(largestPercentSavings * 100);
					var priceUIBadgeFragment = priceUIBadgeTemplate.cloneNode(true);
					var badgeEl = priceUIBadgeFragment.querySelector("[data-badge]");

					if (!isOnSale) {
						var badgeInStockFragment = badgeInStockTemplate.cloneNode(true);
						badgeEl.appendChild(badgeInStockFragment);
						return priceUIBadgeFragment; // Fast return if it's not on sale
					}

					if (savingsVaries) {
						var badgeRangeFragment = createBadgeRangeFragment(
							largestSavings,
							largestPercentSavings,
							style,
							formatter
						);
						badgeEl.appendChild(badgeRangeFragment);
					} else {
						var badgeSingleFragment = createBadgeSingleFragment(
							largestSavings,
							largestPercentSavings,
							style,
							formatter
						);
						badgeEl.appendChild(badgeSingleFragment);
					}

					return priceUIBadgeFragment;
				},
			},
		]);

		return PriceUIBadge;
	})(); // CONCATENATED MODULE: ./node_modules/@pixelunion/shopify-asyncview/dist/index.es.js

	/*!
	 * @pixelunion/shopify-asyncview v2.0.5
	 * (c) 2020 Pixel Union
	 */

	function dist_index_es_classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}

	function dist_index_es_defineProperties(target, props) {
		for (var i = 0; i < props.length; i++) {
			var descriptor = props[i];
			descriptor.enumerable = descriptor.enumerable || false;
			descriptor.configurable = true;
			if ("value" in descriptor) descriptor.writable = true;
			Object.defineProperty(target, descriptor.key, descriptor);
		}
	}

	function dist_index_es_createClass(Constructor, protoProps, staticProps) {
		if (protoProps)
			dist_index_es_defineProperties(Constructor.prototype, protoProps);
		if (staticProps) dist_index_es_defineProperties(Constructor, staticProps);
		return Constructor;
	}

	function dist_index_es_defineProperty(obj, key, value) {
		if (key in obj) {
			Object.defineProperty(obj, key, {
				value: value,
				enumerable: true,
				configurable: true,
				writable: true,
			});
		} else {
			obj[key] = value;
		}

		return obj;
	}

	function dist_index_es_ownKeys(object, enumerableOnly) {
		var keys = Object.keys(object);

		if (Object.getOwnPropertySymbols) {
			var symbols = Object.getOwnPropertySymbols(object);
			if (enumerableOnly)
				symbols = symbols.filter(function (sym) {
					return Object.getOwnPropertyDescriptor(object, sym).enumerable;
				});
			keys.push.apply(keys, symbols);
		}

		return keys;
	}

	function dist_index_es_objectSpread2(target) {
		for (var i = 1; i < arguments.length; i++) {
			var source = arguments[i] != null ? arguments[i] : {};

			if (i % 2) {
				dist_index_es_ownKeys(Object(source), true).forEach(function (key) {
					dist_index_es_defineProperty(target, key, source[key]);
				});
			} else if (Object.getOwnPropertyDescriptors) {
				Object.defineProperties(
					target,
					Object.getOwnPropertyDescriptors(source)
				);
			} else {
				dist_index_es_ownKeys(Object(source)).forEach(function (key) {
					Object.defineProperty(
						target,
						key,
						Object.getOwnPropertyDescriptor(source, key)
					);
				});
			}
		}

		return target;
	}

	function index_es_slicedToArray(arr, i) {
		return (
			index_es_arrayWithHoles(arr) ||
			index_es_iterableToArrayLimit(arr, i) ||
			index_es_unsupportedIterableToArray(arr, i) ||
			index_es_nonIterableRest()
		);
	}

	function index_es_arrayWithHoles(arr) {
		if (Array.isArray(arr)) return arr;
	}

	function index_es_iterableToArrayLimit(arr, i) {
		if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr)))
			return;
		var _arr = [];
		var _n = true;
		var _d = false;
		var _e = undefined;

		try {
			for (
				var _i = arr[Symbol.iterator](), _s;
				!(_n = (_s = _i.next()).done);
				_n = true
			) {
				_arr.push(_s.value);

				if (i && _arr.length === i) break;
			}
		} catch (err) {
			_d = true;
			_e = err;
		} finally {
			try {
				if (!_n && _i["return"] != null) _i["return"]();
			} finally {
				if (_d) throw _e;
			}
		}

		return _arr;
	}

	function index_es_unsupportedIterableToArray(o, minLen) {
		if (!o) return;
		if (typeof o === "string") return index_es_arrayLikeToArray(o, minLen);
		var n = Object.prototype.toString.call(o).slice(8, -1);
		if (n === "Object" && o.constructor) n = o.constructor.name;
		if (n === "Map" || n === "Set") return Array.from(n);
		if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
			return index_es_arrayLikeToArray(o, minLen);
	}

	function index_es_arrayLikeToArray(arr, len) {
		if (len == null || len > arr.length) len = arr.length;

		for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

		return arr2;
	}

	function index_es_nonIterableRest() {
		throw new TypeError(
			"Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
		);
	}

	var index_es_deferred = {};

	var index_es_AsyncView = /*#__PURE__*/ (function () {
		function AsyncView() {
			dist_index_es_classCallCheck(this, AsyncView);
		}

		dist_index_es_createClass(AsyncView, null, [
			{
				key: "load",

				/**
				 * Load the template given by the provided URL into the provided
				 * view
				 *
				 * @param {string} url - The url to load
				 * @param {object} query - An object containing additional query parameters of the URL
				 * @param {string} query.view - A required query parameter indicating which view to load
				 * @param {object} [options] - Config options
				 * @param {string} [options.hash] - A hash of the current page content
				 */
				value: function load(url) {
					var query =
						arguments.length > 1 && arguments[1] !== undefined
							? arguments[1]
							: {};
					var options =
						arguments.length > 2 && arguments[2] !== undefined
							? arguments[2]
							: {};

					if (!("view" in query)) {
						return Promise.reject(
							new Error("'view' not found in 'query' parameter")
						);
					}

					var querylessUrl = url.replace(/\?[^#]+/, "");
					var queryParamsString = new RegExp(/.+\?([^#]+)/).exec(url);
					var queryParams = query;

					if (queryParamsString && queryParamsString.length >= 2) {
						queryParamsString[1].split("&").forEach(function (param) {
							var _param$split = param.split("="),
								_param$split2 = index_es_slicedToArray(_param$split, 2),
								key = _param$split2[0],
								value = _param$split2[1];

							queryParams[key] = value;
						});
					} // NOTE: We're adding an additional timestamp to the query.
					// This is to prevent certain browsers from returning cached
					// versions of the url we are requesting.
					// See this PR for more info: https://github.com/pixelunion/shopify-asyncview/pull/4

					var cachebustingParams = dist_index_es_objectSpread2(
						{},
						queryParams,
						{
							_: new Date().getTime(),
						}
					);

					var hashUrl = querylessUrl.replace(
						/([^#]+)(.*)/,
						function (match, address, hash) {
							return ""
								.concat(address, "?")
								.concat(
									Object.keys(queryParams)
										.sort()
										.map(function (key) {
											return ""
												.concat(key, "=")
												.concat(encodeURIComponent(queryParams[key]));
										})
										.join("&")
								)
								.concat(hash);
						}
					);
					var requestUrl = querylessUrl.replace(
						/([^#]+)(.*)/,
						function (match, address, hash) {
							return ""
								.concat(address, "?")
								.concat(
									Object.keys(cachebustingParams)
										.sort()
										.map(function (key) {
											return ""
												.concat(key, "=")
												.concat(encodeURIComponent(cachebustingParams[key]));
										})
										.join("&")
								)
								.concat(hash);
						}
					);
					var promise = new Promise(function (resolve, reject) {
						var data;

						if (hashUrl in index_es_deferred) {
							resolve(index_es_deferred[hashUrl]);
							return;
						}

						index_es_deferred[hashUrl] = promise;

						if (options.hash) {
							data = sessionStorage.getItem(hashUrl);

							if (data) {
								var deserialized = JSON.parse(data);

								if (options.hash === deserialized.options.hash) {
									delete index_es_deferred[hashUrl];
									resolve(deserialized);
									return;
								}
							}
						}

						var xhr = new XMLHttpRequest();
						xhr.open("GET", requestUrl, true);

						xhr.onload = function () {
							var el = xhr.response;
							var newOptions = {};
							var optionsEl = el.querySelector("[data-options]");

							if (optionsEl && optionsEl.innerHTML) {
								newOptions = JSON.parse(
									el.querySelector("[data-options]").innerHTML
								);
							}

							var htmlEls = el.querySelectorAll("[data-html]");
							var newHtml = {};

							if (
								htmlEls.length === 1 &&
								htmlEls[0].getAttribute("data-html") === ""
							) {
								newHtml = htmlEls[0].innerHTML;
							} else {
								for (var i = 0; i < htmlEls.length; i++) {
									newHtml[htmlEls[i].getAttribute("data-html")] =
										htmlEls[i].innerHTML;
								}
							}

							var dataEls = el.querySelectorAll("[data-data]");
							var newData = {};

							if (
								dataEls.length === 1 &&
								dataEls[0].getAttribute("data-data") === ""
							) {
								newData = JSON.parse(dataEls[0].innerHTML);
							} else {
								for (var _i = 0; _i < dataEls.length; _i++) {
									newData[dataEls[_i].getAttribute("data-data")] = JSON.parse(
										dataEls[_i].innerHTML
									);
								}
							}

							if (options.hash) {
								try {
									sessionStorage.setItem(
										hashUrl,
										JSON.stringify({
											options: newOptions,
											data: newData,
											html: newHtml,
										})
									);
								} catch (error) {
									console.error(error);
								}
							}

							delete index_es_deferred[hashUrl];
							resolve({
								data: newData,
								html: newHtml,
							});
						};

						xhr.onerror = function () {
							delete index_es_deferred[hashUrl];
							reject();
						};

						xhr.responseType = "document";
						xhr.send();
					});
					return promise;
				},
			},
		]);

		return AsyncView;
	})();

	/* harmony default export */ const shopify_asyncview_dist_index_es =
		index_es_AsyncView; // CONCATENATED MODULE: ./node_modules/@pixelunion/pxs-gift-card-recipient-form/dist/index.es.js

	/*!
	 * @pixelunion/pxs-gift-card-recipient-form v1.1.0
	 * (c) 2024 Pixel Union
	 */

	function index_es_unwrapExports(x) {
		return x &&
			x.__esModule &&
			Object.prototype.hasOwnProperty.call(x, "default")
			? x["default"]
			: x;
	}

	function index_es_createCommonjsModule(fn, module) {
		return (
			(module = { exports: {} }), fn(module, module.exports), module.exports
		);
	}

	var index_es_EventHandler_1 = index_es_createCommonjsModule(function (
		module,
		exports
	) {
		exports.__esModule = true;
		var EventHandler = /** @class */ (function () {
			function EventHandler() {
				this.events = [];
			}
			EventHandler.prototype.register = function (el, event, listener) {
				if (!el || !event || !listener) return null;
				this.events.push({ el: el, event: event, listener: listener });
				el.addEventListener(event, listener);
				return { el: el, event: event, listener: listener };
			};
			EventHandler.prototype.unregister = function (_a) {
				var el = _a.el,
					event = _a.event,
					listener = _a.listener;
				if (!el || !event || !listener) return null;
				this.events = this.events.filter(function (e) {
					return el !== e.el || event !== e.event || listener !== e.listener;
				});
				el.removeEventListener(event, listener);
				return { el: el, event: event, listener: listener };
			};
			EventHandler.prototype.unregisterAll = function () {
				this.events.forEach(function (_a) {
					var el = _a.el,
						event = _a.event,
						listener = _a.listener;
					return el.removeEventListener(event, listener);
				});
				this.events = [];
			};
			return EventHandler;
		})();
		exports["default"] = EventHandler;
	});

	var index_es_EventHandler = index_es_unwrapExports(index_es_EventHandler_1);

	/*!
	 * @pixelunion/animations v0.1.0
	 * (c) 2019 Pixel Union
	 * Released under the UNLICENSED license.
	 */

	function pxs_gift_card_recipient_form_dist_index_es_classCallCheck(
		instance,
		Constructor
	) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}

	function pxs_gift_card_recipient_form_dist_index_es_defineProperties(
		target,
		props
	) {
		for (var i = 0; i < props.length; i++) {
			var descriptor = props[i];
			descriptor.enumerable = descriptor.enumerable || false;
			descriptor.configurable = true;
			if ("value" in descriptor) descriptor.writable = true;
			Object.defineProperty(target, descriptor.key, descriptor);
		}
	}

	function pxs_gift_card_recipient_form_dist_index_es_createClass(
		Constructor,
		protoProps,
		staticProps
	) {
		if (protoProps)
			pxs_gift_card_recipient_form_dist_index_es_defineProperties(
				Constructor.prototype,
				protoProps
			);
		if (staticProps)
			pxs_gift_card_recipient_form_dist_index_es_defineProperties(
				Constructor,
				staticProps
			);
		return Constructor;
	}

	/**
	 * Promisified version of window.requestAnimationFrame.
	 * @returns {Promise} Promise will resolve when requestAnimationFrame callback is run.
	 */
	function raf() {
		return new Promise(function (resolve) {
			window.requestAnimationFrame(resolve);
		});
	}
	/**
	 * Represents an HTML element with associate states
	 */

	var Animation =
		/*#__PURE__*/
		(function () {
			/**
			 * @param {Object} options
			 * @param {HTMLElement}  options.el Target element
			 * @param {String} [options.state=initial] Initial state. This is also the default state.
			 * @param {String} [options.stateAttribute=data-revealer] Attribute name to update with state.
			 * @param {String} [options.stateChangeAttribute=data-revealer-transition] Attribute name to
			 * update with change of state.
			 * @param {String} [options.endEvent=transitionend] Event to listen for at end of state change.
			 * @param {Boolean} [options.hold=false] If true, changeAttribute will not be removed until the
			 * next state change.
			 * @param {Function} [options.onStart] Callback to execute immediate after
			 * applying stateChangeAttribute.
			 */
			function Animation(options) {
				pxs_gift_card_recipient_form_dist_index_es_classCallCheck(
					this,
					Animation
				);

				this._el = options.el;
				this.cancelRunning = null;
				this._state = options.state || "initial";
				this.initialState = this._state;
				this.stateAttribute = options.stateAttribute || "data-animation-state";
				this.stateChangeAttribute =
					options.stateChangeAttribute || "data-animation";
				this.endEvent = options.endEvent || "transitionend";
				this.hold = !!options.hold;

				this.onStart =
					options.onStart ||
					function () {
						/* do nothing */
					};

				this.activeEventHandler = null;
			}
			/**
			 * Returns target element
			 *
			 * @return {HTMLElement} Target element
			 */

			pxs_gift_card_recipient_form_dist_index_es_createClass(Animation, [
				{
					key: "isState",

					/**
					 * Check if a state is active
					 * @param {String} state State to compare
					 *
					 * @return {Boolean}
					 */
					value: function isState(state) {
						return state === this._state;
					},
					/**
					 * Sequences a change to a new state.
					 * @param {String} state Target state
					 *
					 * @param {Boolean} options.force Switch to final state immediately
					 *
					 * @param {Function} options.onStart Callback to execute immediately after
					 * applying stateChangeAttribute for this state change only.
					 *
					 * @param {Boolean} [options.hold=false] If true, changeAttribute will not be removed until the
					 * next state change.
					 *
					 * @return {Promise} Resolves when endEvent triggered
					 */
				},
				{
					key: "animateTo",
					value: function animateTo(state) {
						var _this = this;

						var options =
							arguments.length > 1 && arguments[1] !== undefined
								? arguments[1]
								: {};
						var from = this._el.dataset[this.stateAttribute] || this._state;
						var to = state || this.initialState;
						var force = options.force;
						var hold = "hold" in options ? options.hold : this.hold;
						return new Promise(function (resolve) {
							if (_this.cancelRunning) {
								_this.cancelRunning();
							}

							if (from === to) {
								// Removing this here fixes some lingering attributes. But why?
								_this._el.removeAttribute(_this.stateChangeAttribute);

								resolve(from, null);
								return;
							}

							var running = true;

							_this.cancelRunning = function () {
								running = false;
								resolve(null, null);
							};

							_this._el.removeEventListener(
								_this.endEvent,
								_this.activeEventHandler
							);

							_this.activeEventHandler = null;

							if (force) {
								_this._el.setAttribute(
									_this.stateChangeAttribute,
									"".concat(from, "=>").concat(to)
								);

								_this.onStart({
									el: _this._el,
									from: from,
									to: to,
								});

								if (typeof options.onStart === "function") {
									options.onStart({
										el: _this._el,
										from: from,
										to: to,
									});
								}

								_this._el.setAttribute(_this.stateAttribute, to);

								_this._state = to;

								if (!hold) {
									_this._el.removeAttribute(_this.stateChangeAttribute);
								}

								resolve(to, null);
								return;
							}

							raf()
								.then(function () {
									if (!running) throw new Error("cancelled");

									_this._el.setAttribute(
										_this.stateChangeAttribute,
										"".concat(from, "=>").concat(to)
									);

									_this.onStart({
										el: _this._el,
										from: from,
										to: to,
									});

									if (typeof options.onStart === "function") {
										options.onStart({
											el: _this._el,
											from: from,
											to: to,
										});
									}

									return raf();
								})
								.then(function () {
									if (!running) throw new Error("cancelled");

									_this._el.removeEventListener(
										_this.endEvent,
										_this.activeEventHandler
									);

									_this.activeEventHandler = function (e) {
										// Ignore any events bubbling up
										if (e.target !== _this._el || !running) return;

										_this._el.removeEventListener(
											_this.endEvent,
											_this.activeEventHandler
										);

										if (!hold) {
											_this._el.removeAttribute(_this.stateChangeAttribute);
										}

										resolve(to, e);
									};

									_this._el.addEventListener(
										_this.endEvent,
										_this.activeEventHandler
									);

									_this._el.setAttribute(_this.stateAttribute, to);

									_this._state = to;
								})
								["catch"](function (error) {
									// Only catch 'cancelled' errors.
									if (error.message !== "cancelled") throw error;
								});
						});
					},
					/**
					 * Remove any event listeners
					 */
				},
				{
					key: "unload",
					value: function unload() {
						this._el.removeEventListener(
							this.endEvent,
							this.activeEventHandler
						);

						this.activeEventHandler = null;
					},
				},
				{
					key: "el",
					get: function get() {
						return this._el;
					},
					/**
					 * Returns current state
					 *
					 * @return {String} Current state
					 */
				},
				{
					key: "state",
					get: function get() {
						return this._state;
					},
				},
			]);

			return Animation;
		})();

	function transition(options) {
		return new Animation(options);
	}

	class RecipientForm {
		constructor(el) {
			this.el = el;
			this.events = new index_es_EventHandler();
			this.recipientForm = this.el.querySelector("[data-recipient-form]");
			this.recipientFormInputs = this.el.querySelectorAll(
				"[data-recipient-form-input]"
			);
			this.recipientFormEmailInput = this.el.querySelector(
				"[data-recipient-form-email-input]"
			);
			this.disclosure = this.el.querySelector("[data-recipient-disclosure]");
			this.disclosureCheckbox = this.el.querySelector(
				"[data-recipient-disclosure-checkbox]"
			);
			this.checkmark = this.disclosure.querySelector(".checkmark");
			this.checkmarkCheck = this.disclosure.querySelector(".checkmark__check");
			this.fillAnimation = transition({
				el: this.checkmark,
			});
			this.checkAnimation = transition({
				el: this.checkmarkCheck,
			});
			this.events.register(this.recipientForm, "keydown", (event) =>
				this._onKeydown(event)
			);
			this.events.register(this.disclosure, "toggle", () => this._onToggle());
			this.events.register(this.disclosureCheckbox, "change", () =>
				this._onChange()
			);
		}

		_onChange() {
			this.disclosure.open = this.disclosureCheckbox.checked;
		}

		_onKeydown(event) {
			// Prevent input form submission
			if (
				event.key === "Enter" &&
				event.target.matches("[data-recipient-form-input]")
			) {
				event.preventDefault();
			}
		}

		_onToggle() {
			if (this.disclosure.open) {
				this._showRecipientForm();
			} else {
				this._hideRecipientForm();
			}
		}

		_showRecipientForm() {
			if (this.checkmark && this.checkmarkCheck) {
				this.fillAnimation.animateTo("checked");
				this.checkAnimation.animateTo("checked");
			}

			this.disclosureCheckbox.checked = true;
			this.recipientFormEmailInput.required = true;
		}

		_hideRecipientForm() {
			if (this.checkmark && this.checkmarkCheck) {
				this.fillAnimation.animateTo("unchecked");
				this.checkAnimation.animateTo("unchecked");
			}

			this.disclosureCheckbox.checked = false;
			this.recipientFormEmailInput.required = false;

			this._resetRecipientForm();
		}

		_resetRecipientForm() {
			this.recipientFormInputs.forEach((el) => {
				el.value = "";

				if (el.classList.contains("form-field-filled")) {
					el.classList.remove("form-field-filled");
				}
			});

			if (this.recipientForm.classList.contains("recipient-form--has-errors")) {
				this.recipientForm.classList.remove("recipient-form--has-errors");
			}
		}
	}

	/* harmony default export */ const pxs_gift_card_recipient_form_dist_index_es =
		RecipientForm; // CONCATENATED MODULE: ./source/scripts/sections/jsProduct.js

	class Product {
		static load(url) {
			return shopify_asyncview_dist_index_es.load(
				url, // template name
				{ view: "quickshop" } // view name (suffix)
			);
		}

		constructor($section) {
			// Add settings from schema to current object
			this._section = $section[0];
			this._data = window.PXUTheme.getSectionData($section);

			this.stickyOffset = 20;

			// Ensure product media libraries are present
			window.Shopify.loadFeatures(
				[
					{
						name: "shopify-xr",
						version: "1.0",
					},
					{
						name: "model-viewer-ui",
						version: "1.0",
					},
				],
				window.PXUTheme.productMedia.setupMedia
			);

			const priceUIEl = $section[0].querySelector("[data-price-ui]");
			const priceUIBadgeEl = $section[0].querySelector("[data-price-ui-badge]");
			const surfacePickUpEl = $section[0].querySelector(
				"[data-surface-pick-up]"
			);
			const complementaryProductsEl = $section[0].querySelector(
				"[data-complementary-products]"
			);
			const recipientFormEl = this._section.querySelector(
				"[data-recipient-form]"
			);
			const collapsibleRowEl = this._section.querySelector(
				"[data-collapsible-row]"
			);

			if (collapsibleRowEl) {
				window.PXUTheme.collapsibleRowUtil.init();
			}
			if (recipientFormEl) {
				this.recipientForm = new pxs_gift_card_recipient_form_dist_index_es(
					this._section
				);
			}

			this.variantSelection = $section[0].querySelector(
				"[data-variant-selection]"
			);

			if (this.variantSelection) {
				this.variantSelection.addEventListener("variant-change", (event) =>
					this._switchVariant(
						event.detail.product,
						event.detail.variant,
						event.detail.state
					)
				);

				if (surfacePickUpEl) {
					this.surfacePickUp = new shopify_surface_pick_up_dist_index_es(
						surfacePickUpEl
					);
					this.surfacePickUp.onModalRequest((contents) => {
						Promise.all([
							this.variantSelection.getProduct(),
							this.variantSelection.getVariant(),
						]).then(([product, variant]) => {
							const surfacePickUpModal = $section[0].querySelector(
								"[data-surface-pick-up-modal]"
							);
							const fragment = document.createDocumentFragment();
							const header = document.createElement("div");
							const title = document.createElement("span");
							const subtitle = document.createElement("span");

							header.classList.add("surface-pick-up__modal-header");
							title.classList.add("surface-pick-up__modal-title");
							subtitle.classList.add("surface-pick-up__modal-subtitle");

							title.innerHTML = product.title;
							subtitle.innerHTML = variant.title;

							header.appendChild(title);

							if (variant.title !== "Default Title") {
								header.appendChild(subtitle);
							}

							fragment.appendChild(header);

							surfacePickUpModal.innerHTML = contents;
							surfacePickUpModal.insertBefore(
								fragment,
								surfacePickUpModal.firstChild
							);
							$.fancybox.open(surfacePickUpModal, {
								hash: false,
								infobar: false,
								toolbar: false,
								loop: true,
								smallBtn: true,
								buttons: [
									// "zoom",
									// "share",
									// "slideShow",
									// "fullScreen",
									// "download",
									// "thumbs",
									// "close"
								],
								touch: false,
								video: {
									autoStart: false,
								},
								mobile: {
									preventCaptionOverlap: false,
									toolbar: true,
								},
								beforeShow: () => {
									document.body.style.top = `-${window.scrollY}px`;
									document.body.style.position = "fixed";
								},
								beforeClose: () => {
									const scrollY = document.body.style.top;
									document.body.style.position = "";
									document.body.style.top = "";
									window.scrollTo(0, parseInt(scrollY || 0, 10) * -1);
								},
							});
						});
					});
				}
			}

			if (priceUIEl) {
				this.priceUI = new PriceUI(priceUIEl);
			}

			if (priceUIBadgeEl) {
				this.priceUIBadge = new PriceUIBadge(priceUIBadgeEl);
			}

			this.$productGallery = $section.find(".product-gallery__main");
			const $stickyElement = $section.find(".sticky-product-scroll");

			if (this.$productGallery) {
				this.enableSlideshow(this.$productGallery);

				if (this._data.enable_zoom) {
					document.addEventListener("lazyloaded", this.enableZoom);
				}

				if (this._data.enable_product_lightbox) {
					this.enableLightbox(this.$productGallery);
				}
			}

			if (complementaryProductsEl) {
				this.complementaryProducts = new dist_index_es({
					sectionEl: this._section,
					sectionId: this._data.section_id,
					productId: this._data.product.id,
					productRecommendationsRoute:
						window.PXUTheme.routes.product_recommendations_url,
					includeIndicatorDots: true,
					limit: this._data.product_recommendation_limit,
					arrowShape:
						"M 95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46z",
				});
			}

			if (
				$stickyElement &&
				window.isScreenSizeLarge() &&
				this._data.template === "image-scroll"
			) {
				this.enableStickyScroll($stickyElement, this.$productGallery);
			}

			if (window.location.search === "?contact_posted=true") {
				$(".notify_form .contact-form").hide();
				$(".notify_form .contact-form")
					.prev(".message")
					.html(window.PXUTheme.translation.notify_form_success);
			}

			if ($(".masonry--true").length > 0) {
				window.PXUTheme.applyMasonry(".thumbnail");
			}

			if (this.variantSelection) {
				Promise.all([
					this.variantSelection.getProduct(),
					this.variantSelection.getVariant(),
					this.variantSelection.getState(),
				]).then(([product, variant, state]) =>
					this._switchVariant(product, variant, state)
				);
			}
		}

		enableStickyScroll($stickyElement, $productGallery) {
			let announcementHeight = 0;
			let headerHeight = 0;

			if (
				typeof window.PXUTheme.jsAnnouncementBar !== "undefined" &&
				window.PXUTheme.jsAnnouncementBar.enable_sticky
			) {
				announcementHeight = $("#announcement-bar").outerHeight();
			}

			if (window.PXUTheme.theme_settings.header_layout !== "vertical") {
				if (window.PXUTheme.jsHeader.enable_sticky) {
					headerHeight = $("#header").outerHeight();
				}
			}

			const productImages = $productGallery.data("media-count");

			// enable if more than 1 image is present

			if (productImages > 1) {
				$stickyElement.stick_in_parent({
					offset_top: announcementHeight + headerHeight + this.stickyOffset,
				});
			}
		}

		enableLightbox($productGallery) {
			$productGallery.find(".product-gallery__link").fancybox({
				beforeClose: (instance) => {
					const $instanceGallery = instance.$trigger
						.first()
						.parents(".product-gallery__main");
					$instanceGallery.hide();
					setTimeout(() => $instanceGallery.fadeIn(100), 500);
				},
				afterClose: () => {
					setTimeout(() => {
						$productGallery.find(".is-selected a").focus();
					}, 500);
				},
			});
		}

		enableZoom() {
			const $image = $(event.target);
			const zoomSrc = $image.data("zoom-src");
			if (zoomSrc) {
				$image
					.wrap('<span class="zoom-container"></span>')
					.css("display", "block")
					.parent()
					.zoom({
						url: zoomSrc,
						touch: false,
						magnify: 1,
					});
			}
		}

		disableSlideshow($section, selector) {
			let $slider;
			if ($section) {
				$slider = $section.find(".flickity-enabled");
			} else {
				$slider = $(selector);
			}

			this.$productGallery.flickity("destroy");
		}

		enableSlideshow(selector, settings) {
			// Define variables
			const $productGallery = selector;
			const $thumbnailProductGallery = $productGallery
				.closest(".product-gallery")
				.find(".product-gallery__thumbnails");

			const $slides = $productGallery.find(".product-gallery__image");
			const $thumbnails = $thumbnailProductGallery.find(
				".product-gallery__thumbnail"
			);

			function autoplayVideo(videoID, $slide) {
				// Compare id to player object and only play that video
				$.each(videoPlayers, (_, player) => {
					if (player.id === videoID) {
						player.play();

						// On fullscreen toggle, focus back on the slide itself
						player.on("exitfullscreen", () =>
							$slide
								.closest(".product-gallery")
								.find(".product-gallery__thumbnails")
								.focus()
						);
					}
				});
			}

			function autoplayYoutubeVideo(iframeID, $slide) {
				// compare id to player object and only play that video
				$.each(videoPlayers, (_, player) => {
					if (player.playing) {
						player.pause();
					}

					if (player.media.id === iframeID) {
						player.play();

						// On fullscreen toggle, focus back on the slide itself
						player.on("exitfullscreen", () =>
							$slide
								.closest(".product-gallery")
								.find(".product-gallery__thumbnails")
								.focus()
						);
					}
				});
			}

			function checkForVideos() {
				$slides.each((index, slide) => {
					// Variables
					const $slide = $(slide);
					const mediaType =
						$slide.data("media-type") ||
						$slide.find("[data-media-type]").data("media-type");
					let videoID = $slide.find("video").data("plyr-video-id");
					const $iframeVideo = $slide.find("iframe");
					const iframeID = $iframeVideo.attr("id");
					if ($slide.hasClass("is-selected")) {
						if (mediaType === "video") {
							videoID = $slide.find("video").data("plyr-video-id");
							if (videoID) {
								autoplayVideo(videoID, $slide);
							}
						} else if (mediaType === "external_video" && iframeID) {
							autoplayYoutubeVideo(iframeID, $slide);
						}
					}
				});
			}

			// Adds 'product-gallery__image' class if not present
			$productGallery
				.find(".gallery-cell:not(.product-gallery__image)")
				.addClass("product-gallery__image");

			// Adds 'product-gallery__thumbnail' class if not present
			$thumbnailProductGallery
				.find(".gallery-cell:not(.product-gallery__thumbnail)")
				.addClass("product-gallery__thumbnail");

			// If custom settings available, use them otherwise take settings from product templates
			const {
				thumbnails_enabled: thumbnailsEnabled,
				enable_thumbnail_slider: thumbnailsSliderEnabled,
				thumbnail_position: thumbnailsPosition,
				gallery_arrows: arrowsEnabled,
				slideshow_speed: slideshowSpeed,
				slideshow_transition: slideshowTransition,
			} = settings || this._data;

			$productGallery.on("ready.flickity", () => {
				$slides.each((index, slide) => {
					// Determine media type
					const mediaType =
						$(slide).data("media-type") ||
						$(slide).find("[data-media-type]").data("media-type");
					let videoID;
					const videoLooping = $("[data-video-loop]").data("video-loop");
					const { videoPlayers } = window;

					switch (mediaType) {
						case "external_video":
							videoID = $(slide)
								.find("[data-plyr-video-id]")
								.data("plyr-video-id");
							if (videoPlayers) {
								for (let i = 0; i < videoPlayers.length; i++) {
									if (
										videoPlayers[i].id === videoID ||
										videoPlayers[i].media.id === videoID
									) {
										videoPlayers[i].loop = videoLooping;

										if (!$(slide).hasClass("is-selected")) {
											videoPlayers[i].keyboard = {
												focused: false,
												global: false,
											};
										}
									}
								}
							}

							break;
						case "video":
							videoID = $(slide)
								.find("[data-plyr-video-id]")
								.data("plyr-video-id");
							if (videoPlayers) {
								for (let i = 0; i < videoPlayers.length; i++) {
									if (
										videoPlayers[i].id === videoID ||
										videoPlayers[i].media.id === videoID
									) {
										videoPlayers[i].loop = videoLooping;

										if (!$(slide).hasClass("is-selected")) {
											videoPlayers[i].keyboard = {
												focused: true,
												global: false,
											};
										}
									}
								}
							}

							break;
						case "model":
							if ($(slide).hasClass("is-selected")) {
								// When active slide
								if (mediaType === "model" && window.isScreenSizeLarge()) {
									$(slide).on("mouseenter", () =>
										$productGallery.flickity("unbindDrag")
									);
									$(slide).on("mouseleave", () =>
										$productGallery.flickity("bindDrag")
									);
								}
							}
							break;
						default:
							break;
					}

					// Detect keyboard 'ENTER' key on slides
					$(slide).keypress((event) => {
						if (event.which === 13) {
							// Bring focus to media inside selected slide
							$(slide)
								.find("model-viewer, .product-gallery__link, .plyr")
								.focus();
							// Run video autoplay logic if featured media is a video
							if (mediaType === "video" || mediaType === "external_video") {
								checkForVideos();
							}
							// Autoplay model if featured media is a model
							if (mediaType === "model") {
								// If model container has class is-selected then play the model
								// autoplayModel(); This method does not exist
							}
						}
					});
				});
			});

			this.$productGallery.flickity({
				wrapAround: true,
				adaptiveHeight: true,
				dragThreshold: 10,
				imagesLoaded: true,
				pageDots: false,
				prevNextButtons:
					$productGallery.data("media-count") > 1 || $slides.length > 1,
				autoPlay: slideshowSpeed * 1000,
				fade: slideshowTransition === "fade",
				watchCSS:
					this._data.template === "image-scroll" &&
					!$productGallery.hasClass("js-gallery-modal"), // Disables Flickity for main product gallery on image-scroll template
				arrowShape: window.arrowShape,
			});

			$productGallery.on("change.flickity", () => {
				$slides.each((index, slide) => {
					// Determine media type of current slide
					const mediaType =
						$(slide).data("media-type") ||
						$(slide).find("[data-media-type]").data("media-type");

					if ($(slide).hasClass("is-selected")) {
						// When active slide
						switch (mediaType) {
							case "model":
								/* On slide change, if active slide contains 3d model
								 * If on desktop, on hover, unbind flickity, after hover bind flickity
								 * On model play event, unbind flickity to ensure model can be interacted with
								 * On model pause event, bind flickity so that slide can be swiped
								 * Pause all model slides when hidden
								 */

								if (window.isScreenSizeLarge()) {
									// On mouseenter event, unbind flickity
									$(slide).on("mouseenter", () =>
										this.$productGallery.flickity("unbindDrag")
									);

									// On mouseleave event, bind flickity
									$(slide).on("mouseleave", () =>
										this.$productGallery.flickity("bindDrag")
									);
								}

								// Listen for model pause/play events
								$(slide)
									.find("model-viewer")
									.on("shopify_model_viewer_ui_toggle_play", () =>
										this.$productGallery.flickity("unbindDrag")
									);
								$(slide)
									.find("model-viewer")
									.on("shopify_model_viewer_ui_toggle_pause", () =>
										this.$productGallery.flickity("bindDrag")
									);

								break;
							default:
								this.$productGallery.flickity("bindDrag");
						}
					} else {
						// When inactive slide
						switch (mediaType) {
							case "external_video":
								// Youtube video pausing
								$.each(videoPlayers, (_, player) => player.pause());

								break;
							case "video":
								// HTML5 video pausing
								$.each(videoPlayers, (_, player) => player.pause());

								break;
							case "model":
								$.each(window.PXUTheme.productMedia.models, (_, model) =>
									model.pause()
								);
								break;
							default:
								break;
						}
					}
				});

				// Restore 3d model icons
				window.PXUTheme.productMedia.showModelIcon($productGallery);
			});

			// Checks for videos and plays them if they are the featured media
			// Autoplay logic only happens on desktop, autoplay set to off for mobile
			const $sliderArrows = $productGallery.find(".flickity-prev-next-button");

			if (($sliderArrows || $thumbnails) && window.isScreenSizeLarge()) {
				$sliderArrows.on("click", () => {
					$productGallery.on("settle.flickity", () => {
						// Find out media type of featured media slide
						const $selectedSlide = $productGallery.find(
							".product-gallery__image.is-selected"
						);
						const mediaType =
							$selectedSlide.data("media-type") ||
							$selectedSlide.find("[data-media-type]").data("media-type");
						const pId = $productGallery.data("product-id");

						// Run video autoplay logic if featured media is a video
						if (mediaType === "video" || mediaType === "external_video") {
							checkForVideos();
						}

						// Autoplay model if featured media is a model
						if (mediaType === "model") {
							// Sort models to get those in selected slide
							const sortedModels = [];

							$.each(window.PXUTheme.productMedia.models, (index, model) => {
								if (
									$(model.container)
										.closest(".product-gallery__image")
										.data("product-id") === pId
								) {
									sortedModels.push(model);
								}
							});

							// If model container has class is-selected then play the model
							$.each(sortedModels, (index, model) => {
								const $slide = $(model.container).parents(
									".product-gallery__image"
								);
								if ($slide.hasClass("is-selected")) {
									model.play();
								}
							});
						}

						$productGallery.off("settle.flickity");
					});

					return false;
				});

				$thumbnails.on("click", (event) => {
					const index = $(event.currentTarget).index();
					this.$productGallery.flickity("select", index);

					$productGallery.on("settle.flickity", () => {
						// Find out media type of featured media slide
						const $selectedSlide = $productGallery.find(
							".product-gallery__image.is-selected"
						);
						const mediaType =
							$selectedSlide.data("media-type") ||
							$selectedSlide.find("[data-media-type]").data("media-type");
						const pId = $productGallery.data("product-id");

						// Run video autoplay logic if featured media is a video
						if (mediaType === "video" || mediaType === "external_video") {
							checkForVideos();
						}

						// Autoplay model if featured media is a model
						if (mediaType === "model") {
							// Sort models to get those in selected slide
							const sortedModels = [];
							$.each(window.PXUTheme.productMedia.models, (_, model) => {
								if (
									$(model.container)
										.closest(".product-gallery__image")
										.data("product-id") === pId
								) {
									sortedModels.push(model);
								}
							});

							// If model container has class is-selected then play the model
							$.each(sortedModels, (_, model) => {
								const $slide = $(model.container).parents(
									".product-gallery__image"
								);
								if ($slide.hasClass("is-selected")) {
									model.play();
								}
							});
						}

						$productGallery.off("settle.flickity");
					});

					return false;
				});

				$thumbnails.keypress((event) => {
					const index = $(event.currentTarget).index();
					if (event.which === 13) {
						this.$productGallery.flickity("select", index);

						const $selectedSlide = $productGallery.find(
							".product-gallery__image.is-selected"
						);
						const pId = $productGallery.data("product-id");

						$productGallery.on("settle.flickity", () => {
							$selectedSlide.find("model-viewer, .plyr, a").focus();
							$selectedSlide.find("[data-youtube-video]").attr("tabindex", "0");
							$productGallery.off("settle.flickity");
						});

						// Find out media type of featured media slide
						const mediaType = $selectedSlide.data("media-type");

						// Run video autoplay logic if featured media is a video
						if (mediaType === "video" || mediaType === "external_video") {
							checkForVideos();
						}

						// Autoplay model if featured media is a model
						if (mediaType === "model") {
							// Sort models to get those in selected slide
							const sortedModels = [];
							$.each(window.PXUTheme.productMedia.models, (_, model) => {
								if (
									$(model.container)
										.closest(".product-gallery__image")
										.data("product-id") === pId
								) {
									sortedModels.push(model);
								}
							});

							// If model container has class is-selected then play the model
							$.each(sortedModels, (_, model) => {
								const $slide = $(model.container).parents(
									".product-gallery__image"
								);
								if ($slide.hasClass("is-selected")) {
									model.play();
								}
							});
						}
					}
				});
			} else if (thumbnailsEnabled) {
				// If thumbnail slider is disabled, ensure thumbnails can still navigate product images
				$thumbnailProductGallery
					.find(".product-gallery__thumbnail")
					.on("click", (event) => {
						const $currentTarget = $(event.currentTarget);
						const index = $currentTarget.index();
						this.$productGallery.flickity("selectCell", index);
					});
			}

			// Resize flickity when the slider is settled
			$productGallery.on("settle.flickity", () =>
				this.$productGallery.flickity("resize")
			);

			$(window).on("load", () => this.$productGallery.flickity("resize"));

			let resizeTimer;

			$(window).on("resize", () => {
				clearTimeout(resizeTimer);
				resizeTimer = setTimeout(
					() => this.$productGallery.flickity("resize"),
					250
				);
			});

			if (
				thumbnailsEnabled === true &&
				thumbnailsSliderEnabled === true &&
				$slides.length > 1
			) {
				// If desktop determine which slider we build
				if (window.isScreenSizeLarge()) {
					if (
						thumbnailsPosition === "right-thumbnails" ||
						thumbnailsPosition === "left-thumbnails"
					) {
						$thumbnailProductGallery.addClass("vertical-slider-enabled");

						const navCellHeight = $thumbnails.height();
						const navHeight = $thumbnailProductGallery.height();

						// Resize thumbnail gallery

						$(window).on("load", () => {
							const $productGalleryHeight = $productGallery.height();
							$thumbnailProductGallery.css("max-height", $productGalleryHeight);
						});

						$(window).on("resize", () => {
							this.$productGallery.flickity("resize");
							const $productGalleryHeight = $productGallery.height();
							$thumbnailProductGallery.css("max-height", $productGalleryHeight);
						});

						$productGallery.on("change.flickity", () => {
							this.$productGallery.flickity("resize");
							const $productGalleryHeight = $productGallery.height();
							$thumbnailProductGallery.css("max-height", $productGalleryHeight);
						});

						$productGallery.on("select.flickity", () => {
							// set selected nav cell
							const flkty = $productGallery.data("flickity");
							if (flkty) {
								$thumbnailProductGallery
									.find(".is-nav-selected")
									.removeClass("is-nav-selected");
								const $selected = $thumbnails
									.eq(flkty.selectedIndex)
									.addClass("is-nav-selected");

								// scroll nav
								const scrollY =
									$selected.position().top +
									$thumbnailProductGallery.scrollTop() -
									(navHeight + navCellHeight) / 2;
								$thumbnailProductGallery.animate({
									scrollTop: scrollY,
								});
							}
						});
					} else {
						$thumbnailProductGallery.flickity({
							cellAlign: "center",
							contain: true,
							groupCells: "80%",
							imagesLoaded: true,
							pageDots: false,
							prevNextButtons: $thumbnails.length > 5 ? arrowsEnabled : false,
							asNavFor:
								this._data.template === "image-scroll" &&
								window.isScreenSizeLarge()
									? ""
									: $productGallery[0],
							arrowShape: window.arrowShape,
						});

						// Resize flickity when the slider is settled
						$thumbnailProductGallery.on("settle.flickity", () =>
							$thumbnailProductGallery.flickity("resize")
						);
						$(window).on("load", () =>
							$thumbnailProductGallery.flickity("resize")
						);
					}
				} else {
					// Otherwise create standard thumbnail slider
					$thumbnailProductGallery.flickity({
						cellAlign: "center",
						contain: true,
						groupCells: "80%",
						imagesLoaded: true,
						pageDots: false,
						prevNextButtons: $thumbnails.length > 5,
						asNavFor:
							this._data.template === "image-scroll" &&
							window.isScreenSizeLarge()
								? ""
								: $productGallery[0],
						arrowShape: window.arrowShape,
					});
				}
			}
		}

		filterGalleryByVariant(variantId) {
			if (!this._data.variant_media_map || !variantId) {
				// Show all images if no mapping exists
				this.showAllGalleryImages();
				return;
			}

			const variantMediaIds = this._data.variant_media_map[variantId];

			// If variant has no specific media assigned, show all images
			if (!variantMediaIds || variantMediaIds.length === 0) {
				this.showAllGalleryImages();
				return;
			}

			const $productGallery = this.$productGallery;
			const $thumbnailGallery = $productGallery
				.closest(".product-gallery")
				.find(".product-gallery__thumbnails");

			// Get all gallery cells
			const $allCells = $productGallery.find(".product-gallery__image");
			const $allThumbnails = $thumbnailGallery.find(
				".product-gallery__thumbnail"
			);

			// Track the first visible cell index
			let firstVisibleIndex = -1;

			// Hide all cells first
			$allCells.each((index, cell) => {
				const $cell = $(cell);
				const mediaId = $cell.data("media-id");

				if (variantMediaIds.includes(mediaId)) {
					$cell.show();
					if (firstVisibleIndex === -1) {
						firstVisibleIndex = index;
					}
				} else {
					$cell.hide();
				}
			});

			// Update thumbnails
			$allThumbnails.each((index, thumb) => {
				const $thumb = $(thumb);
				const mediaId = $thumb.data("media-id");

				if (variantMediaIds.includes(mediaId)) {
					$thumb.show();
				} else {
					$thumb.hide();
				}
			});

			// Refresh Flickity galleries
			if ($productGallery.data("flickity")) {
				$productGallery.flickity("reloadCells");
				$productGallery.flickity("resize");

				// Select the first visible slide and force it to load
				if (firstVisibleIndex >= 0) {
					$productGallery.flickity("select", firstVisibleIndex, false, true);

					// Trigger lazy load on the selected image
					const $selectedSlide = $productGallery
						.find(".product-gallery__image")
						.eq(firstVisibleIndex);
					const $lazyImage = $selectedSlide.find("img.lazyload");

					if ($lazyImage.length && window.lazySizes) {
						window.lazySizes.loader.unveil($lazyImage[0]);
					}
				}
			}

			if ($thumbnailGallery.data("flickity")) {
				$thumbnailGallery.flickity("reloadCells");
				$thumbnailGallery.flickity("resize");
			}
		}

		showAllGalleryImages() {
			const $productGallery = this.$productGallery;
			const $thumbnailGallery = $productGallery
				.closest(".product-gallery")
				.find(".product-gallery__thumbnails");

			// Show all cells
			$productGallery.find(".product-gallery__image").show();
			$thumbnailGallery.find(".product-gallery__thumbnail").show();

			// Refresh Flickity galleries
			if ($productGallery.data("flickity")) {
				$productGallery.flickity("reloadCells");
				$productGallery.flickity("resize");
			}

			if ($thumbnailGallery.data("flickity")) {
				$thumbnailGallery.flickity("reloadCells");
				$thumbnailGallery.flickity("resize");
			}
		}

		scrollSelectedImage(variant) {
			let headerHeight = 0;
			let announceHeight = 0;

			// Get header height is sticky enabled
			if (
				window.PXUTheme.jsHeader.enable_sticky === true &&
				window.PXUTheme.theme_settings.header_layout !== "vertical"
			) {
				headerHeight = window.PXUTheme.jsHeader.getHeaderHeight();
			}

			// Get announcement height is sticky enabled
			if (
				typeof window.PXUTheme.jsAnnouncementBar !== "undefined" &&
				window.PXUTheme.jsAnnouncementBar.enable_sticky === true &&
				window.PXUTheme.theme_settings.header_layout !== "vertical"
			) {
				announceHeight =
					window.PXUTheme.jsAnnouncementBar.getAnnouncementHeight();
			}

			// Add values
			const totalHeight = headerHeight + announceHeight + this.stickyOffset;

			window.PXUTheme.scrollToTop($(`[data-index="${variant}"]`), totalHeight);
		}

		updateStockDisplay(variant) {
			const stockDisplayEl = this._section.querySelector(
				"[data-product-stock]"
			);

			if (!stockDisplayEl) return;

			// Get inventory data from the map
			const inventoryData = this._data.variant_inventory_map?.[variant.id];

			if (!inventoryData) {
				stockDisplayEl.style.display = "none";
				return;
			}

			// Check if product has dealer-exclusive tag
			const isDealerExclusive =
				this._data.product.tags &&
				this._data.product.tags.includes("dealer-exclusive");

			if (isDealerExclusive) {
				stockDisplayEl.style.display = "none";
				return;
			}

			// Only show stock if inventory is managed by Shopify and policy is deny
			if (
				inventoryData.inventory_management !== "shopify" ||
				inventoryData.inventory_policy !== "deny"
			) {
				stockDisplayEl.style.display = "none";
				return;
			}

			stockDisplayEl.style.display = "block";

			const inventory = inventoryData.inventory_quantity;
			let statusHTML = "";

			if (inventory > 10) {
				statusHTML =
					'<span class="stock-status stock-status--in-stock">In Stock</span>';
			} else if (inventory > 0 && inventory <= 10) {
				statusHTML = `<span class="stock-status stock-status--low-stock">Only ${inventory} left in stock</span>`;
			} else {
				statusHTML =
					'<span class="stock-status stock-status--out-of-stock">Out of Stock</span>';
			}

			stockDisplayEl.innerHTML = statusHTML;
		}

		unload($section) {
			$(".selector-wrapper select", $section).unwrap();
			this.disableSlideshow($section);
			$("[data-variant-selector]").off();
			document.removeEventListener("lazyloaded", this.enableZoom);

			const collapsibleRowEl = this._section.querySelector(
				"[data-collapsible-row]"
			);
			if (collapsibleRowEl) {
				window.PXUTheme.collapsibleRowUtil.unload();
			}
		}

		_switchVariant(product, variant, state) {
			console.log('_switchVariant called:', { variant, state });
			if (variant && variant.id) {
				this.filterGalleryByVariant(variant.id);
			}

			window.selectCallback(
				this._section.querySelector(`.product-${product.id}`),
				product,
				variant,
				state
			);

			if (this.priceUI) {
				const formatter = (price) =>
					price === 0
						? window.PXUTheme.translation.free_price_text
						: Shopify.formatMoney(price, $("body").data("money-format"));

				this.priceUI.load(product, {
					variant,
					formatter,
					handler: (priceUIFragment, p, { variant: v }) => {
						if (state === "unavailable") {
							return document.createDocumentFragment();
						}

						if (v && v.available) {
							const shopPayInstallmentsTemplate = this._section.querySelector(
								"[data-shop-pay-installments-template] shopify-payment-terms"
							);
							let shopPayInstallEl = null;

							if (shopPayInstallmentsTemplate) {
								shopPayInstallEl = shopPayInstallmentsTemplate.cloneNode(true);
								shopPayInstallEl.setAttribute("variant-id", variant.id);
							}

							if (this._data.display_savings && v.compare_at_price > v.price) {
								const span = document.createElement("span");

								span.classList.add("sale", "savings");
								// span.innerHTML = `${window.PXUTheme.translation.product_savings} ${Math.round(parseFloat(((v.compare_at_price - v.price) * 100) / v.compare_at_price, 10))}% (<span class="money">${formatter(v.compare_at_price - v.price)}</span>)`;
								span.innerHTML = `${
									window.PXUTheme.translation.product_savings
								} ${Math.round(
									parseFloat(
										((v.compare_at_price - v.price) * 100) / v.compare_at_price,
										10
									)
								)}%`;
								priceUIFragment.appendChild(span);
							}

							if (shopPayInstallEl) {
								priceUIFragment.appendChild(shopPayInstallEl);
							}
						}

						// Convert all elements if currency converter is enabled
						if (window.PXUTheme.currencyConverter) {
							const moneyEls = priceUIFragment.querySelectorAll(".money");

							for (let i = 0; i < moneyEls.length; i++) {
								window.PXUTheme.currencyConverter.update(moneyEls[i]);
							}
						}

						return priceUIFragment;
					},
				});
			}

			if (this.priceUIBadge) {
				this.priceUIBadge.load(product, {
					variant,
					formatter: (price) => price,
					style: "",
					handler: () => {
						const fragment = document.createDocumentFragment();
						const sticker = this.priceUIBadge._el.parentNode;
						const stickerText = document.createElement("span");

						stickerText.classList.add("thumbnail-sticker__text");

						let text;

						if (variant && variant.available) {
							if (variant.compare_at_price > variant.price) {
								sticker.classList.remove("thumbnail-sticker--hidden");
								if (sticker.classList.contains("thumbnail-sticker--sold-out")) {
									sticker.classList.replace(
										"thumbnail-sticker--sold-out",
										"thumbnail-sticker--sale"
									);
								} else {
									sticker.classList.add("thumbnail-sticker--sale");
								}
								text = window.PXUTheme.translation.sale;
							} else {
								sticker.classList.add("thumbnail-sticker--hidden");
								text = "";
							}
						} else if (variant && !variant.available) {
							sticker.classList.remove("thumbnail-sticker--hidden");
							if (sticker.classList.contains("thumbnail-sticker--sale")) {
								sticker.classList.replace(
									"thumbnail-sticker--sale",
									"thumbnail-sticker--sold-out"
								);
							} else {
								sticker.classList.add("thumbnail-sticker--sold-out");
							}
							text = window.PXUTheme.translation.sold_out;
						}

						stickerText.innerHTML = text;
						fragment.appendChild(stickerText);
						return fragment;
					},
				});
			}

			if (this.surfacePickUp) {
				this.surfacePickUp.load(variant ? variant.id : null);
			}

			if (variant) {
				this.updateStockDisplay(variant);
			}

			if (
				this._section.classList.contains("product-template") &&
				product.variants.length > 1 &&
				!window.Shopify.designMode
			) {
				this._updateHistory(variant);
			}

			if (
				this._section.classList.contains("product-template") &&
				product.variants.length > 1 &&
				!window.Shopify.designMode
			) {
				this._updateHistory(variant);
			}

			// Using variant.featured_media and not variant.featured_image to account for positions of
			// non-image media such as videos too.
			if (this._data.template === "image-scroll" && variant.featured_media) {
				const imagePosition = variant.featured_media.position - 1;
				this.scrollSelectedImage(imagePosition);
			}
		}

		_updateHistory(variant) {
			const url = new URL(window.location);
			if (variant.id) url.searchParams.set("variant", variant.id);
			window.history.replaceState({}, "", url);
		}
	}

	window.PXUTheme.jsProductClass = Product;
	window.PXUTheme.jsProduct = {
		init($section) {
			this.product = new Product($section);
			return this.product;
		},
		unload($section) {
			if (this.product) {
				this.product.unload($section);
				this.product = null;
			}
		},
		relatedProducts() {
			$(".js-related-products-slider .products-slider").each((_, slider) => {
				const $relatedSlider = $(slider);

				const slideData = {
					products_per_slide: $relatedSlider.data("products-per-slide"),
					products_available: $relatedSlider.data("products-available"),
					products_limit: $relatedSlider.data("products-limit"),
					initialIndex: 0,
					cellAlign: "left",
					wrapAround: true,
				};

				if (
					slideData.products_available > slideData.products_per_slide &&
					slideData.products_limit > slideData.products_per_slide
				) {
					slideData.wrapAround = true;
				} else {
					slideData.wrapAround = false;
				}

				if (
					slideData.products_available < slideData.products_per_slide ||
					slideData.products_limit < slideData.products_per_slide
				) {
					$relatedSlider.addClass("container is-justify-center");
					$relatedSlider.find(".gallery-cell").addClass("column");
				} else {
					$relatedSlider.flickity({
						lazyLoad: 2,
						freeScroll: true,
						imagesLoaded: true,
						draggable: true,
						cellAlign: "center",
						wrapAround: slideData.wrapAround,
						pageDots: false,
						contain: true,
						prevNextButtons:
							slideData.products_limit > slideData.products_per_slide,
						initialIndex: slideData.initialIndex,
						arrowShape: window.arrowShape,
					});

					// Resize flickity when the slider is settled
					$relatedSlider.on("settle.flickity", () =>
						$relatedSlider.flickity("resize")
					);

					$(window).on("load", () => $relatedSlider.flickity("resize"));
				}
			});
		},
	};

	/******/
})();
